<template>
  <div>
    <svg
      class="clickable"
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      width="504px"
      height="179px"
      viewBox="0 0 504 179"
      enable-background="new 0 0 504 179"
      xml:space="preserve"
      style="max-height:200px;"
    >
      <g>
        <g>
          <path
            fill="#D9D9D9"
            d="M10.976,88.507v22.118c0,5.424,2.189,10.624,6.036,14.436c1.235,1.224,2.447,2.412,3.659,3.589
			c6.577,0.341,10.836,0.588,17.73,2.412l34.12,26.695l-17.648,0.941c0.012,0,0.012,0,0.023,0.012l-2.447,2.447
			c-0.471,0.471-0.612,1.189-0.329,1.8c0.2,0.471,0.635,0.812,1.141,0.895c51.108,8.977,88.369,13.436,152.137,13.683
			c30.237,0.035,55.309-2.765,81.875-11.119l-1.153,0.071c-1.659,0.094-1.753-0.353-0.223-0.988
			c29.59-12.483,52.226-24.107,77.485-39.261c2.895-1.73,6.153-2.788,9.519-3.118l3.965-0.388l0.494-0.047
			c2.259-0.188,4.482-0.389,6.694-0.6c74.063-7.118,121.418-25.813,118.019-64.298c-0.047-0.529-0.506-0.941-1.036-0.941h-3.764
			l-0.189-10.989l3.942-7.883c1.576-3.164-0.542-6.929-4.071-7.2l-41.308-3.247l-3.671-0.294l-0.694-0.024
			c1.235,4.553,2.188,9.26,2.188,14.236c0,24.966-20.389,45.203-45.555,45.203c-25.154,0-45.544-20.237-45.544-45.203
			c0-6.094,0.494-11,0.941-16.624l-0.623-0.012l-3.178,0.012l-225.988,1.129l-3.424,0.012l-0.706,0.047
			c0.494,4.565,0.612,9.271,0.612,14.26c0,24.966-19.883,45.202-44.414,45.202c-24.531,0-44.414-20.236-44.414-45.202
			c0-3.012,0.118-5.73,0.282-8.389l-4.059,0.494l-15.189,1.847c-2.718,0.33-5.282,1.483-7.341,3.283l-6.424,5.977
			c-2.789,2.447-4.695,5.953-4.895,9.565C2.658,68.964,3.317,79.777,10.976,88.507 M99.334,154.264
			c0.294-3.259,1.024-11.554,1.341-15.224c0.118-1.283,0.435-2.542,1.024-3.683c1.906-3.682,4.623-5.989,9.483-7.53
			c2.541-0.812,5.212-1.188,7.871-1.259c91.616-2.364,159.583-6.976,233.53-14.2c-1.283,3.776-2.483,6.647-4.118,9.588
			c-2.306,4.118-5.553,7.66-9.436,10.354c-24.99,17.365-43.944,26.707-72.264,34.343c-5.518,1.494-11.177,2.435-16.87,2.882
			c-53.238,4.154-85.84,2.389-140.608-4.541c-1.6-0.2-3.188-0.588-4.659-1.271c-2.964-1.353-4.517-3.153-5.165-6.424
			C99.263,156.298,99.252,155.275,99.334,154.264"
          />
          <path
            d="M115.248,42.204c0-16.029-12.994-29.023-29.023-29.023c-16.028,0-29.022,12.994-29.022,29.023
			c0,16.029,12.994,29.023,29.022,29.023C102.253,71.227,115.248,58.233,115.248,42.204"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_1_"
              d="M78.819,24.303c-0.485,0.2-0.959,0.419-1.419,0.654c-1.005,0.512-1.95,1.105-2.829,1.766
				c-0.778,0.587-1.506,1.227-2.178,1.914c-0.398,0.405-0.776,0.827-1.135,1.264c-0.009,0.012-0.019,0.024-0.029,0.036
				c-0.005,0.006-0.01,0.012-0.015,0.019c-0.167,0.205-0.33,0.414-0.488,0.625c-0.24,0.32-0.469,0.647-0.687,0.979
				c-0.008,0.013-0.017,0.025-0.025,0.037c-0.005,0.008-0.01,0.016-0.015,0.024c-0.436,0.67-0.83,1.365-1.181,2.083
				c-0.49,1.003-0.894,2.05-1.206,3.126c-0.24,0.827-0.426,1.673-0.553,2.532c-0.128,0.859-0.199,1.73-0.209,2.608
				c-0.013,1.006,0.055,2.022,0.205,3.039c0.15,1.018,0.383,2.037,0.704,3.049c0.324,1.02,0.723,1.994,1.192,2.919
				c0.468,0.925,1.004,1.799,1.6,2.619c0.595,0.82,1.25,1.584,1.956,2.291c0.002,0.003,0.005,0.005,0.007,0.008
				c0.707,0.706,1.464,1.354,2.265,1.939c0.803,0.587,1.648,1.11,2.528,1.567c0.88,0.457,1.795,0.845,2.737,1.163
				c0.941,0.319,1.91,0.565,2.895,0.735c0.987,0.171,1.991,0.266,3.004,0.28c1.015,0.015,2.039-0.051,3.064-0.201
				c0.382-0.056,0.765-0.124,1.147-0.203c0.004-0.001,0.007-0.002,0.011-0.003c0.002,0,0.004,0,0.006-0.001
				c3.142-0.661,6.24-2.163,8.715-4.299c0.354-0.306,0.696-0.624,1.025-0.954c0.709-0.707,1.358-1.466,1.944-2.268
				c0.587-0.802,1.11-1.648,1.567-2.528s0.845-1.795,1.163-2.737c0.028-0.082,0.055-0.165,0.082-0.248
				c0.003-0.009,0.006-0.017,0.009-0.026c0.003-0.009,0.006-0.019,0.009-0.028c0.015-0.048,0.03-0.096,0.045-0.144
				c0.085-0.274,0.164-0.55,0.238-0.829c0.001-0.004,0.002-0.008,0.003-0.011c0.006-0.022,0.011-0.044,0.017-0.066
				c0.131-0.509,0.242-1.023,0.332-1.543c0.17-0.986,0.265-1.991,0.28-3.005c0.015-1.014-0.051-2.038-0.201-3.063
				c-0.151-1.026-0.385-2.053-0.708-3.071c-0.317-1.001-0.708-1.958-1.164-2.867c-0.458-0.908-0.98-1.768-1.56-2.578
				c-0.598-0.834-1.258-1.612-1.971-2.331c-0.712-0.72-1.479-1.379-2.289-1.974c-0.815-0.6-1.676-1.134-2.575-1.599
				c-0.897-0.465-1.83-0.859-2.791-1.18c-0.881-0.294-1.785-0.526-2.706-0.691c-0.343-0.061-0.688-0.114-1.035-0.157
				c-0.009-0.001-0.019-0.002-0.029-0.004c-0.015-0.001-0.03-0.003-0.046-0.005c-0.018-0.002-0.036-0.005-0.054-0.007
				c-0.007,0-0.014-0.001-0.02-0.002c-0.052-0.006-0.103-0.012-0.154-0.017c-0.661-0.071-1.328-0.106-1.995-0.106
				C83.734,22.833,81.146,23.349,78.819,24.303"
            />
          </defs>
          <clipPath id="SVGIDB_2_">
            <use xlink:href="#SVGIDB_1_" overflow="visible" />
          </clipPath>
          <g clip-path="url(#SVGIDB_2_)">
            <g>
              <defs>
                <rect
                  id="SVGIDB_3_"
                  x="66.837"
                  y="22.833"
                  width="38.778"
                  height="38.761"
                />
              </defs>
              <clipPath id="SVGIDB_4_">
                <use xlink:href="#SVGIDB_3_" overflow="visible" />
              </clipPath>
              <g
                transform="matrix(1 0 0 1 2.226952e-006 3.134010e-007)"
                clip-path="url(#SVGIDB_4_)"
              >
                <image
                  overflow="visible"
                  width="81"
                  height="81"
                  xlink:href="data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAlgCWAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA
EAMCAwYAAAISAAADcwAABVb/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX
Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa
JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAFMAUwMBIgACEQEDEQH/
xACTAAACAwEBAQAAAAAAAAAAAAAABAMFBgIBBwEBAAAAAAAAAAAAAAAAAAAAABAAAgMAAQMEAwEA
AAAAAAAAAwQBAgUAERITECBQBjEjFBURAAEDAgMFBAkFAQAAAAAAAAEAEQIhAzFBElFhcRMEEIEi
MiCRobHBQqIjFNFywjNDYxIBAAAAAAAAAAAAAAAAAAAAUP/aAAwDAQACEQMRAAAA+gAsSxY26Gaa
4zprZV84bP3NaQ9AOFK9I6Q0VYWdDZQDlEzdnNihWGpEQrqvSLmfcdWPOufSaDqQUnckOCcKmp2C
hUWbGdLDxyvJJlZCv41SRwX4epPeGHdccF6awqjS5bXVZ5ok3wAAAOAM9WAatsD0AAD/2gAIAQIA
AQUA+E//2gAIAQMAAQUA+E//2gAIAQEAAQUA9DHCCo3KF5ouNigezqWMkya44fX7/wA+x5v+ULLb
RWcpnujVp1ErXq1WYCtpNTe+HpMi5ExMcJeo6XijEaebPET2AZiYMnmj73tdqAiWXu0VNCoqiJWJ
59i0JDdXV7eBcAzXUy7V5kM+dfIHFXD+XScUSEoM746cNrzW/wDp06a2dZpu2OeJhd8Fl9c4efpo
fx34I6aAyn0WOVzDEkeXWvP547GWxjLOkCOE2lqzfaFebReazaa8u2ZWabC1uUfBblWhW55qdPsc
lC5WjBZUx7lnwp5okrEfaSrDgUHoiWsYRIKowGasGpPjL49RGrgVs+lIZaEsM5yvHgUKZ2EToxtK
SMuXpz0uELFYx6kY7a+mha4Rut3LfHT622L9oMm/ad4MGAallzZjtySOvbX0tWLQ59biCpLyGmyT
rGfboUMwQLOOdombkr59Pbf8bHj6IdnmT7fH7P/aAAgBAgIGPwAT/9oACAEDAgY/ABP/2gAIAQEB
Bj8A7NV2QiN6+3htKJtz0cAPitJ6gtsaP6ISuHVvWichCWT4Hv8ARMojVcPljv3o3OokZS9g4BAO
iQm3p9yMQULN57lk4E4xTjA9hnIsAnNSUZRCEJUqtQ2IjYVoBqy1HB0DILlvw7LXTxz8c/gg5WmT
VXPs1atFOxLzAYK/cOFt3KMYVgDihqbUmdAwqQXCdqfj/ke3Tp9alcIwAiOAR0ugYglaOptkxzcK
PXdFIGH+1oYgZllfs2DW/cczwEbbAv7VyrH3buZAeqJjHRE7cU92RJWC0/8ALl92vUpROIRwVQCt
NuwLhOTLnXLFvpo/Ka65E5ARITSYPLQTLyiTAgSZkBe6aIA+aGBVYsdioqFPufudlGUfLci4O8Yq
joG5gtcgDMYI9Xe/qtOYRyXWWpYykZR4o9H1g1AUBK5ljPYqOqpq6vw+Z38zV7kC3jtl48MwgZBE
RYFaHo6IFCQpjaVzoUOKFuZ9acM5UQR4AXlwCwGDYZbOwziPDm2S0goSIWgbF3p9ycbVGEXMjRlX
zZ9pjIODQgrndKXiam0cv2rxBiNqI7G3JrcWGcjQLw+O6fNcPuHpZd6l/X9boeT60G0dz/y9H//Z"
                  transform="matrix(0.48 0 0 0.48 66.8369 22.833)"
                ></image>
              </g>
            </g>
          </g>
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_5_"
              d="M72.63,42.204c0,7.509,6.086,13.595,13.595,13.595c7.509,0,13.595-6.086,13.595-13.595
				c0-7.509-6.086-13.595-13.595-13.595C78.716,28.609,72.63,34.695,72.63,42.204"
            />
          </defs>
          <clipPath id="SVGIDB_6_">
            <use xlink:href="#SVGIDB_5_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_7_"
            cx="-156"
            cy="571.001"
            r="1"
            gradientTransform="matrix(13.5951 0 0 13.5951 2207.0615 -7720.5996)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#1A1A1A" />
            <stop offset="0.8368" style="stop-color:#1A1A1A" />
            <stop offset="1" style="stop-color:#4E4D4D" />
          </radialGradient>
          <rect
            x="72.63"
            y="28.609"
            clip-path="url(#SVGIDB_6_)"
            fill="url(#SVGIDB_7_)"
            width="27.19"
            height="27.19"
          />
        </g>
        <g>
          <g>
            <g>
              <defs>
                <rect
                  id="SVGIDB_8_"
                  x="66.848"
                  y="22.828"
                  width="38.754"
                  height="38.735"
                />
              </defs>
              <clipPath id="SVGIDB_9_">
                <use xlink:href="#SVGIDB_8_" overflow="visible" />
              </clipPath>
              <g clip-path="url(#SVGIDB_9_)">
                <defs>
                  <path
                    id="SVGIDB_10_"
                    d="M105.602,42.195c0-10.696-8.675-19.367-19.377-19.367c-10.701,0-19.377,8.671-19.377,19.367
							c0,10.697,8.676,19.368,19.377,19.368C96.927,61.563,105.602,52.892,105.602,42.195"
                  />
                </defs>
                <clipPath id="SVGIDB_11_">
                  <use xlink:href="#SVGIDB_10_" overflow="visible" />
                </clipPath>

                <radialGradient
                  id="SVGIDB_12_"
                  cx="-156"
                  cy="571.001"
                  r="1"
                  gradientTransform="matrix(19.377 0 0 19.3673 3109.0364 -11016.5664)"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop offset="0" style="stop-color:#FFFFFF" />
                  <stop offset="0.5732" style="stop-color:#FFFFFF" />
                  <stop offset="0.7573" style="stop-color:#808080" />
                  <stop offset="1" style="stop-color:#676767" />
                </radialGradient>
                <rect
                  x="66.848"
                  y="22.828"
                  clip-path="url(#SVGIDB_11_)"
                  fill="url(#SVGIDB_12_)"
                  width="38.754"
                  height="38.735"
                />
              </g>
            </g>
          </g>
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_13_"
              d="M105.337,34.436l-5.05,1.147c-0.814,0.162-1.4,0.876-1.4,1.705c0.381,3.847,0.669,6.287,0,9.85
				c0,0.819,0.579,1.524,1.382,1.684l5.053,1.146c0.322,0.073,0.656-0.099,0.772-0.409c0.851-2.286,1.317-4.766,1.317-7.351
				c0-2.591-0.468-5.076-1.324-7.373c-0.094-0.255-0.341-0.415-0.606-0.415C105.433,34.42,105.385,34.425,105.337,34.436"
            />
          </defs>
          <clipPath id="SVGIDB_14_">
            <use xlink:href="#SVGIDB_13_" overflow="visible" />
          </clipPath>

          <linearGradient
            id="SVGIDB_15_"
            gradientUnits="userSpaceOnUse"
            x1="-156.0005"
            y1="571"
            x2="-155.0005"
            y2="571"
            gradientTransform="matrix(0 15.565 -15.565 0 8990.7734 2462.5598)"
          >
            <stop offset="0" style="stop-color:#0E0405" />
            <stop offset="0.5021" style="stop-color:#681418" />
            <stop offset="1" style="stop-color:#0E0405" />
          </linearGradient>
          <rect
            x="98.887"
            y="34.42"
            clip-path="url(#SVGIDB_14_)"
            fill="url(#SVGIDB_15_)"
            width="8.524"
            height="15.621"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_16_"
              d="M63.525,42.201c0-12.538,10.167-22.697,22.696-22.697c12.537,0,22.704,10.159,22.704,22.697
				c0,12.536-10.167,22.695-22.704,22.695C73.692,64.896,63.525,54.737,63.525,42.201 M58.427,42.201
				c0,15.349,12.444,27.801,27.794,27.801c15.358,0,27.802-12.452,27.802-27.801c0-15.351-12.444-27.795-27.802-27.795
				C70.871,14.406,58.427,26.85,58.427,42.201"
            />
          </defs>
          <clipPath id="SVGIDB_17_">
            <use xlink:href="#SVGIDB_16_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_18_"
            cx="-156.0005"
            cy="571"
            r="1"
            gradientTransform="matrix(27.7983 0 0 27.7983 4422.75 -15830.6172)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#878787" />
            <stop offset="0.8536" style="stop-color:#878787" />
            <stop offset="1" style="stop-color:#F0F0F0" />
          </radialGradient>
          <rect
            x="58.427"
            y="14.406"
            :style="rearWheelClass"
            v-on:click="changeSeverity('rearWheel')"
            clip-path="url(#SVGIDB_17_)"
            fill="url(#SVGIDB_18_)"
            width="55.596"
            height="55.596"
          />
        </g>
        <g>
          <path
            fill="#4D4D4D"
            d="M95.507,48.639l9.794,5.875l-6.749,6.754l-5.902-9.826c-1.705-1.216-3.853-0.325-4.415,1.88l2.822,11.06
			l-9.652,0.001l2.829-11.132c-0.356-2.054-2.5-2.935-4.452-1.773L73.91,61.27l-6.754-6.753l9.854-5.923
			c1.196-1.702,0.307-3.835-1.889-4.396l-11.088,2.776v-9.545l11.147,2.77c2.053-0.35,2.938-2.483,1.793-4.432l-9.815-5.882
			l6.749-6.749l5.909,9.817c1.698,1.222,3.838,0.346,4.416-1.838l-2.78-11.104l9.502-0.043l-2.722,11.134
			c0.327,2.077,2.465,2.979,4.422,1.843l5.887-9.809l6.75,6.749l-9.793,5.875c-1.241,1.702-0.363,3.856,1.831,4.435l11.087-2.765
			v9.545l-11.088-2.778C95.251,44.531,94.353,46.679,95.507,48.639"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_19_"
              d="M81.486,19.904l2.76,11.292c-0.572,2.168-2.697,3.039-4.383,1.825l-6.055-9.936
				c-0.038,0.029-6.674,6.668-6.701,6.7l9.935,6.029c1.136,1.935,0.258,4.052-1.781,4.399l-11.334-2.75
				c-0.006,0.046-0.006,9.431,0,9.477l11.276-2.757c2.18,0.556,3.062,2.674,1.874,4.363l-9.972,6.071
				c0.027,0.035,6.668,6.673,6.706,6.704l6.019-9.911c1.937-1.155,4.065-0.28,4.419,1.76l-2.808,11.319
				c0.043,0.004,9.535,0.003,9.581,0L88.22,53.24c0.557-2.189,2.69-3.073,4.382-1.867l6.048,9.946
				c0.037-0.03,6.674-6.671,6.702-6.706l-9.914-6.022c-1.144-1.945-0.253-4.078,1.809-4.409l11.275,2.758
				c0.004-0.043,0.005-9.429,0-9.476l-11.275,2.745c-2.179-0.574-3.05-2.713-1.818-4.402l9.913-6.021
				c-0.031-0.036-6.665-6.674-6.701-6.701l-6.034,9.927c-1.943,1.127-4.065,0.233-4.389-1.828l2.703-11.322
				c-0.002-0.001-0.02-0.001-0.054-0.001C90.098,19.861,81.529,19.899,81.486,19.904"
            />
          </defs>
          <clipPath id="SVGIDB_20_">
            <use xlink:href="#SVGIDB_19_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_21_"
            cx="-156.001"
            cy="571"
            r="1.0005"
            gradientTransform="matrix(22.7058 0.3206 -0.3206 -22.0646 3811.4031 12691.0918)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#727271" />
            <stop offset="0.5272" style="stop-color:#727271" />
            <stop offset="1" style="stop-color:#737372" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_20_)"
            fill="url(#SVGIDB_21_)"
            points="63.263,19.222 108.527,19.861 109.185,65.132 63.921,64.493
					"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_22_"
              d="M81.52,19.798l2.741,11.48c-0.568,2.152-2.677,3.015-4.35,1.812l-6.202-10.057
				c-0.077,0.06-6.599,6.588-6.653,6.653l10.053,6.176c1.129,1.92,0.256,4.021-1.767,4.366L63.82,37.497
				c-0.009,0.091-0.009,9.317,0,9.409l11.465-2.737c2.163,0.552,3.039,2.653,1.861,4.331l-10.092,6.216
				c0.056,0.07,6.582,6.594,6.658,6.655l6.165-10.029c1.924-1.147,4.035-0.278,4.386,1.746l-2.787,11.507
				c0.087,0.01,9.418,0.007,9.511,0l-2.782-11.437c0.554-2.173,2.669-3.05,4.351-1.852l6.194,10.065
				c0.073-0.062,6.597-6.588,6.653-6.659L95.37,48.544c-1.137-1.932-0.252-4.048,1.795-4.377l11.464,2.739
				c0.008-0.087,0.01-9.315,0-9.409l-11.464,2.727c-2.162-0.57-3.027-2.693-1.803-4.369l10.031-6.169
				c-0.062-0.07-6.581-6.599-6.653-6.653l-6.181,10.048c-1.928,1.119-4.034,0.23-4.357-1.815l2.686-11.51
				c-0.008,0-0.094-0.001-0.241-0.001C89.186,19.755,81.601,19.789,81.52,19.798"
            />
          </defs>
          <clipPath id="SVGIDB_23_">
            <use xlink:href="#SVGIDB_22_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_24_"
            cx="-156"
            cy="571"
            r="1"
            gradientTransform="matrix(23.2585 0.6605 -0.6605 -21.9375 4091.7017 12671.5068)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#757574" />
            <stop offset="0.5272" style="stop-color:#747473" />
            <stop offset="1" style="stop-color:#767675" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_23_)"
            fill="url(#SVGIDB_24_)"
            points="62.421,18.442 108.639,19.755 110.029,65.917 63.811,64.605
					"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_25_"
              d="M81.554,19.692l2.722,11.667c-0.565,2.137-2.657,2.994-4.318,1.798L73.61,22.982
				c-0.115,0.09-6.523,6.507-6.605,6.604l10.172,6.323c1.12,1.906,0.255,3.992-1.753,4.334l-11.71-2.712
				c-0.015,0.136-0.015,9.203,0,9.341l11.653-2.718c2.147,0.548,3.016,2.634,1.846,4.298l-10.21,6.363
				c0.084,0.106,6.496,6.516,6.61,6.608l6.312-10.15c1.908-1.137,4.004-0.275,4.353,1.734l-2.767,11.694
				c0.131,0.016,9.302,0.01,9.441,0l-2.761-11.625c0.549-2.157,2.649-3.027,4.317-1.839l6.341,10.184
				c0.11-0.09,6.522-6.503,6.605-6.609l-10.152-6.316c-1.128-1.916-0.251-4.018,1.781-4.343l11.652,2.719
				c0.013-0.13,0.015-9.2,0-9.341l-11.652,2.708c-2.146-0.566-3.005-2.673-1.789-4.337l10.151-6.315
				c-0.093-0.105-6.498-6.524-6.606-6.605l-6.327,10.167c-1.914,1.11-4.005,0.229-4.324-1.802l2.667-11.696
				c-0.02-0.002-0.226-0.003-0.563-0.003C88.293,19.648,81.668,19.678,81.554,19.692"
            />
          </defs>
          <clipPath id="SVGIDB_26_">
            <use xlink:href="#SVGIDB_25_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_27_"
            cx="-155.9995"
            cy="571"
            r="0.9998"
            gradientTransform="matrix(23.8639 1.0223 -1.0223 -21.8193 4392.7358 12660.4775)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#777777" />
            <stop offset="0.5272" style="stop-color:#767675" />
            <stop offset="1" style="stop-color:#797978" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_26_)"
            fill="url(#SVGIDB_27_)"
            points="61.493,17.624 108.75,19.648 110.957,66.742 63.699,64.717
					"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_28_"
              d="M81.588,19.584l2.702,11.857c-0.56,2.12-2.637,2.971-4.285,1.785l-6.494-10.295
				c-0.154,0.119-6.449,6.427-6.557,6.556l10.292,6.469c1.111,1.892,0.253,3.962-1.741,4.301l-11.897-2.692
				c-0.021,0.181-0.02,9.088,0,9.272l11.841-2.698c2.131,0.544,2.993,2.614,1.833,4.266l-10.33,6.509
				c0.111,0.142,6.41,6.437,6.562,6.56l6.458-10.269c1.894-1.129,3.975-0.274,4.321,1.72l-2.747,11.883
				c0.175,0.02,9.185,0.012,9.371,0l-2.741-11.814c0.545-2.141,2.629-3.005,4.284-1.825l6.488,10.303
				c0.147-0.12,6.445-6.42,6.557-6.561l-10.272-6.462c-1.119-1.902-0.247-3.988,1.768-4.311l11.84,2.699
				c0.016-0.173,0.022-9.084,0-9.272l-11.84,2.689c-2.129-0.562-2.981-2.653-1.776-4.305l10.271-6.462
				c-0.124-0.14-6.413-6.448-6.558-6.556l-6.473,10.287c-1.9,1.101-3.975,0.226-4.291-1.789l2.647-11.884
				c-0.033-0.003-0.346-0.005-0.839-0.005C87.731,19.54,81.734,19.568,81.588,19.584"
            />
          </defs>
          <clipPath id="SVGIDB_29_">
            <use xlink:href="#SVGIDB_28_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_30_"
            cx="-156"
            cy="571"
            r="1"
            gradientTransform="matrix(24.53 1.4091 -1.4091 -21.7118 4717.4932 12659.4141)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#7A7A79" />
            <stop offset="0.5272" style="stop-color:#787877" />
            <stop offset="1" style="stop-color:#7C7C7C" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_29_)"
            fill="url(#SVGIDB_30_)"
            points="60.467,16.76 108.863,19.54 111.982,67.608 63.587,64.828
			"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_31_"
              d="M81.622,19.478l2.683,12.045c-0.556,2.104-2.617,2.947-4.253,1.771l-6.64-10.415
				c-0.193,0.151-6.373,6.346-6.509,6.509l10.411,6.616c1.103,1.877,0.25,3.931-1.727,4.268l-12.085-2.673
				c-0.025,0.227-0.025,8.974,0,9.204l12.028-2.679c2.115,0.54,2.971,2.595,1.819,4.234l-10.448,6.655
				c0.14,0.177,6.324,6.358,6.513,6.511l6.606-10.387c1.88-1.121,3.944-0.272,4.287,1.707l-2.726,12.071
				c0.219,0.024,9.069,0.015,9.301,0l-2.721-12.004c0.541-2.124,2.61-2.98,4.252-1.81l6.634,10.422
				c0.184-0.151,6.37-6.336,6.509-6.513l-10.391-6.609c-1.111-1.888-0.246-3.957,1.754-4.278l12.029,2.68
				c0.02-0.216,0.026-8.969,0-9.204L96.92,40.268c-2.113-0.557-2.959-2.632-1.763-4.271l10.39-6.609
				c-0.155-0.175-6.33-6.373-6.509-6.509l-6.621,10.406c-1.884,1.094-3.944,0.226-4.259-1.774l2.63-12.071
				c-0.05-0.005-0.506-0.007-1.189-0.007C87.154,19.433,81.796,19.458,81.622,19.478"
            />
          </defs>
          <clipPath id="SVGIDB_32_">
            <use xlink:href="#SVGIDB_31_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_33_"
            cx="-155.999"
            cy="571"
            r="0.9996"
            gradientTransform="matrix(25.266 1.8246 -1.8246 -21.6168 5069.5679 12670.0039)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#7D7C7C" />
            <stop offset="0.5272" style="stop-color:#7A7A7A" />
            <stop offset="1" style="stop-color:#807F7F" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_32_)"
            fill="url(#SVGIDB_33_)"
            points="59.333,15.848 108.974,19.433 113.118,68.524 63.477,64.939
					"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_34_"
              d="M81.657,19.372l2.663,12.233c-0.552,2.087-2.598,2.925-4.22,1.757l-6.787-10.534
				c-0.231,0.18-6.298,6.266-6.46,6.46l10.53,6.763c1.094,1.864,0.248,3.901-1.715,4.236l-12.272-2.654
				c-0.031,0.272-0.03,8.86,0,9.136l12.216-2.66c2.099,0.536,2.949,2.575,1.806,4.202l-10.567,6.802
				c0.166,0.212,6.238,6.279,6.464,6.463l6.752-10.508c1.866-1.112,3.914-0.27,4.255,1.694l-2.706,12.259
				c0.263,0.03,8.952,0.019,9.231,0l-2.7-12.191c0.536-2.108,2.589-2.959,4.219-1.797l6.78,10.541
				c0.221-0.181,6.294-6.253,6.461-6.464l-10.511-6.756c-1.102-1.873-0.244-3.927,1.741-4.245l12.218,2.66
				c0.024-0.26,0.031-8.854,0-9.136l-12.217,2.65c-2.097-0.553-2.937-2.612-1.75-4.239l10.51-6.756
				c-0.185-0.21-6.246-6.297-6.461-6.46L92.37,33.354c-1.871,1.085-3.914,0.224-4.226-1.761l2.612-12.259
				c-0.071-0.006-0.672-0.009-1.534-0.009C86.677,19.325,81.856,19.349,81.657,19.372"
            />
          </defs>
          <clipPath id="SVGIDB_35_">
            <use xlink:href="#SVGIDB_34_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_36_"
            cx="-156"
            cy="570.999"
            r="1.0005"
            gradientTransform="matrix(26.0834 2.2734 -2.2734 -21.5366 5453.334 12694.2529)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#7F7F7F" />
            <stop offset="0.5272" style="stop-color:#7C7C7C" />
            <stop offset="1" style="stop-color:#838282" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_35_)"
            fill="url(#SVGIDB_36_)"
            points="58.069,14.878 109.086,19.325 114.382,69.498 63.365,65.051
					"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_37_"
              d="M81.691,19.265l2.644,12.421c-0.548,2.072-2.578,2.903-4.189,1.744l-6.933-10.653
				c-0.268,0.21-6.222,6.185-6.412,6.412l10.65,6.91c1.085,1.848,0.247,3.871-1.701,4.203l-12.46-2.635
				c-0.036,0.317-0.036,8.746,0,9.068l12.404-2.64c2.083,0.531,2.926,2.554,1.791,4.169l-10.686,6.948
				c0.195,0.247,6.153,6.2,6.417,6.414l6.899-10.627c1.851-1.103,3.884-0.266,4.222,1.681l-2.686,12.447
				c0.306,0.035,8.837,0.022,9.16,0l-2.68-12.379c0.533-2.092,2.57-2.936,4.188-1.783l6.927,10.66
				c0.257-0.211,6.217-6.169,6.412-6.416l-10.63-6.903c-1.094-1.858-0.242-3.896,1.727-4.213l12.406,2.642
				c0.028-0.304,0.037-8.739,0-9.068l-12.405,2.631c-2.081-0.549-2.914-2.592-1.736-4.207l10.629-6.902
				c-0.216-0.245-6.161-6.222-6.412-6.412l-6.914,10.645c-1.857,1.076-3.884,0.222-4.194-1.747l2.593-12.447
				c-0.09-0.008-0.811-0.012-1.809-0.012C86.338,19.216,81.915,19.24,81.691,19.265"
            />
          </defs>
          <clipPath id="SVGIDB_38_">
            <use xlink:href="#SVGIDB_37_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_39_"
            cx="-156"
            cy="570.998"
            r="1.001"
            gradientTransform="matrix(26.9959 2.761 -2.761 -21.474 5874.104 12734.543)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#828281" />
            <stop offset="0.5272" style="stop-color:#7F7E7E" />
            <stop offset="1" style="stop-color:#868585" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_38_)"
            fill="url(#SVGIDB_39_)"
            points="56.656,13.842 109.198,19.216 115.796,70.536 63.254,65.162
					"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_40_"
              d="M81.725,19.159l2.625,12.609c-0.544,2.055-2.557,2.88-4.156,1.73l-7.08-10.773
				c-0.307,0.241-6.147,6.105-6.364,6.364l10.768,7.057c1.079,1.834,0.246,3.841-1.687,4.17l-12.648-2.615
				c-0.04,0.362-0.039,8.631,0,9l12.593-2.621c2.066,0.527,2.903,2.535,1.778,4.136l-10.805,7.095
				c0.222,0.283,6.066,6.122,6.368,6.366l7.046-10.746c1.837-1.095,3.853-0.265,4.188,1.668l-2.665,12.634
				c0.35,0.041,8.72,0.026,9.09,0l-2.659-12.567c0.528-2.076,2.55-2.914,4.154-1.77l7.074,10.78
				c0.294-0.242,6.141-6.086,6.364-6.368L94.96,48.259c-1.086-1.845-0.241-3.866,1.713-4.18l12.594,2.622
				c0.033-0.347,0.042-8.625,0-9l-12.593,2.611c-2.065-0.543-2.891-2.571-1.723-4.173l10.749-7.05
				c-0.246-0.28-6.077-6.146-6.364-6.364L92.275,33.49c-1.841,1.069-3.853,0.22-4.161-1.734l2.575-12.633
				c-0.114-0.011-0.967-0.015-2.107-0.015C86.007,19.108,81.972,19.131,81.725,19.159"
            />
          </defs>
          <clipPath id="SVGIDB_41_">
            <use xlink:href="#SVGIDB_40_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_42_"
            cx="-155.999"
            cy="571"
            r="0.9996"
            gradientTransform="matrix(28.0206 3.2942 -3.2942 -21.4322 6338.4551 12793.8467)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#858484" />
            <stop offset="0.5272" style="stop-color:#818080" />
            <stop offset="1" style="stop-color:#898888" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_41_)"
            fill="url(#SVGIDB_42_)"
            points="55.067,12.731 109.309,19.108 117.385,71.651 63.143,65.274
					"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_43_"
              d="M81.76,19.052l2.604,12.798c-0.539,2.039-2.537,2.857-4.123,1.716l-7.226-10.892
				c-0.346,0.271-6.072,6.025-6.315,6.316l10.887,7.203c1.069,1.821,0.243,3.812-1.674,4.138l-12.836-2.596
				c-0.046,0.408-0.045,8.516,0,8.931l12.781-2.601c2.05,0.523,2.88,2.515,1.763,4.104L66.698,55.41
				c0.25,0.319,5.98,6.042,6.32,6.318l7.192-10.866c1.822-1.085,3.824-0.263,4.157,1.655L81.721,65.34
				c0.395,0.045,8.604,0.028,9.02,0l-2.639-12.756c0.524-2.059,2.53-2.891,4.123-1.755l7.219,10.898
				c0.331-0.272,6.065-6.003,6.316-6.32l-10.869-7.195c-1.076-1.831-0.238-3.836,1.701-4.148l12.782,2.602
				c0.036-0.389,0.047-8.509,0-8.931l-12.782,2.593c-2.048-0.54-2.868-2.553-1.709-4.141l10.868-7.197
				c-0.278-0.316-5.993-6.071-6.315-6.315l-7.208,10.884c-1.828,1.059-3.823,0.217-4.128-1.721l2.556-12.821
				c-0.138-0.012-1.112-0.018-2.369-0.018C85.739,18.999,82.028,19.022,81.76,19.052"
            />
          </defs>
          <clipPath id="SVGIDB_44_">
            <use xlink:href="#SVGIDB_43_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_45_"
            cx="-156"
            cy="571"
            r="1"
            gradientTransform="matrix(29.1787 3.8818 -3.8818 -21.4151 6854.6089 12875.7559)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#878786" />
            <stop offset="0.5272" style="stop-color:#838282" />
            <stop offset="1" style="stop-color:#8B8B8B" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_44_)"
            fill="url(#SVGIDB_45_)"
            points="53.269,11.529 109.421,18.999 119.183,72.855 63.031,65.385
					"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_46_"
              d="M81.794,18.946l2.585,12.986c-0.535,2.023-2.517,2.835-4.09,1.702l-7.373-11.011
				c-0.384,0.3-5.997,5.943-6.268,6.267l11.007,7.351c1.061,1.805,0.241,3.781-1.661,4.105l-13.023-2.577
				c-0.05,0.454-0.05,8.402,0,8.863L75.94,44.05c2.034,0.519,2.857,2.496,1.749,4.072l-11.043,7.387
				c0.279,0.354,5.896,5.964,6.272,6.27l7.339-10.985c1.808-1.078,3.794-0.26,4.124,1.642l-2.624,13.011
				c0.437,0.049,8.486,0.031,8.949,0l-2.619-12.945c0.52-2.043,2.51-2.867,4.09-1.742l7.366,11.018
				c0.367-0.302,5.99-5.919,6.268-6.271l-10.988-7.343c-1.068-1.815-0.237-3.805,1.687-4.115l12.97,2.583
				c0.041-0.433,0.052-8.394,0-8.863l-12.97,2.573c-2.032-0.535-2.845-2.532-1.695-4.108l10.988-7.343
				c-0.309-0.352-5.909-5.996-6.268-6.267L92.18,33.626c-1.812,1.052-3.793,0.217-4.095-1.706l2.538-13.009
				c-0.161-0.014-1.221-0.021-2.556-0.021C85.559,18.89,82.084,18.913,81.794,18.946"
            />
          </defs>
          <clipPath id="SVGIDB_47_">
            <use xlink:href="#SVGIDB_46_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_48_"
            cx="-156"
            cy="571"
            r="1"
            gradientTransform="matrix(30.4969 4.5345 -4.5345 -21.4278 7432.9639 12984.8486)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#8A8A89" />
            <stop offset="0.5272" style="stop-color:#858584" />
            <stop offset="1" style="stop-color:#8E8E8E" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_47_)"
            fill="url(#SVGIDB_48_)"
            points="51.224,10.22 109.532,18.89 121.229,74.166 62.921,65.496
			"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_49_"
              d="M81.829,18.839l2.565,13.174c-0.531,2.007-2.497,2.813-4.058,1.69l-7.519-11.131
				c-0.422,0.331-5.921,5.863-6.219,6.219l11.126,7.497c1.052,1.791,0.239,3.751-1.648,4.072l-13.211-2.557
				c-0.056,0.499-0.055,8.288,0,8.795l13.157-2.562c2.018,0.514,2.834,2.475,1.735,4.039l-11.161,7.534
				c0.305,0.389,5.809,5.884,6.223,6.221l7.486-11.105c1.794-1.068,3.764-0.258,4.09,1.629l-2.603,13.199
				c0.481,0.055,8.37,0.034,8.879,0L88.073,52.42c0.516-2.027,2.489-2.845,4.056-1.728l7.514,11.137
				c0.403-0.333,5.912-5.836,6.219-6.223l-11.108-7.49c-1.059-1.801-0.234-3.775,1.674-4.081l13.158,2.563
				c0.045-0.476,0.058-8.279,0-8.795l-13.158,2.553c-2.016-0.531-2.822-2.511-1.682-4.075l11.108-7.49
				c-0.339-0.386-5.825-5.921-6.219-6.219l-7.501,11.123c-1.799,1.043-3.764,0.215-4.064-1.693l2.52-13.196
				c-0.187-0.018-1.345-0.025-2.763-0.025C85.371,18.781,82.138,18.804,81.829,18.839"
            />
          </defs>
          <clipPath id="SVGIDB_50_">
            <use xlink:href="#SVGIDB_49_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_51_"
            cx="-155.9995"
            cy="570.999"
            r="1.0003"
            gradientTransform="matrix(32.0094 5.2664 -5.2664 -21.4766 8086.8281 13126.8691)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#8C8C8C" />
            <stop offset="0.5272" style="stop-color:#878786" />
            <stop offset="1" style="stop-color:#919190" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_50_)"
            fill="url(#SVGIDB_51_)"
            points="48.875,8.783 109.644,18.781 123.579,75.606 62.809,65.608
					"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_52_"
              d="M81.863,18.733l2.545,13.361c-0.526,1.992-2.477,2.79-4.025,1.677l-7.665-11.25
				c-0.461,0.36-5.847,5.782-6.171,6.171l11.245,7.643c1.043,1.778,0.237,3.722-1.635,4.04l-13.399-2.539
				c-0.06,0.545-0.059,8.175,0,8.728l13.346-2.543c2.001,0.51,2.811,2.455,1.721,4.007l-11.28,7.68
				c0.334,0.425,5.723,5.806,6.175,6.173l7.633-11.224c1.779-1.06,3.733-0.257,4.058,1.616l-2.584,13.386
				c0.525,0.06,8.253,0.038,8.809,0l-2.579-13.321c0.513-2.01,2.47-2.822,4.025-1.714l7.66,11.256
				c0.439-0.363,5.837-5.753,6.171-6.175l-11.227-7.636c-1.051-1.787-0.233-3.745,1.66-4.05l13.347,2.545
				c0.049-0.52,0.064-8.164,0-8.728l-13.347,2.536c-1.999-0.528-2.799-2.492-1.667-4.043l11.226-7.637
				c-0.37-0.422-5.741-5.845-6.171-6.171l-7.648,11.242c-1.784,1.035-3.733,0.213-4.031-1.679l2.502-13.383
				c-0.211-0.02-1.436-0.029-2.904-0.029C85.249,18.672,82.194,18.696,81.863,18.733"
            />
          </defs>
          <clipPath id="SVGIDB_53_">
            <use xlink:href="#SVGIDB_52_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_54_"
            cx="-156"
            cy="571"
            r="1"
            gradientTransform="matrix(33.7609 6.0957 -6.0957 -21.5695 8833.5713 13309.3076)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#8F8F8E" />
            <stop offset="0.5272" style="stop-color:#898988" />
            <stop offset="1" style="stop-color:#949493" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_53_)"
            fill="url(#SVGIDB_54_)"
            points="46.157,7.188 109.757,18.672 126.298,77.202 62.698,65.719
					"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_55_"
              d="M81.897,18.627l2.526,13.549c-0.522,1.976-2.457,2.768-3.992,1.663L72.619,22.47
				c-0.5,0.389-5.771,5.701-6.124,6.123l11.366,7.79c1.034,1.762,0.234,3.691-1.622,4.007l-13.587-2.519
				c-0.065,0.589-0.065,8.06,0,8.659l13.534-2.524c1.985,0.507,2.789,2.435,1.707,3.974l-11.399,7.827
				c0.361,0.461,5.636,5.727,6.127,6.125L80.4,50.589c1.765-1.052,3.703-0.255,4.025,1.602l-2.563,13.575
				c0.569,0.065,8.137,0.041,8.739-0.001l-2.558-13.51c0.508-1.993,2.45-2.799,3.992-1.699l7.806,11.375
				c0.476-0.393,5.761-5.669,6.123-6.127l-11.346-7.782c-1.044-1.772-0.231-3.715,1.647-4.017L109.8,46.53
				c0.053-0.563,0.068-8.05,0-8.659l-13.535,2.515c-1.984-0.523-2.778-2.471-1.655-4.009l11.347-7.784
				c-0.402-0.457-5.657-5.77-6.123-6.123l-7.796,11.361c-1.769,1.026-3.702,0.212-3.998-1.665l2.483-13.572
				c-0.235-0.021-1.514-0.031-3.02-0.031C85.153,18.563,82.249,18.587,81.897,18.627"
            />
          </defs>
          <clipPath id="SVGIDB_56_">
            <use xlink:href="#SVGIDB_55_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_57_"
            cx="-156"
            cy="570.999"
            r="1.0005"
            gradientTransform="matrix(35.8104 7.0466 -7.0466 -21.7172 9696.2441 13541.9658)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#929191" />
            <stop offset="0.5272" style="stop-color:#8B8A8A" />
            <stop offset="1" style="stop-color:#979796" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_56_)"
            fill="url(#SVGIDB_57_)"
            points="42.979,5.401 109.868,18.563 129.476,78.993 62.587,65.831
					"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_58_"
              d="M81.931,18.521l2.507,13.737c-0.518,1.959-2.437,2.745-3.96,1.649l-7.959-11.488
				c-0.537,0.42-5.695,5.62-6.074,6.075l11.483,7.937c1.027,1.747,0.234,3.66-1.608,3.973l-13.774-2.499
				c-0.07,0.634-0.069,7.946,0,8.59l13.722-2.503c1.969,0.502,2.766,2.415,1.693,3.942l-11.518,7.972
				c0.389,0.497,5.55,5.648,6.079,6.077l7.926-11.463c1.751-1.043,3.672-0.252,3.991,1.59l-2.542,13.762
				c0.613,0.071,8.02,0.043,8.669,0l-2.538-13.699c0.504-1.977,2.43-2.775,3.96-1.685l7.952,11.494
				c0.513-0.423,5.685-5.586,6.075-6.078l-11.466-7.93c-1.034-1.758-0.228-3.685,1.634-3.983l13.723,2.504
				c0.057-0.606,0.074-7.934,0-8.59l-13.722,2.496c-1.969-0.519-2.756-2.451-1.642-3.978l11.466-7.929
				c-0.433-0.493-5.573-5.696-6.075-6.075l-7.942,11.48c-1.755,1.019-3.673,0.21-3.965-1.652l2.465-13.758
				c-0.262-0.024-1.601-0.035-3.148-0.035C85.05,18.454,82.302,18.478,81.931,18.521"
            />
          </defs>
          <clipPath id="SVGIDB_59_">
            <use xlink:href="#SVGIDB_58_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_60_"
            cx="-155.9995"
            cy="571"
            r="0.9998"
            gradientTransform="matrix(38.2377 8.1519 -8.1519 -21.9338 10706.0693 13838.1123)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#949494" />
            <stop offset="0.5272" style="stop-color:#8D8C8C" />
            <stop offset="1" style="stop-color:#9A9999" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_59_)"
            fill="url(#SVGIDB_60_)"
            points="39.22,3.369 109.98,18.454 133.236,81.028 62.476,65.943
			"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_61_"
              d="M81.965,18.414l2.488,13.926c-0.514,1.942-2.417,2.722-3.928,1.635L72.42,22.367
				c-0.576,0.45-5.62,5.541-6.026,6.027l11.602,8.083c1.019,1.735,0.232,3.631-1.594,3.942L62.44,37.938
				c-0.076,0.681-0.075,7.832,0,8.523l13.909-2.485c1.953,0.499,2.744,2.396,1.68,3.911l-11.636,8.118
				c0.416,0.532,5.464,5.57,6.029,6.029l8.073-11.582c1.736-1.034,3.643-0.25,3.96,1.577l-2.523,13.95
				c0.657,0.074,7.904,0.046,8.599,0l-2.518-13.888c0.5-1.961,2.41-2.753,3.927-1.672l8.1,11.614
				c0.549-0.454,5.608-5.502,6.026-6.03l-11.585-8.077c-1.026-1.743-0.227-3.654,1.62-3.951l13.911,2.486
				c0.061-0.65,0.079-7.819,0-8.522l-13.91,2.477c-1.952-0.515-2.733-2.431-1.628-3.945l11.585-8.077
				c-0.463-0.527-5.489-5.62-6.027-6.027l-8.088,11.6c-1.741,1.01-3.643,0.208-3.933-1.639l2.447-13.944
				c-0.289-0.027-1.685-0.04-3.268-0.04C84.958,18.344,82.355,18.369,81.965,18.414"
            />
          </defs>
          <clipPath id="SVGIDB_62_">
            <use xlink:href="#SVGIDB_61_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_63_"
            cx="-155.999"
            cy="571"
            r="0.9997"
            gradientTransform="matrix(41.1944 9.4667 -9.4667 -22.2609 11918.0381 14229.9688)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#979796" />
            <stop offset="0.5272" style="stop-color:#8F8E8E" />
            <stop offset="1" style="stop-color:#9C9C9C" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_62_)"
            fill="url(#SVGIDB_63_)"
            points="34.708,1.021 110.091,18.344 137.747,83.376 62.364,66.053
					"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_64_"
              d="M82,18.307l2.467,14.114c-0.509,1.927-2.396,2.7-3.895,1.622l-8.251-11.727
				c-0.614,0.481-5.545,5.459-5.978,5.979l11.722,8.23c1.01,1.719,0.229,3.601-1.582,3.909l-14.149-2.462
				c-0.081,0.726-0.079,7.718,0,8.455l14.097-2.465c1.937,0.494,2.721,2.376,1.666,3.877l-11.756,8.265
				c0.445,0.568,5.379,5.491,5.982,5.981l8.219-11.702c1.722-1.026,3.613-0.248,3.927,1.564l-2.502,14.138
				c0.7,0.08,7.787,0.05,8.529,0L87.999,52.01c0.495-1.945,2.39-2.731,3.894-1.659l8.246,11.732
				c0.586-0.483,5.532-5.418,5.979-5.981l-11.706-8.223c-1.017-1.729-0.225-3.624,1.607-3.918l14.1,2.466
				c0.065-0.693,0.084-7.704,0-8.455L96.02,40.43c-1.936-0.509-2.71-2.41-1.615-3.911l11.706-8.224
				c-0.495-0.563-5.406-5.544-5.979-5.979l-8.235,11.72c-1.727,1.001-3.613,0.206-3.901-1.626l2.428-14.132
				c-0.313-0.029-1.739-0.043-3.335-0.043C84.908,18.235,82.41,18.261,82,18.307"
            />
          </defs>
          <clipPath id="SVGIDB_65_">
            <use xlink:href="#SVGIDB_64_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_66_"
            cx="-156"
            cy="571"
            r="1"
            gradientTransform="matrix(44.9827 11.0939 -11.0939 -22.795 13438.1172 14788.7803)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#999999" />
            <stop offset="0.5272" style="stop-color:#909090" />
            <stop offset="1" style="stop-color:#9F9F9F" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_65_)"
            fill="url(#SVGIDB_66_)"
            points="29.205,-1.741 110.203,18.235 143.251,86.141 62.253,66.165
					"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_67_"
              d="M82.034,18.201l2.448,14.302c-0.505,1.911-2.377,2.678-3.862,1.608l-8.398-11.846
				c-0.652,0.51-5.469,5.379-5.93,5.93l11.841,8.377c1.002,1.705,0.228,3.571-1.569,3.877l-14.337-2.442
				c-0.085,0.771-0.084,7.603,0,8.386l14.286-2.446c1.921,0.491,2.698,2.355,1.653,3.845L66.29,56.204
				c0.473,0.602,5.293,5.411,5.934,5.931l8.366-11.82c1.708-1.017,3.582-0.247,3.894,1.551l-2.482,14.325
				c0.745,0.085,7.671,0.054,8.458,0l-2.476-14.263c0.491-1.929,2.369-2.708,3.862-1.645l8.392,11.852
				c0.623-0.514,5.456-5.336,5.93-5.934l-11.824-8.369c-1.009-1.715-0.223-3.594,1.593-3.886l14.288,2.447
				c0.07-0.737,0.089-7.589,0-8.386l-14.287,2.438c-1.919-0.505-2.687-2.39-1.601-3.878l11.825-8.372
				c-0.526-0.597-5.321-5.469-5.931-5.93l-8.382,11.839c-1.712,0.993-3.582,0.204-3.868-1.612l2.41-14.32
				c-0.339-0.031-1.8-0.046-3.413-0.046C84.852,18.126,82.463,18.152,82.034,18.201"
            />
          </defs>
          <clipPath id="SVGIDB_68_">
            <use xlink:href="#SVGIDB_67_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_69_"
            cx="-156"
            cy="570.999"
            r="1.0005"
            gradientTransform="matrix(49.6915 13.1012 -13.1012 -23.4891 15318.8398 15498.2656)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#9C9C9B" />
            <stop offset="0.5272" style="stop-color:#929292" />
            <stop offset="1" style="stop-color:#A2A2A1" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_68_)"
            fill="url(#SVGIDB_69_)"
            points="22.351,-5.065 110.314,18.126 150.105,89.467 62.142,66.276
					"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_70_"
              d="M82.068,18.094l2.429,14.491c-0.501,1.894-2.357,2.654-3.83,1.595l-8.544-11.967
				c-0.691,0.541-5.395,5.299-5.882,5.883l11.961,8.524c0.992,1.691,0.226,3.54-1.557,3.844l-14.524-2.423
				c-0.091,0.816-0.089,7.489,0,8.318l14.474-2.427c1.904,0.486,2.676,2.336,1.638,3.813L66.24,56.303
				c0.499,0.638,5.206,5.332,5.885,5.884l8.513-11.94c1.693-1.009,3.551-0.244,3.861,1.537l-2.462,14.514
				c0.789,0.09,7.554,0.056,8.388,0l-2.456-14.452c0.487-1.914,2.35-2.686,3.829-1.631l8.539,11.971
				c0.66-0.545,5.38-5.252,5.882-5.885l-11.943-8.517c-1-1.7-0.222-3.563,1.58-3.853l14.476,2.428c0.073-0.78,0.094-7.474,0-8.318
				L95.856,40.46c-1.903-0.501-2.665-2.371-1.588-3.847l11.944-8.517c-0.555-0.633-5.236-5.394-5.881-5.882l-8.53,11.959
				c-1.697,0.984-3.551,0.202-3.834-1.599l2.391-14.507c-0.367-0.034-1.862-0.051-3.489-0.051
				C84.799,18.016,82.515,18.043,82.068,18.094"
            />
          </defs>
          <clipPath id="SVGIDB_71_">
            <use xlink:href="#SVGIDB_70_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_72_"
            cx="-156"
            cy="570.998"
            r="1.001"
            gradientTransform="matrix(55.6968 15.6444 -15.6444 -24.4079 17707.9023 16419.6309)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#9F9F9E" />
            <stop offset="0.5272" style="stop-color:#949494" />
            <stop offset="1" style="stop-color:#A5A5A4" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_71_)"
            fill="url(#SVGIDB_72_)"
            points="13.592,-9.183 110.426,18.016 158.864,93.587 62.03,66.388
					"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_73_"
              d="M82.102,17.988l2.41,14.679c-0.497,1.878-2.337,2.631-3.798,1.58l-8.69-12.085
				c-0.73,0.571-5.319,5.218-5.834,5.834l12.08,8.671c0.985,1.676,0.223,3.51-1.543,3.811l-14.712-2.404
				c-0.095,0.862-0.094,7.376,0,8.25l14.662-2.406c1.888,0.482,2.652,2.316,1.624,3.78l-12.113,8.704
				c0.529,0.674,5.121,5.254,5.837,5.835l8.661-12.059c1.678-1,3.521-0.242,3.827,1.525l-2.441,14.701
				c0.832,0.096,7.438,0.06,8.318,0l-2.436-14.64c0.483-1.897,2.33-2.662,3.797-1.617l8.685,12.089
				c0.697-0.574,5.305-5.167,5.835-5.836l-12.063-8.664c-0.993-1.685-0.22-3.533,1.566-3.819l14.665,2.407
				c0.077-0.822,0.099-7.359,0-8.249l-14.665,2.399c-1.886-0.496-2.641-2.35-1.574-3.813l12.064-8.664
				c-0.587-0.668-5.153-5.318-5.834-5.834L91.755,34.24c-1.683,0.976-3.522,0.202-3.803-1.584l2.374-14.695
				c-0.393-0.036-1.901-0.054-3.527-0.054C84.776,17.907,82.57,17.934,82.102,17.988"
            />
          </defs>
          <clipPath id="SVGIDB_74_">
            <use xlink:href="#SVGIDB_73_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_75_"
            cx="-156"
            cy="571"
            r="1"
            gradientTransform="matrix(63.6125 18.9779 -18.9779 -25.6566 20846.1641 17652.6895)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#A1A1A1" />
            <stop offset="0.5272" style="stop-color:#969695" />
            <stop offset="1" style="stop-color:#A8A8A7" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_74_)"
            fill="url(#SVGIDB_75_)"
            points="2.032,-14.464 110.538,17.907 170.426,98.872 61.92,66.5
			"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_76_"
              d="M82.136,17.882l2.391,14.866c-0.492,1.863-2.318,2.61-3.765,1.568l-8.837-12.204
				c-0.769,0.6-5.244,5.137-5.786,5.785l12.198,8.818c0.977,1.661,0.223,3.479-1.528,3.778l-14.9-2.385
				c-0.101,0.907-0.099,7.261,0,8.182l14.85-2.388c1.872,0.479,2.63,2.297,1.61,3.749l-12.231,8.85
				c0.555,0.709,5.035,5.176,5.788,5.788l8.807-12.179c1.664-0.992,3.491-0.241,3.796,1.511L82.108,66.51
				c0.875,0.1,7.32,0.063,8.247,0L87.94,51.681c0.478-1.88,2.309-2.639,3.763-1.603l8.833,12.21
				c0.733-0.604,5.228-5.085,5.785-5.789l-12.181-8.81c-0.984-1.672-0.219-3.503,1.552-3.788l14.853,2.389
				c0.081-0.866,0.105-7.244,0-8.182L95.692,40.49c-1.87-0.494-2.619-2.33-1.56-3.781l12.183-8.812
				c-0.618-0.703-5.068-5.243-5.785-5.785l-8.823,12.196c-1.669,0.968-3.491,0.2-3.77-1.57l2.355-14.882
				c-0.418-0.039-1.937-0.059-3.561-0.059C84.754,17.797,82.624,17.826,82.136,17.882"
            />
          </defs>
          <clipPath id="SVGIDB_77_">
            <use xlink:href="#SVGIDB_76_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_78_"
            cx="-156"
            cy="571"
            r="1"
            gradientTransform="matrix(74.5127 23.5464 -23.5464 -27.4199 25155.2227 19372.1816)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#A4A4A3" />
            <stop offset="0.5272" style="stop-color:#989897" />
            <stop offset="1" style="stop-color:#ABAAAA" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_77_)"
            fill="url(#SVGIDB_78_)"
            points="-13.911,-21.565 110.65,17.797 186.369,105.972
			61.808,66.61 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_79_"
              d="M82.171,17.775l2.37,15.055c-0.488,1.847-2.297,2.587-3.732,1.554L71.825,22.06
				c-0.805,0.63-5.168,5.057-5.737,5.738l12.318,8.964c0.968,1.648,0.22,3.45-1.516,3.746l-15.087-2.366
				c-0.106,0.953-0.105,7.146,0,8.114l15.038-2.368c1.856,0.474,2.607,2.277,1.596,3.715L66.087,56.6
				c0.583,0.745,4.949,5.096,5.74,5.74l8.953-12.299c1.651-0.982,3.462-0.237,3.763,1.499l-2.4,15.077
				c0.919,0.105,7.204,0.065,8.177,0l-2.395-15.018c0.475-1.864,2.29-2.616,3.732-1.588l8.978,12.328
				c0.769-0.635,5.152-5.001,5.737-5.74l-12.301-8.958c-0.975-1.656-0.216-3.472,1.539-3.754l15.041,2.369
				c0.086-0.91,0.111-7.129,0-8.114L95.61,40.504c-1.854-0.489-2.596-2.309-1.547-3.749l12.303-8.957
				c-0.648-0.738-4.984-5.168-5.737-5.738L91.66,34.377c-1.655,0.959-3.461,0.198-3.737-1.557l2.336-15.07
				c-0.444-0.041-1.968-0.062-3.585-0.062C84.742,17.688,82.678,17.718,82.171,17.775"
            />
          </defs>
          <clipPath id="SVGIDB_80_">
            <use xlink:href="#SVGIDB_79_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_81_"
            cx="-156"
            cy="571"
            r="1"
            gradientTransform="matrix(90.5142 30.2225 -30.2225 -30.0693 31463.4414 21926.4668)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#A7A6A6" />
            <stop offset="0.5272" style="stop-color:#9A9A99" />
            <stop offset="1" style="stop-color:#ADADAD" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_80_)"
            fill="url(#SVGIDB_81_)"
            points="-37.264,-31.737 110.762,17.688 209.723,116.147
			61.697,66.722 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_82_"
              d="M82.205,17.668l2.351,15.244c-0.484,1.829-2.277,2.564-3.699,1.54l-9.131-12.443
				c-0.844,0.661-5.093,4.976-5.689,5.689l12.437,9.112c0.96,1.633,0.218,3.419-1.502,3.712l-15.275-2.345
				c-0.111,0.997-0.109,7.031,0,8.045l15.226-2.348c1.839,0.469,2.584,2.256,1.582,3.682L66.036,56.7
				c0.611,0.779,4.863,5.017,5.692,5.69l9.1-12.417c1.635-0.975,3.431-0.236,3.729,1.485l-2.379,15.266
				c0.963,0.109,7.087,0.068,8.107,0L87.91,51.517c0.471-1.847,2.27-2.593,3.699-1.575l9.125,12.447
				c0.806-0.664,5.076-4.917,5.69-5.691l-12.421-9.104c-0.967-1.642-0.214-3.442,1.525-3.722l15.229,2.35
				c0.09-0.953,0.116-7.014,0-8.045l-15.229,2.342c-1.837-0.485-2.573-2.29-1.532-3.716l12.421-9.104
				c-0.679-0.773-4.9-5.092-5.688-5.689l-9.116,12.436c-1.64,0.951-3.431,0.196-3.705-1.543l2.318-15.258
				c-0.47-0.044-2.001-0.065-3.612-0.065C84.728,17.579,82.732,17.609,82.205,17.668"
            />
          </defs>
          <clipPath id="SVGIDB_83_">
            <use xlink:href="#SVGIDB_82_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_84_"
            cx="-156"
            cy="570.999"
            r="1.0005"
            gradientTransform="matrix(116.5102 41.0135 -41.0135 -34.4833 41680.5 26130.2383)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#A9A9A9" />
            <stop offset="0.5272" style="stop-color:#9C9C9B" />
            <stop offset="1" style="stop-color:#B0B0B0" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_83_)"
            fill="url(#SVGIDB_84_)"
            points="-74.684,-47.74 110.873,17.579 247.144,132.152
			61.586,66.833 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_85_"
              d="M82.239,17.562l2.332,15.432c-0.48,1.813-2.257,2.541-3.668,1.526l-9.276-12.562
				c-0.883,0.69-5.017,4.895-5.641,5.641l12.557,9.257c0.95,1.619,0.216,3.391-1.49,3.681L61.59,38.21
				c-0.116,1.043-0.114,6.918,0,7.978l15.415-2.33c1.823,0.467,2.561,2.238,1.568,3.651l-12.588,9.29
				c0.639,0.815,4.777,4.938,5.644,5.642l9.247-12.536c1.62-0.966,3.401-0.234,3.697,1.472l-2.36,15.453
				c1.007,0.115,6.971,0.072,8.037,0l-2.355-15.395c0.467-1.831,2.25-2.57,3.667-1.561l9.271,12.567
				c0.843-0.695,5-4.834,5.641-5.644l-12.54-9.25c-0.958-1.629-0.212-3.412,1.513-3.69l15.417,2.331
				c0.094-0.997,0.121-6.899,0-7.978l-15.417,2.324c-1.822-0.481-2.551-2.27-1.52-3.683l12.542-9.252
				c-0.71-0.808-4.816-5.017-5.641-5.641l-9.263,12.555c-1.626,0.943-3.4,0.194-3.672-1.53l2.3-15.444
				c-0.496-0.046-2.032-0.07-3.636-0.07C84.715,17.469,82.785,17.5,82.239,17.562"
            />
          </defs>
          <clipPath id="SVGIDB_86_">
            <use xlink:href="#SVGIDB_85_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_87_"
            cx="-156"
            cy="570.998"
            r="1.001"
            gradientTransform="matrix(164.7962 61.035 -61.035 -42.7263 60645.4141 33960.3633)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#ACACAB" />
            <stop offset="0.5272" style="stop-color:#9E9D9D" />
            <stop offset="1" style="stop-color:#B3B3B2" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_86_)"
            fill="url(#SVGIDB_87_)"
            points="-144.23,-77.054 110.985,17.469 316.689,161.468
			61.474,66.945 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_88_"
              d="M82.273,17.456l2.312,15.619c-0.475,1.798-2.236,2.52-3.634,1.513l-9.423-12.682
				c-0.922,0.721-4.943,4.815-5.592,5.593l12.675,9.405c0.942,1.605,0.214,3.36-1.476,3.648l-15.651-2.308
				c-0.121,1.088-0.119,6.804,0,7.909l15.603-2.309c1.807,0.462,2.538,2.217,1.554,3.618l-12.707,9.436
				c0.667,0.85,4.691,4.86,5.595,5.594l9.394-12.656c1.607-0.957,3.371-0.232,3.664,1.459l-2.339,15.641
				c1.051,0.121,6.855,0.076,7.967,0L87.88,51.354c0.463-1.816,2.23-2.548,3.634-1.548l9.419,12.685
				c0.879-0.724,4.923-4.75,5.592-5.595l-12.659-9.397c-0.949-1.613-0.21-3.382,1.499-3.656l15.606,2.31
				c0.098-1.039,0.126-6.784,0-7.909l-15.606,2.304c-1.806-0.475-2.528-2.249-1.506-3.649l12.661-9.4
				c-0.741-0.843-4.732-4.941-5.593-5.593l-9.409,12.675c-1.611,0.934-3.371,0.193-3.64-1.516l2.282-15.632
				c-0.523-0.048-2.061-0.073-3.655-0.073C84.707,17.36,82.838,17.392,82.273,17.456"
            />
          </defs>
          <clipPath id="SVGIDB_89_">
            <use xlink:href="#SVGIDB_88_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_90_"
            cx="-156.0005"
            cy="570.999"
            r="1.0006"
            gradientTransform="matrix(285.1908 110.9256 -110.9256 -63.3396 107914.5313 53513.4922)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#AEAEAE" />
            <stop offset="0.5272" style="stop-color:#A09F9F" />
            <stop offset="1" style="stop-color:#B6B5B5" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_89_)"
            fill="url(#SVGIDB_90_)"
            points="-317.865,-149.485 111.097,17.36 490.324,233.902
			61.363,67.057 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_91_"
              d="M82.307,17.35L84.6,33.156c-0.471,1.782-2.217,2.497-3.602,1.501l-9.569-12.802
				c-0.96,0.751-4.867,4.734-5.545,5.545l12.795,9.552c0.934,1.59,0.212,3.329-1.463,3.614l-15.838-2.288
				c-0.126,1.133-0.124,6.69,0,7.841l15.79-2.29c1.791,0.458,2.517,2.197,1.541,3.585l-12.826,9.583
				c0.695,0.886,4.606,4.78,5.547,5.546l9.541-12.775c1.592-0.949,3.34-0.23,3.631,1.446l-2.319,15.828
				c1.095,0.125,6.738,0.079,7.897,0l-2.314-15.77c0.458-1.799,2.209-2.526,3.601-1.534l9.565,12.804
				c0.916-0.755,4.847-4.667,5.545-5.546l-12.779-9.545c-0.942-1.598-0.209-3.351,1.485-3.623l15.794,2.291
				c0.101-1.083,0.131-6.669,0-7.841l-15.793,2.285c-1.791-0.471-2.507-2.229-1.494-3.618l12.781-9.545
				c-0.772-0.878-4.648-4.866-5.545-5.545L91.47,34.65c-1.596,0.926-3.34,0.19-3.607-1.503l2.264-15.82
				c-0.549-0.05-2.079-0.077-3.658-0.077C84.71,17.25,82.892,17.283,82.307,17.35"
            />
          </defs>
          <clipPath id="SVGIDB_92_">
            <use xlink:href="#SVGIDB_91_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_93_"
            cx="-156"
            cy="571"
            r="1"
            gradientTransform="matrix(1116.068 455.1087 -455.1087 -205.8507 434059.625 188579.9063)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#B1B1B1" />
            <stop offset="0.5272" style="stop-color:#A1A1A1" />
            <stop offset="1" style="stop-color:#B8B8B8" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_92_)"
            fill="url(#SVGIDB_93_)"
            points="-1517.102,-646.74 111.208,17.25 1689.561,731.156
			61.252,67.167 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_94_"
              d="M82.342,17.243l2.273,15.995c-0.467,1.766-2.197,2.474-3.569,1.486l-9.716-12.92
				c-0.999,0.781-4.792,4.654-5.497,5.496l12.914,9.699c0.926,1.575,0.211,3.3-1.449,3.582l-16.026-2.269
				c-0.131,1.179-0.129,6.576,0,7.773l15.978-2.271c1.775,0.454,2.493,2.177,1.527,3.553l-12.945,9.729
				c0.723,0.922,4.52,4.702,5.499,5.499l9.687-12.896c1.578-0.94,3.311-0.227,3.599,1.433l-2.299,16.017
				c1.139,0.13,6.622,0.081,7.827,0L87.85,51.19c0.455-1.783,2.191-2.503,3.57-1.52l9.711,12.924
				c0.953-0.786,4.772-4.584,5.496-5.499l-12.898-9.691c-0.932-1.585-0.207-3.321,1.472-3.591l15.983,2.272
				c0.105-1.126,0.136-6.554,0-7.772l-15.982,2.265c-1.774-0.467-2.483-2.209-1.48-3.585l12.901-9.692
				c-0.803-0.913-4.565-4.792-5.498-5.497l-9.702,12.914c-1.583,0.917-3.311,0.189-3.574-1.49l2.244-16.006
				c-0.575-0.053-2.107-0.081-3.675-0.081C84.703,17.141,82.944,17.174,82.342,17.243"
            />
          </defs>
          <clipPath id="SVGIDB_95_">
            <use xlink:href="#SVGIDB_94_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_96_"
            cx="-155.999"
            cy="571.002"
            r="0.9988"
            gradientTransform="matrix(571.4449 243.9213 -243.9213 -83.6024 228510.5938 85830.8359)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#B4B3B3" />
            <stop offset="0.5272" style="stop-color:#A3A3A3" />
            <stop offset="1" style="stop-color:#BBBBBA" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_95_)"
            fill="url(#SVGIDB_96_)"
            points="-739.468,-274.461 61.141,67.279 911.929,358.881
			111.32,17.141 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_97_"
              d="M82.376,17.136l2.253,16.184c-0.462,1.75-2.176,2.452-3.537,1.473l-9.862-13.04
				c-1.036,0.81-4.716,4.572-5.447,5.448l13.032,9.845c0.917,1.562,0.209,3.27-1.436,3.55l-16.214-2.25
				c-0.135,1.225-0.134,6.461,0,7.705L77.332,43.8c1.759,0.449,2.471,2.157,1.513,3.521l-13.063,9.874
				c0.749,0.957,4.433,4.623,5.45,5.45l9.833-13.014c1.565-0.932,3.281-0.226,3.566,1.419l-2.278,16.206
				c1.183,0.135,6.506,0.084,7.756,0l-2.273-16.148c0.45-1.767,2.17-2.48,3.536-1.507l9.858,13.043c0.99-0.815,4.695-4.5,5.448-5.45
				l-13.017-9.837c-0.924-1.571-0.205-3.292,1.458-3.558l16.171,2.253c0.11-1.17,0.141-6.44,0-7.706l-16.17,2.247
				c-1.758-0.463-2.461-2.19-1.466-3.552l13.02-9.84c-0.834-0.948-4.48-4.715-5.449-5.448l-9.849,13.032
				c-1.568,0.91-3.281,0.189-3.542-1.475l2.226-16.193c-0.602-0.056-2.127-0.085-3.68-0.085
				C84.705,17.032,82.998,17.065,82.376,17.136"
            />
          </defs>
          <clipPath id="SVGIDB_98_">
            <use xlink:href="#SVGIDB_97_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_99_"
            cx="-156"
            cy="570.999"
            r="1.0005"
            gradientTransform="matrix(228.2925 101.8576 -101.8576 -24.5774 93860.4688 29965.6602)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#B6B6B6" />
            <stop offset="0.5272" style="stop-color:#A5A5A5" />
            <stop offset="1" style="stop-color:#BDBDBD" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_98_)"
            fill="url(#SVGIDB_99_)"
            points="-244.126,-68.761 61.03,67.391 416.587,153.184
			111.431,17.032 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_100_"
              d="M82.41,17.03l2.235,16.371c-0.459,1.734-2.158,2.429-3.505,1.46l-10.009-13.16
				c-1.074,0.841-4.641,4.493-5.4,5.401l13.153,9.992c0.909,1.547,0.207,3.239-1.423,3.516l-16.402-2.23
				c-0.141,1.27-0.138,6.347,0,7.637l16.355-2.232c1.742,0.445,2.448,2.137,1.499,3.488L65.73,57.294
				c0.778,0.993,4.347,4.545,5.403,5.402l9.98-13.133c1.549-0.924,3.25-0.224,3.533,1.406l-2.258,16.393
				c1.226,0.14,6.389,0.087,7.686,0l-2.252-16.337c0.445-1.75,2.15-2.456,3.503-1.491l10.005,13.161
				c1.026-0.846,4.619-4.416,5.4-5.402l-13.138-9.984c-0.915-1.555-0.203-3.261,1.446-3.525l16.358,2.233
				c0.115-1.214,0.148-6.324,0-7.637l-16.358,2.228c-1.742-0.46-2.438-2.169-1.453-3.52l13.14-9.986
				c-0.865-0.984-4.396-4.64-5.401-5.401l-9.996,13.153c-1.553,0.901-3.25,0.185-3.509-1.462l2.209-16.382
				c-0.628-0.057-2.14-0.088-3.674-0.088C84.716,16.922,83.052,16.957,82.41,17.03"
            />
          </defs>
          <clipPath id="SVGIDB_101_">
            <use xlink:href="#SVGIDB_100_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_102_"
            cx="-155.999"
            cy="570.999"
            r="1.0003"
            gradientTransform="matrix(143.0492 66.6248 -66.6248 -9.7996 60444.625 16031.2217)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#B9B9B8" />
            <stop offset="0.5272" style="stop-color:#A7A7A7" />
            <stop offset="1" style="stop-color:#C0C0C0" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_101_)"
            fill="url(#SVGIDB_102_)"
            points="-121.176,-17.308 60.918,67.502 293.639,101.732
			111.544,16.922 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_103_"
              d="M82.444,16.924l2.215,16.559c-0.453,1.718-2.137,2.407-3.472,1.446L71.032,21.65
				c-1.113,0.871-4.566,4.412-5.351,5.352l13.271,10.139c0.9,1.532,0.204,3.209-1.41,3.484l-16.589-2.211
				c-0.146,1.315-0.144,6.233,0,7.568l16.543-2.212c1.726,0.441,2.425,2.118,1.485,3.456L65.68,57.393
				c0.805,1.028,4.26,4.466,5.353,5.354l10.128-13.253c1.534-0.914,3.22-0.221,3.5,1.393l-2.238,16.581
				c1.27,0.146,6.273,0.091,7.615,0l-2.232-16.525c0.442-1.733,2.131-2.433,3.472-1.478l10.151,13.282
				c1.063-0.877,4.543-4.334,5.352-5.354L93.524,47.261c-0.907-1.541-0.201-3.229,1.432-3.492l16.547,2.213
				c0.118-1.256,0.152-6.209,0-7.568l-16.547,2.208c-1.725-0.455-2.416-2.148-1.439-3.487l13.26-10.133
				c-0.897-1.019-4.313-4.565-5.353-5.351L91.281,34.922c-1.539,0.893-3.22,0.184-3.476-1.448l2.189-16.569
				c-0.653-0.062-2.15-0.093-3.665-0.093C84.727,16.812,83.106,16.848,82.444,16.924"
            />
          </defs>
          <clipPath id="SVGIDB_104_">
            <use xlink:href="#SVGIDB_103_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_105_"
            cx="-155.999"
            cy="571.001"
            r="0.9993"
            gradientTransform="matrix(104.384 50.6872 -50.6872 -3.0097 45312.4844 9667.918)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#BBBBBB" />
            <stop offset="0.5272" style="stop-color:#A9A9A9" />
            <stop offset="1" style="stop-color:#C3C2C2" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_104_)"
            fill="url(#SVGIDB_105_)"
            points="-65.473,6.294 60.807,67.614 237.935,78.131
			111.655,16.812 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_106_"
              d="M82.478,16.817l2.195,16.748c-0.449,1.701-2.115,2.384-3.438,1.432L70.933,21.599
				c-1.152,0.901-4.491,4.331-5.303,5.304l13.391,10.285c0.891,1.519,0.202,3.18-1.397,3.452l-16.777-2.192
				c-0.151,1.36-0.149,6.119,0,7.5l16.731-2.193c1.71,0.437,2.402,2.098,1.47,3.423L65.629,57.492
				c0.833,1.064,4.175,4.387,5.305,5.306l10.274-13.372c1.521-0.907,3.19-0.22,3.467,1.38l-2.216,16.769
				c1.314,0.15,6.156,0.094,7.544,0l-2.211-16.714c0.437-1.717,2.11-2.411,3.439-1.464l10.297,13.4
				c1.1-0.906,4.467-4.25,5.303-5.305L93.456,47.214c-0.899-1.527-0.199-3.2,1.418-3.46l16.736,2.195
				c0.121-1.301,0.157-6.095,0-7.501l-16.736,2.189c-1.708-0.451-2.392-2.128-1.425-3.454l13.378-10.28
				c-0.926-1.054-4.227-4.49-5.304-5.304L91.234,34.991c-1.525,0.883-3.19,0.181-3.445-1.436L89.961,16.8
				c-0.68-0.064-2.164-0.097-3.66-0.097C84.736,16.703,83.159,16.74,82.478,16.817"
            />
          </defs>
          <clipPath id="SVGIDB_107_">
            <use xlink:href="#SVGIDB_106_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_108_"
            cx="-155.9995"
            cy="571"
            r="0.9999"
            gradientTransform="matrix(82.417 41.677 -41.677 0.937 36740.8164 6008.7554)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#BEBEBE" />
            <stop offset="0.5272" style="stop-color:#ABABAA" />
            <stop offset="1" style="stop-color:#C5C5C5" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_107_)"
            fill="url(#SVGIDB_108_)"
            points="-35.906,18.875 62.87,68.824 208.369,65.553
			109.593,15.604 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_109_"
              d="M82.513,16.711l2.176,16.936c-0.446,1.685-2.097,2.361-3.407,1.418L70.834,21.548
				c-1.191,0.931-4.415,4.251-5.256,5.255l13.51,10.433c0.884,1.504,0.202,3.149-1.383,3.419l-16.963-2.173
				c-0.157,1.406-0.155,6.005,0,7.432L77.66,43.74c1.694,0.433,2.379,2.079,1.457,3.392l-13.54,10.46
				c0.862,1.099,4.09,4.308,5.258,5.257l10.421-13.492c1.506-0.897,3.159-0.217,3.435,1.367l-2.197,16.957
				c1.357,0.155,6.039,0.098,7.474,0l-2.191-16.902c0.433-1.701,2.09-2.388,3.406-1.451l10.444,13.52
				c1.136-0.937,4.391-4.166,5.256-5.257L93.387,47.167c-0.89-1.512-0.197-3.17,1.405-3.427l16.924,2.175
				c0.126-1.344,0.163-5.98,0-7.433l-16.924,2.17c-1.692-0.447-2.369-2.109-1.412-3.421l13.498-10.428
				c-0.956-1.089-4.143-4.413-5.255-5.255L91.186,35.059c-1.509,0.876-3.159,0.18-3.411-1.422l2.153-16.943
				c-0.705-0.066-2.172-0.101-3.646-0.101C84.752,16.593,83.213,16.631,82.513,16.711"
            />
          </defs>
          <clipPath id="SVGIDB_110_">
            <use xlink:href="#SVGIDB_109_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_111_"
            cx="-156"
            cy="571.001"
            r="0.9995"
            gradientTransform="matrix(68.3857 35.9747 -35.9747 3.5638 31295.9883 3619.3521)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#C1C1C0" />
            <stop offset="0.5272" style="stop-color:#ADADAC" />
            <stop offset="1" style="stop-color:#C8C8C7" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_110_)"
            fill="url(#SVGIDB_111_)"
            points="-21.388,24.713 68.713,72.112 193.852,59.715
			103.75,12.317 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_112_"
              d="M82.547,16.604l2.156,17.124c-0.441,1.669-2.076,2.339-3.374,1.406L70.735,21.497
				c-1.228,0.96-4.34,4.17-5.207,5.207l13.628,10.579c0.876,1.489,0.199,3.119-1.369,3.387l-17.152-2.154
				c-0.162,1.451-0.159,5.89,0,7.364l17.107-2.154c1.677,0.428,2.357,2.058,1.442,3.359L65.527,57.691
				c0.889,1.134,4.003,4.228,5.209,5.209l10.567-13.611c1.492-0.889,3.129-0.215,3.402,1.354l-2.176,17.145
				c1.401,0.16,5.923,0.099,7.404,0l-2.171-17.091c0.43-1.684,2.07-2.365,3.373-1.437L101.726,62.9
				c1.172-0.968,4.315-4.084,5.208-5.21L93.319,47.119c-0.881-1.498-0.195-3.139,1.391-3.394l17.112,2.155
				c0.13-1.386,0.168-5.864,0-7.364L94.71,40.667c-1.675-0.442-2.347-2.089-1.397-3.389l13.617-10.574
				c-0.989-1.124-4.06-4.339-5.208-5.207l-10.583,13.63c-1.496,0.867-3.129,0.179-3.379-1.408l2.135-17.131
				c-0.732-0.068-2.184-0.104-3.638-0.104C84.763,16.484,83.267,16.522,82.547,16.604"
            />
          </defs>
          <clipPath id="SVGIDB_113_">
            <use xlink:href="#SVGIDB_112_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_114_"
            cx="-155.999"
            cy="571"
            r="0.9998"
            gradientTransform="matrix(58.5883 32.0305 -32.0305 5.4726 27515.4043 1914.0852)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#C3C3C3" />
            <stop offset="0.5272" style="stop-color:#AFAFAE" />
            <stop offset="1" style="stop-color:#CACACA" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_113_)"
            fill="url(#SVGIDB_114_)"
            points="-11.248,28.738 72.74,74.654 183.711,55.694 99.724,9.778
					"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_115_"
              d="M82.581,16.497l2.137,17.313c-0.437,1.653-2.056,2.316-3.341,1.391L70.636,21.446
				c-1.267,0.991-4.265,4.089-5.159,5.158l13.748,10.727c0.867,1.475,0.197,3.088-1.357,3.353l-17.339-2.135
				c-0.167,1.497-0.164,5.776,0,7.297l17.295-2.135c1.661,0.424,2.334,2.038,1.429,3.326L65.476,57.79
				c0.917,1.17,3.917,4.15,5.161,5.161l10.714-13.73c1.477-0.881,3.099-0.214,3.368,1.341l-2.155,17.332
				c1.445,0.165,5.806,0.103,7.334,0l-2.15-17.278c0.425-1.67,2.05-2.343,3.341-1.423l10.737,13.757
				c1.208-0.997,4.239-4,5.158-5.161L93.251,47.071c-0.873-1.483-0.194-3.108,1.377-3.361l17.301,2.136
				c0.134-1.43,0.173-5.749,0-7.296l-17.3,2.131c-1.66-0.437-2.324-2.068-1.385-3.356l13.737-10.721
				c-1.019-1.159-3.975-4.263-5.159-5.158L91.091,35.195c-1.481,0.859-3.098,0.177-3.346-1.394l2.117-17.318
				c-0.759-0.071-2.198-0.109-3.633-0.109C84.772,16.374,83.319,16.414,82.581,16.497"
            />
          </defs>
          <clipPath id="SVGIDB_116_">
            <use xlink:href="#SVGIDB_115_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_117_"
            cx="-156"
            cy="571"
            r="1"
            gradientTransform="matrix(51.3534 29.1499 -29.1499 6.9464 24741.9648 623.2181)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#C6C6C6" />
            <stop offset="0.5272" style="stop-color:#B1B0B0" />
            <stop offset="1" style="stop-color:#CDCDCD" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_116_)"
            fill="url(#SVGIDB_117_)"
            points="-3.769,31.656 75.661,76.743 176.233,52.777 96.804,7.69
					"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_118_"
              d="M82.615,16.391l2.118,17.501c-0.433,1.637-2.037,2.294-3.309,1.378L70.536,21.394
				c-1.305,1.021-4.189,4.009-5.11,5.111l13.867,10.873c0.858,1.461,0.196,3.059-1.343,3.321l-17.527-2.116
				c-0.172,1.542-0.169,5.662,0,7.228l17.483-2.115c1.645,0.421,2.311,2.019,1.415,3.294L65.425,57.889
				c0.944,1.205,3.832,4.071,5.112,5.112l10.861-13.849c1.463-0.872,3.069-0.211,3.337,1.329L82.599,68
				c1.489,0.171,5.69,0.107,7.264,0l-2.13-17.466c0.421-1.654,2.03-2.321,3.308-1.41l10.884,13.877
				c1.245-1.027,4.162-3.916,5.111-5.113L93.182,47.024c-0.864-1.469-0.192-3.078,1.364-3.329l17.489,2.117
				c0.139-1.473,0.179-5.634,0-7.229l-17.488,2.113c-1.644-0.433-2.302-2.048-1.371-3.323l13.856-10.868
				c-1.049-1.194-3.891-4.188-5.111-5.111L91.045,35.263c-1.467,0.851-3.069,0.176-3.314-1.38l2.098-17.506
				c-0.785-0.073-2.202-0.112-3.614-0.112C84.791,16.265,83.373,16.305,82.615,16.391"
            />
          </defs>
          <clipPath id="SVGIDB_119_">
            <use xlink:href="#SVGIDB_118_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_120_"
            cx="-156.0005"
            cy="571"
            r="1.0001"
            gradientTransform="matrix(45.7926 26.9649 -26.9649 8.1373 22626.8594 -397.657)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#C9C8C8" />
            <stop offset="0.5272" style="stop-color:#B2B2B2" />
            <stop offset="1" style="stop-color:#D0CFCF" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_119_)"
            fill="url(#SVGIDB_120_)"
            points="1.971,33.853 77.858,78.539 170.495,50.583 94.607,5.897
					"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_121_"
              d="M82.649,16.285l2.098,17.689c-0.428,1.621-2.016,2.27-3.276,1.364L70.437,21.343
				c-1.343,1.051-4.114,3.929-5.062,5.063l13.987,11.019c0.849,1.446,0.192,3.03-1.331,3.289l-17.714-2.096
				c-0.178,1.587-0.175,5.547,0,7.159l17.67-2.096c1.629,0.417,2.289,1.999,1.402,3.262L65.374,57.988
				c0.973,1.241,3.746,3.993,5.064,5.065l11.008-13.969c1.448-0.863,3.038-0.21,3.303,1.315l-2.115,17.708
				c1.533,0.175,5.573,0.109,7.194,0l-2.11-17.655c0.417-1.637,2.01-2.298,3.276-1.396l11.03,13.996
				c1.282-1.058,4.087-3.832,5.063-5.065l-13.973-11.01c-0.856-1.455-0.19-3.049,1.351-3.297l17.676,2.098
				c0.144-1.517,0.184-5.52,0-7.16l-17.676,2.093c-1.628-0.429-2.279-2.028-1.358-3.291l13.976-11.014
				c-1.08-1.23-3.807-4.113-5.062-5.063L90.997,35.332c-1.453,0.842-3.039,0.173-3.282-1.367l2.08-17.693
				c-0.811-0.076-2.208-0.117-3.598-0.117C84.808,16.155,83.427,16.196,82.649,16.285"
            />
          </defs>
          <clipPath id="SVGIDB_122_">
            <use xlink:href="#SVGIDB_121_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_123_"
            cx="-156"
            cy="571"
            r="1"
            gradientTransform="matrix(41.3853 25.2599 -25.2599 9.1345 20965.7715 -1233.0585)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#CBCBCB" />
            <stop offset="0.5272" style="stop-color:#B4B4B4" />
            <stop offset="1" style="stop-color:#D2D2D2" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_122_)"
            fill="url(#SVGIDB_123_)"
            points="6.509,35.549 79.555,80.132 165.955,48.889 92.909,4.305
					"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_124_"
              d="M82.684,16.179l2.079,17.877c-0.425,1.604-1.997,2.248-3.245,1.35l-11.18-14.114
				c-1.382,1.081-4.039,3.847-5.014,5.015L79.43,37.473c0.841,1.432,0.191,2.999-1.317,3.255l-17.902-2.076
				c-0.182,1.632-0.18,5.433,0,7.091l17.858-2.076c1.613,0.412,2.266,1.979,1.388,3.229L65.324,58.088
				c0.999,1.276,3.659,3.913,5.015,5.016l11.155-14.089c1.434-0.855,3.009-0.207,3.27,1.303l-2.095,17.895
				c1.577,0.18,5.457,0.113,7.124,0l-2.09-17.844c0.413-1.62,1.991-2.273,3.244-1.381l11.176,14.115
				c1.319-1.088,4.011-3.749,5.014-5.016L93.045,46.929c-0.848-1.44-0.188-3.018,1.338-3.263l17.865,2.078
				c0.146-1.561,0.19-5.405,0-7.092l-17.864,2.073c-1.612-0.424-2.258-2.007-1.345-3.258l14.096-11.16
				c-1.112-1.265-3.724-4.038-5.015-5.015L90.949,35.399c-1.437,0.835-3.008,0.172-3.248-1.352l2.062-17.881
				c-0.838-0.077-2.216-0.12-3.583-0.12C84.825,16.046,83.48,16.088,82.684,16.179"
            />
          </defs>
          <clipPath id="SVGIDB_125_">
            <use xlink:href="#SVGIDB_124_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_126_"
            cx="-155.9995"
            cy="571"
            r="0.9999"
            gradientTransform="matrix(37.8221 23.91 -23.91 9.9978 19639.0625 -1936.5957)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#CECECE" />
            <stop offset="0.5272" style="stop-color:#B6B6B6" />
            <stop offset="1" style="stop-color:#D5D5D5" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_125_)"
            fill="url(#SVGIDB_126_)"
            points="10.189,36.886 80.894,81.583 162.277,47.553 91.573,2.856
					"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_127_"
              d="M82.718,16.072l2.059,18.065c-0.42,1.588-1.976,2.226-3.211,1.337L70.239,21.24
				c-1.42,1.112-3.963,3.768-4.966,4.968l14.225,11.313c0.833,1.417,0.189,2.968-1.305,3.222l-18.089-2.058
				c-0.187,1.679-0.184,5.32,0,7.024l18.047-2.057c1.597,0.408,2.244,1.959,1.374,3.197L65.272,58.187
				c1.028,1.312,3.574,3.834,4.968,4.967l11.301-14.207c1.42-0.846,2.979-0.205,3.238,1.289l-2.075,18.083
				c1.62,0.186,5.34,0.117,7.054,0l-2.07-18.032c0.409-1.604,1.971-2.251,3.212-1.367l11.323,14.234
				c1.355-1.118,3.933-3.665,4.966-4.968L92.977,46.881c-0.839-1.425-0.185-2.988,1.325-3.23l18.053,2.059
				c0.15-1.604,0.194-5.29,0-7.025l-18.053,2.056c-1.596-0.421-2.234-1.988-1.331-3.226l14.215-11.307
				c-1.143-1.301-3.64-3.963-4.967-4.968L90.902,35.468c-1.423,0.826-2.978,0.17-3.215-1.34L89.73,16.06
				c-0.864-0.08-2.218-0.124-3.56-0.124C84.846,15.936,83.534,15.979,82.718,16.072"
            />
          </defs>
          <clipPath id="SVGIDB_128_">
            <use xlink:href="#SVGIDB_127_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_129_"
            cx="-155.9995"
            cy="571"
            r="0.9999"
            gradientTransform="matrix(35.0695 22.9454 -22.9454 10.8213 18658.9004 -2557.3105)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#D0D0D0" />
            <stop offset="0.5272" style="stop-color:#B8B8B7" />
            <stop offset="1" style="stop-color:#D7D7D7" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_128_)"
            fill="url(#SVGIDB_129_)"
            points="13.226,37.956 81.963,82.93 159.24,46.485 90.502,1.511
			"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_130_"
              d="M82.752,15.966l2.039,18.252c-0.415,1.573-1.955,2.204-3.178,1.324L70.14,21.189
				c-1.459,1.141-3.889,3.686-4.918,4.919l14.344,11.459c0.824,1.404,0.188,2.939-1.291,3.191l-18.277-2.039
				c-0.191,1.724-0.189,5.206,0,6.955l18.235-2.037c1.58,0.404,2.22,1.939,1.36,3.164L65.221,58.286
				c1.056,1.348,3.488,3.756,4.92,4.92l11.447-14.327c1.406-0.838,2.949-0.204,3.205,1.275L82.74,68.426
				c1.664,0.19,5.223,0.119,6.983,0l-2.05-18.221c0.405-1.588,1.951-2.228,3.179-1.353l11.47,14.353
				c1.392-1.148,3.858-3.582,4.918-4.92L92.908,46.834c-0.83-1.411-0.183-2.958,1.312-3.198l18.241,2.039
				c0.155-1.647,0.2-5.174,0-6.956L94.22,40.755c-1.58-0.417-2.212-1.967-1.318-3.192l14.335-11.455
				c-1.173-1.335-3.556-3.887-4.918-4.919L90.855,35.536c-1.409,0.817-2.948,0.168-3.184-1.327l2.025-18.254
				c-0.889-0.083-2.221-0.129-3.539-0.129C84.865,15.826,83.587,15.87,82.752,15.966"
            />
          </defs>
          <clipPath id="SVGIDB_131_">
            <use xlink:href="#SVGIDB_130_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_132_"
            cx="-156"
            cy="571"
            r="1"
            gradientTransform="matrix(32.7651 22.1725 -22.1725 11.5799 17858.0742 -3111.0374)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#D3D3D3" />
            <stop offset="0.5272" style="stop-color:#BAB9B9" />
            <stop offset="1" style="stop-color:#DADADA" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_131_)"
            fill="url(#SVGIDB_132_)"
            points="15.778,38.821 82.83,84.196 156.69,45.621 89.638,0.246
			"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_133_"
              d="M82.786,15.859L84.807,34.3c-0.412,1.556-1.937,2.181-3.147,1.31L70.041,21.139
				c-1.497,1.171-3.813,3.605-4.87,4.87l14.463,11.606c0.817,1.389,0.186,2.909-1.278,3.157l-18.464-2.018
				c-0.197,1.768-0.193,5.09,0,6.887l18.423-2.019c1.564,0.4,2.198,1.919,1.345,3.133l-14.489,11.63
				c1.083,1.383,3.401,3.677,4.87,4.871l11.595-14.447c1.391-0.828,2.918-0.2,3.172,1.264l-2.033,18.46
				c1.708,0.195,5.106,0.121,6.912,0l-2.028-18.41c0.4-1.571,1.93-2.206,3.145-1.339l11.617,14.472
				c1.429-1.178,3.782-3.498,4.869-4.872L92.84,46.787c-0.822-1.397-0.182-2.928,1.298-3.165l18.429,2.019
				c0.16-1.69,0.205-5.059,0-6.887L94.138,40.77c-1.563-0.413-2.189-1.947-1.304-3.16l14.455-11.601
				c-1.204-1.371-3.473-3.812-4.871-4.87l-11.61,14.465c-1.395,0.809-2.918,0.167-3.151-1.313l2.006-18.442
				c-0.915-0.085-2.222-0.132-3.514-0.132C84.888,15.717,83.641,15.762,82.786,15.859"
            />
          </defs>
          <clipPath id="SVGIDB_134_">
            <use xlink:href="#SVGIDB_133_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_135_"
            cx="-155.9995"
            cy="571.002"
            r="0.999"
            gradientTransform="matrix(30.8094 21.5499 -21.5499 12.2904 17197.4688 -3613.8276)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#D6D6D5" />
            <stop offset="0.5272" style="stop-color:#BBBBBB" />
            <stop offset="1" style="stop-color:#DCDCDC" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_134_)"
            fill="url(#SVGIDB_135_)"
            points="17.947,39.527 83.535,85.403 154.52,44.918 88.933,-0.958
					"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_136_"
              d="M82.82,15.753l2.001,18.629c-0.407,1.54-1.916,2.158-3.114,1.296L69.942,21.087
				c-1.536,1.201-3.738,3.525-4.822,4.822l14.583,11.754c0.807,1.374,0.183,2.878-1.265,3.125l-18.652-2
				c-0.203,1.813-0.199,4.976,0,6.818l18.611-1.999c1.548,0.396,2.175,1.9,1.332,3.1l-14.61,11.777
				c1.112,1.419,3.317,3.598,4.823,4.823l11.742-14.566c1.376-0.82,2.888-0.198,3.139,1.25l-2.012,18.648
				c1.75,0.2,4.989,0.125,6.841,0l-2.008-18.598c0.396-1.555,1.91-2.183,3.113-1.325l11.763,14.591
				c1.466-1.208,3.707-3.415,4.822-4.823l-14.57-11.745c-0.814-1.382-0.18-2.897,1.284-3.133l18.618,2.001
				c0.163-1.733,0.21-4.945,0-6.819l-18.618,1.997c-1.547-0.408-2.166-1.928-1.291-3.128l14.575-11.748
				c-1.236-1.405-3.388-3.736-4.822-4.822L90.76,35.672c-1.38,0.801-2.887,0.166-3.118-1.299l1.988-18.63
				c-0.941-0.087-2.222-0.135-3.488-0.135C84.911,15.608,83.695,15.653,82.82,15.753"
            />
          </defs>
          <clipPath id="SVGIDB_137_">
            <use xlink:href="#SVGIDB_136_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_138_"
            cx="-155.999"
            cy="571.001"
            r="0.9993"
            gradientTransform="matrix(29.1301 21.0474 -21.0474 12.9647 16648.6035 -4077.248)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#D8D8D8" />
            <stop offset="0.5272" style="stop-color:#BDBDBD" />
            <stop offset="1" style="stop-color:#DFDFDF" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_137_)"
            fill="url(#SVGIDB_138_)"
            points="19.814,40.104 84.112,86.562 152.653,44.342
			88.355,-2.115 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_139_"
              d="M82.855,15.646l1.98,18.817c-0.402,1.525-1.895,2.136-3.08,1.284L69.842,21.036
				c-1.574,1.231-3.663,3.444-4.773,4.774l14.702,11.9c0.799,1.36,0.182,2.848-1.252,3.092L59.68,38.821
				c-0.207,1.859-0.204,4.863,0,6.751l18.799-1.979c1.532,0.391,2.153,1.879,1.317,3.067L65.069,58.584
				c1.138,1.454,3.23,3.518,4.774,4.775l11.888-14.687c1.362-0.81,2.858-0.196,3.106,1.238l-1.991,18.835
				c1.794,0.205,4.872,0.129,6.771,0l-1.988-18.786c0.392-1.539,1.891-2.16,3.081-1.312l11.909,14.711
				c1.503-1.239,3.63-3.332,4.774-4.775l-14.69-11.891c-0.804-1.368-0.178-2.867,1.271-3.1l18.806,1.981
				c0.167-1.777,0.216-4.83,0-6.752l-18.806,1.978c-1.531-0.403-2.143-1.907-1.277-3.094l14.694-11.895
				c-1.266-1.441-3.304-3.662-4.774-4.774L90.712,35.74c-1.365,0.792-2.857,0.164-3.085-1.285l1.97-18.817
				c-0.968-0.09-2.227-0.14-3.47-0.14C84.93,15.498,83.748,15.544,82.855,15.646"
            />
          </defs>
          <clipPath id="SVGIDB_140_">
            <use xlink:href="#SVGIDB_139_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_141_"
            cx="-155.999"
            cy="571.001"
            r="0.9993"
            gradientTransform="matrix(27.6735 20.6427 -20.6427 13.6118 16190.2676 -4509.9043)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#DBDBDB" />
            <stop offset="0.5272" style="stop-color:#BFBFBE" />
            <stop offset="1" style="stop-color:#E1E1E1" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_140_)"
            fill="url(#SVGIDB_141_)"
            points="21.438,40.578 84.586,87.683 151.031,43.87 87.882,-3.235
					"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_142_"
              d="M82.889,15.54l1.962,19.005c-0.399,1.509-1.877,2.113-3.048,1.27l-12.06-14.83
				c-1.611,1.261-3.587,3.364-4.725,4.726L79.84,37.757c0.79,1.346,0.179,2.818-1.239,3.059l-19.028-1.961
				c-0.212,1.905-0.208,4.749,0,6.684l18.988-1.961c1.515,0.387,2.129,1.86,1.304,3.035l-14.847,12.07
				c1.167,1.489,3.143,3.44,4.726,4.726l12.035-14.805c1.347-0.803,2.827-0.194,3.074,1.224l-1.972,19.023
				c1.838,0.211,4.756,0.132,6.701,0l-1.967-18.973c0.388-1.523,1.87-2.138,3.048-1.299l12.056,14.83
				c1.538-1.269,3.554-3.248,4.724-4.727L92.635,46.644c-0.797-1.353-0.177-2.836,1.257-3.066l18.995,1.961
				c0.171-1.821,0.22-4.715,0-6.684l-18.994,1.96c-1.515-0.4-2.121-1.888-1.263-3.063l14.812-12.041
				c-1.297-1.476-3.22-3.587-4.725-4.726L90.666,35.809c-1.352,0.784-2.828,0.161-3.053-1.272l1.951-19.004
				c-0.994-0.093-2.228-0.144-3.446-0.144C84.952,15.389,83.801,15.436,82.889,15.54"
            />
          </defs>
          <clipPath id="SVGIDB_143_">
            <use xlink:href="#SVGIDB_142_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_144_"
            cx="-155.999"
            cy="571"
            r="0.9997"
            gradientTransform="matrix(26.3988 20.3187 -20.3187 14.2385 15806.4199 -4918.2729)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#DDDDDD" />
            <stop offset="0.5272" style="stop-color:#C1C0C0" />
            <stop offset="1" style="stop-color:#E4E4E4" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_143_)"
            fill="url(#SVGIDB_144_)"
            points="22.86,40.968 84.975,88.776 149.608,43.483 87.494,-4.325
					"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_145_"
              d="M82.923,15.434l1.942,19.193c-0.394,1.492-1.856,2.091-3.016,1.256L69.644,20.934
				c-1.65,1.29-3.512,3.283-4.677,4.677l14.94,12.194c0.783,1.331,0.178,2.787-1.224,3.027l-19.216-1.943
				c-0.217,1.95-0.213,4.634,0,6.615l19.176-1.941c1.499,0.384,2.106,1.84,1.289,3.002L64.967,58.782
				c1.194,1.525,3.057,3.362,4.678,4.678l12.181-14.924c1.334-0.794,2.797-0.192,3.041,1.211l-1.951,19.211
				c1.882,0.215,4.639,0.134,6.631,0l-1.948-19.162c0.385-1.507,1.852-2.115,3.016-1.285l12.203,14.948
				c1.575-1.298,3.478-3.164,4.677-4.678L92.566,46.596c-0.787-1.338-0.174-2.806,1.244-3.034l19.183,1.942
				c0.175-1.863,0.226-4.599,0-6.615l-19.182,1.94c-1.498-0.395-2.099-1.867-1.25-3.03l14.932-12.188
				c-1.328-1.511-3.135-3.51-4.677-4.677L90.618,35.877c-1.337,0.775-2.797,0.159-3.02-1.258l1.933-19.193
				c-1.02-0.094-2.227-0.147-3.418-0.147C84.977,15.279,83.855,15.327,82.923,15.434"
            />
          </defs>
          <clipPath id="SVGIDB_146_">
            <use xlink:href="#SVGIDB_145_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_147_"
            cx="-155.999"
            cy="571"
            r="0.9997"
            gradientTransform="matrix(25.2751 20.0627 -20.0627 14.8503 15484.9268 -5307.54)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#E0E0E0" />
            <stop offset="0.5272" style="stop-color:#C2C2C2" />
            <stop offset="1" style="stop-color:#E6E6E6" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_146_)"
            fill="url(#SVGIDB_147_)"
            points="24.116,41.285 85.292,89.844 148.353,43.167
			87.177,-5.393 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_148_"
              d="M82.957,15.327l1.923,19.382c-0.39,1.476-1.836,2.067-2.983,1.242L69.545,20.882
				c-1.689,1.321-3.437,3.203-4.629,4.63l15.059,12.34c0.774,1.317,0.177,2.758-1.211,2.994l-19.403-1.923
				c-0.222,1.996-0.219,4.52,0,6.547l19.364-1.921c1.483,0.379,2.084,1.82,1.276,2.97L64.916,58.881
				c1.222,1.56,2.972,3.282,4.629,4.63l12.329-15.044c1.319-0.785,2.767-0.19,3.007,1.198l-1.93,19.4
				c1.926,0.22,4.523,0.137,6.561,0l-1.927-19.352c0.38-1.49,1.831-2.092,2.983-1.27l12.349,15.068
				c1.612-1.33,3.401-3.081,4.629-4.63L92.498,46.549c-0.779-1.325-0.173-2.776,1.23-3.001L113.1,45.47
				c0.179-1.907,0.231-4.484,0-6.546l-19.371,1.919c-1.482-0.39-2.076-1.846-1.236-2.996l15.051-12.335
				c-1.358-1.546-3.051-3.435-4.628-4.63L90.571,35.945c-1.323,0.767-2.767,0.158-2.988-1.245l1.914-19.379
				c-1.046-0.097-2.226-0.151-3.391-0.151C85.001,15.17,83.909,15.219,82.957,15.327"
            />
          </defs>
          <clipPath id="SVGIDB_149_">
            <use xlink:href="#SVGIDB_148_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_150_"
            cx="-155.9985"
            cy="571.002"
            r="0.9988"
            gradientTransform="matrix(24.2776 19.8644 -19.8644 15.4513 15216.1309 -5681.6445)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#E3E3E3" />
            <stop offset="0.5272" style="stop-color:#C4C4C4" />
            <stop offset="1" style="stop-color:#E9E9E8" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_149_)"
            fill="url(#SVGIDB_150_)"
            points="25.233,41.543 85.549,90.895 147.236,42.912 86.92,-6.439
					"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_151_"
              d="M82.991,15.22l1.904,19.57c-0.386,1.46-1.816,2.046-2.951,1.229L69.446,20.831
				c-1.728,1.351-3.362,3.122-4.581,4.581l15.179,12.487c0.765,1.303,0.174,2.728-1.198,2.962l-19.591-1.904
				c-0.228,2.041-0.223,4.405,0,6.479l19.551-1.903c1.467,0.376,2.061,1.801,1.262,2.938L64.865,58.98
				c1.25,1.596,2.886,3.204,4.581,4.582l12.475-15.163c1.305-0.777,2.737-0.188,2.976,1.185l-1.911,19.587
				c1.97,0.225,4.406,0.141,6.491,0l-1.906-19.54c0.375-1.473,1.809-2.068,2.95-1.256l12.495,15.187
				c1.649-1.36,3.326-2.998,4.581-4.582L92.43,46.502c-0.771-1.311-0.171-2.746,1.217-2.969l19.559,1.903
				c0.184-1.95,0.237-4.369,0-6.479l-19.559,1.902c-1.466-0.387-2.053-1.827-1.223-2.964l15.172-12.483
				c-1.39-1.58-2.968-3.36-4.581-4.581L90.523,36.013c-1.307,0.759-2.736,0.157-2.954-1.231l1.896-19.566
				c-1.074-0.1-2.229-0.156-3.369-0.156C85.022,15.06,83.961,15.11,82.991,15.22"
            />
          </defs>
          <clipPath id="SVGIDB_152_">
            <use xlink:href="#SVGIDB_151_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_153_"
            cx="-155.998"
            cy="571.002"
            r="0.9986"
            gradientTransform="matrix(23.3886 19.7173 -19.7173 16.0461 14993.4385 -6044.231)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#E5E5E5" />
            <stop offset="0.5272" style="stop-color:#C6C6C5" />
            <stop offset="1" style="stop-color:#EBEBEB" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_152_)"
            fill="url(#SVGIDB_153_)"
            points="26.232,41.749 85.755,91.929 146.238,42.707
			86.715,-7.473 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_154_"
              d="M83.026,15.114l1.883,19.758c-0.381,1.443-1.795,2.023-2.917,1.215L69.347,20.78
				c-1.766,1.381-3.286,3.042-4.533,4.533l15.298,12.634c0.757,1.288,0.172,2.697-1.185,2.929l-19.778-1.885
				c-0.233,2.086-0.229,4.291,0,6.411l19.739-1.883c1.451,0.371,2.039,1.78,1.249,2.905L64.814,59.08
				c1.278,1.63,2.8,3.124,4.533,4.532L81.969,48.33c1.29-0.768,2.706-0.186,2.942,1.172l-1.89,19.775c2.013,0.23,4.29,0.144,6.421,0
				l-1.887-19.728c0.372-1.457,1.791-2.046,2.918-1.243l12.642,15.306c1.686-1.389,3.25-2.914,4.533-4.533L92.361,46.454
				c-0.762-1.295-0.168-2.715,1.205-2.936l19.746,1.884c0.188-1.994,0.243-4.254,0-6.411l-19.746,1.882
				c-1.45-0.382-2.031-1.806-1.21-2.931l15.291-12.629c-1.42-1.616-2.883-3.285-4.532-4.533L90.476,36.081
				c-1.294,0.751-2.706,0.155-2.923-1.217l1.879-19.754c-1.099-0.102-2.223-0.16-3.335-0.16
				C85.051,14.95,84.016,15.001,83.026,15.114"
            />
          </defs>
          <clipPath id="SVGIDB_155_">
            <use xlink:href="#SVGIDB_154_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_156_"
            cx="-155.999"
            cy="571.002"
            r="0.9989"
            gradientTransform="matrix(22.5944 19.6168 -19.6168 16.6392 14812.1377 -6398.5728)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#E8E8E8" />
            <stop offset="0.5272" style="stop-color:#C8C7C7" />
            <stop offset="1" style="stop-color:#EDEDED" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_155_)"
            fill="url(#SVGIDB_156_)"
            points="27.131,41.911 85.917,92.95 145.34,42.546 86.554,-8.493
					"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_157_"
              d="M83.06,15.008l1.865,19.946c-0.377,1.427-1.777,2-2.887,1.201L69.247,20.728
				c-1.803,1.412-3.211,2.961-4.483,4.485l15.417,12.781c0.748,1.274,0.17,2.667-1.172,2.896l-19.967-1.865
				c-0.237,2.131-0.233,4.177,0,6.343l19.928-1.863c1.435,0.366,2.016,1.76,1.234,2.872L64.763,59.179
				c1.306,1.666,2.714,3.046,4.485,4.485l12.769-15.402c1.275-0.76,2.676-0.184,2.908,1.158l-1.869,19.964
				c2.058,0.235,4.173,0.147,6.351,0l-1.866-19.917c0.367-1.441,1.77-2.023,2.885-1.228l12.788,15.425
				c1.723-1.421,3.174-2.831,4.485-4.486L92.293,46.406c-0.753-1.281-0.167-2.685,1.191-2.902l19.935,1.864
				c0.191-2.037,0.247-4.139,0-6.343l-19.935,1.862c-1.434-0.378-2.008-1.785-1.197-2.898l15.411-12.776
				c-1.452-1.651-2.799-3.208-4.484-4.485L90.429,36.15c-1.28,0.741-2.677,0.153-2.89-1.204l1.859-19.942
				c-1.124-0.104-2.221-0.163-3.306-0.163C85.076,14.841,84.069,14.893,83.06,15.008"
            />
          </defs>
          <clipPath id="SVGIDB_158_">
            <use xlink:href="#SVGIDB_157_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_159_"
            cx="-155.999"
            cy="571.001"
            r="0.9993"
            gradientTransform="matrix(21.8837 19.5591 -19.5591 17.2346 14668.3496 -6747.5337)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#EBEBEA" />
            <stop offset="0.5272" style="stop-color:#C9C9C9" />
            <stop offset="1" style="stop-color:#F0F0F0" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_158_)"
            fill="url(#SVGIDB_159_)"
            points="27.943,42.035 86.041,93.961 144.528,42.425
			86.431,-9.501 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_160_"
              d="M83.094,14.902l1.845,20.134c-0.373,1.411-1.756,1.977-2.853,1.188L69.148,20.677
				c-1.842,1.442-3.135,2.881-4.436,4.438l15.537,12.928c0.74,1.259,0.168,2.638-1.159,2.863l-20.154-1.846
				c-0.242,2.177-0.238,4.063,0,6.274l20.116-1.844c1.419,0.363,1.994,1.741,1.22,2.841l-15.56,12.948
				c1.333,1.702,2.628,2.966,4.437,4.437l12.915-15.521c1.261-0.752,2.646-0.182,2.877,1.145l-1.85,20.151
				c2.102,0.241,4.057,0.151,6.281,0l-1.846-20.105c0.363-1.425,1.751-2,2.853-1.215l12.934,15.545
				c1.76-1.451,3.098-2.748,4.437-4.437L92.225,46.359c-0.746-1.267-0.165-2.655,1.177-2.871l20.124,1.845
				c0.195-2.079,0.252-4.023,0-6.274l-20.124,1.844c-1.418-0.374-1.985-1.766-1.183-2.866l15.53-12.923
				c-1.482-1.688-2.715-3.134-4.436-4.438L90.381,36.218c-1.264,0.734-2.646,0.151-2.857-1.19l1.841-20.129
				c-1.15-0.107-2.217-0.168-3.274-0.168C85.103,14.731,84.123,14.784,83.094,14.902"
            />
          </defs>
          <clipPath id="SVGIDB_161_">
            <use xlink:href="#SVGIDB_160_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_162_"
            cx="-155.998"
            cy="571.001"
            r="0.999"
            gradientTransform="matrix(21.2446 19.5393 -19.5393 17.8339 14557.3184 -7092.8579)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#EDEDED" />
            <stop offset="0.5272" style="stop-color:#CBCBCB" />
            <stop offset="1" style="stop-color:#F2F2F2" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_161_)"
            fill="url(#SVGIDB_162_)"
            points="28.68,42.126 86.131,94.965 143.792,42.336
			86.341,-10.503 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_163_"
              d="M83.128,14.795l1.826,20.322c-0.369,1.396-1.736,1.955-2.821,1.174L69.049,20.627
				c-1.88,1.47-3.06,2.799-4.388,4.387l15.656,13.075c0.731,1.245,0.166,2.608-1.145,2.831L58.83,39.093
				c-0.247,2.222-0.243,3.949,0,6.206l20.304-1.824c1.402,0.358,1.97,1.721,1.207,2.808l-15.68,13.094
				c1.362,1.737,2.543,2.888,4.388,4.388l13.062-15.64c1.248-0.742,2.616-0.18,2.844,1.132l-1.829,20.339
				c2.145,0.246,3.941,0.154,6.21,0l-1.825-20.293c0.359-1.409,1.731-1.978,2.821-1.201l13.08,15.663
				c1.797-1.48,3.023-2.664,4.389-4.388L92.156,46.312c-0.736-1.252-0.163-2.625,1.164-2.838l20.312,1.825
				c0.2-2.123,0.257-3.908,0-6.206L93.32,40.917c-1.401-0.369-1.962-1.746-1.169-2.833l15.65-13.07
				c-1.513-1.721-2.632-3.058-4.389-4.387L90.335,36.286c-1.252,0.725-2.617,0.149-2.826-1.177l1.823-20.316
				c-1.177-0.109-2.215-0.171-3.246-0.171C85.128,14.622,84.176,14.675,83.128,14.795"
            />
          </defs>
          <clipPath id="SVGIDB_164_">
            <use xlink:href="#SVGIDB_163_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_165_"
            cx="-155.999"
            cy="571"
            r="0.9997"
            gradientTransform="matrix(20.6666 19.5522 -19.5522 18.4377 14474.5127 -7435.6099)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#F0F0F0" />
            <stop offset="0.5272" style="stop-color:#CDCDCC" />
            <stop offset="1" style="stop-color:#F5F5F5" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_164_)"
            fill="url(#SVGIDB_165_)"
            points="29.352,42.187 86.191,95.961 143.12,42.277
			86.281,-11.497 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_166_"
              d="M83.162,14.688l1.807,20.511c-0.365,1.379-1.717,1.933-2.789,1.16L68.951,20.575
				c-1.92,1.502-2.986,2.719-4.34,4.34l15.774,13.221c0.724,1.231,0.165,2.578-1.132,2.798l-20.529-1.807
				c-0.253,2.267-0.249,3.835,0,6.138l20.492-1.805c1.386,0.354,1.947,1.701,1.192,2.775L64.611,59.476
				c1.388,1.773,2.456,2.81,4.34,4.341l13.208-15.76c1.233-0.735,2.586-0.177,2.811,1.119l-1.809,20.527
				c2.189,0.25,3.825,0.156,6.14,0l-1.804-20.482c0.354-1.393,1.71-1.954,2.787-1.188l13.228,15.784
				c1.833-1.511,2.945-2.581,4.34-4.341L92.088,46.264c-0.728-1.238-0.161-2.594,1.15-2.805l20.5,1.806
				c0.204-2.167,0.263-3.794,0-6.138l-20.5,1.805c-1.385-0.365-1.94-1.726-1.156-2.8l15.77-13.217
				c-1.544-1.757-2.547-2.983-4.341-4.34L90.287,36.354c-1.236,0.717-2.586,0.148-2.792-1.163l1.804-20.503
				c-1.203-0.112-2.213-0.176-3.216-0.176C85.154,14.512,84.23,14.567,83.162,14.688"
            />
          </defs>
          <clipPath id="SVGIDB_167_">
            <use xlink:href="#SVGIDB_166_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_168_"
            cx="-155.998"
            cy="571.001"
            r="0.999"
            gradientTransform="matrix(20.1406 19.5934 -19.5934 19.0461 14415.9609 -7776.5918)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#F2F2F2" />
            <stop offset="0.5272" style="stop-color:#CECECE" />
            <stop offset="1" style="stop-color:#F7F7F7" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_167_)"
            fill="url(#SVGIDB_168_)"
            points="29.965,42.222 86.225,96.953 142.507,42.243
			86.247,-12.488 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_169_"
              d="M83.197,14.582l1.786,20.698c-0.36,1.364-1.696,1.91-2.755,1.147L68.852,20.524
				c-1.959,1.531-2.911,2.638-4.293,4.292l15.894,13.368c0.715,1.217,0.163,2.547-1.118,2.766l-20.717-1.789
				c-0.258,2.312-0.253,3.72,0,6.07l20.68-1.786c1.37,0.35,1.925,1.681,1.179,2.743L64.559,59.576
				c1.417,1.807,2.371,2.73,4.293,4.291l13.355-15.879c1.218-0.725,2.556-0.175,2.778,1.107l-1.788,20.714
				c2.233,0.256,3.708,0.16,6.069,0l-1.785-20.67c0.352-1.376,1.692-1.932,2.755-1.173l13.375,15.901
				c1.87-1.541,2.869-2.496,4.292-4.291l-15.884-13.36c-0.719-1.223-0.159-2.564,1.137-2.772l20.689,1.787
				c0.208-2.211,0.267-3.679,0-6.07l-20.688,1.786c-1.37-0.361-1.918-1.706-1.143-2.768l15.889-13.363
				c-1.575-1.792-2.463-2.908-4.292-4.292L90.239,36.423c-1.221,0.708-2.555,0.145-2.759-1.15l1.786-20.691
				c-1.23-0.114-2.209-0.179-3.185-0.179C85.18,14.403,84.283,14.458,83.197,14.582"
            />
          </defs>
          <clipPath id="SVGIDB_170_">
            <use xlink:href="#SVGIDB_169_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_171_"
            cx="-155.999"
            cy="571.001"
            r="0.9993"
            gradientTransform="matrix(19.659 19.659 -19.659 19.659 14378.3086 -8116.2852)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#F5F5F5" />
            <stop offset="0.5272" style="stop-color:#D0D0D0" />
            <stop offset="1" style="stop-color:#FAFAFA" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_170_)"
            :style="rearWheelClass"
            v-on:click="changeSeverity('rearWheel')"
            fill="url(#SVGIDB_171_)"
            points="30.529,42.234 86.236,97.941 141.943,42.234
			86.236,-13.473 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_172_"
              d="M84.827,46.4c0,0.779,0.632,1.411,1.412,1.411c0.779,0,1.411-0.632,1.411-1.411
				c0-0.779-0.632-1.41-1.411-1.41C85.459,44.99,84.827,45.621,84.827,46.4"
            />
          </defs>
          <clipPath id="SVGIDB_173_">
            <use xlink:href="#SVGIDB_172_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_174_"
            cx="-156"
            cy="571"
            r="1"
            gradientTransform="matrix(1.411 0 0 1.411 306.347 -759.2526)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#4F4F4F" />
            <stop offset="0.046" style="stop-color:#4F4F4F" />
            <stop offset="0.2388" style="stop-color:#4A4A4A" />
            <stop offset="0.4727" style="stop-color:#3B3B3B" />
            <stop offset="0.7277" style="stop-color:#232323" />
            <stop offset="0.9963" style="stop-color:#010101" />
            <stop offset="1" style="stop-color:#000000" />
          </radialGradient>
          <rect
            x="84.827"
            y="44.99"
            clip-path="url(#SVGIDB_173_)"
            fill="url(#SVGIDB_174_)"
            width="2.823"
            height="2.821"
          />
        </g>
        <g>
          <defs>
            <polygon
              id="SVGIDB_175_"
              points="85.719,45.501 85.2,46.4 85.719,47.3 86.758,47.3 87.277,46.4 86.758,45.501 			"
            />
          </defs>
          <clipPath id="SVGIDB_176_">
            <use xlink:href="#SVGIDB_175_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_177_"
            cx="-156"
            cy="571"
            r="0.9996"
            gradientTransform="matrix(0.9717 0 0 0.9717 237.817 -508.4163)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#CBCACA" />
            <stop offset="0.1261" style="stop-color:#C6C5C5" />
            <stop offset="0.279" style="stop-color:#B7B6B6" />
            <stop offset="0.446" style="stop-color:#9E9D9D" />
            <stop offset="0.6228" style="stop-color:#7C7B7B" />
            <stop offset="0.8058" style="stop-color:#515050" />
            <stop offset="0.8159" style="stop-color:#4E4D4D" />
            <stop offset="1" style="stop-color:#1A1A1A" />
          </radialGradient>
          <rect
            x="85.2"
            y="45.501"
            clip-path="url(#SVGIDB_176_)"
            fill="url(#SVGIDB_177_)"
            width="2.077"
            height="1.799"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_178_"
              d="M81.682,42.093c-0.742,0.241-1.148,1.036-0.906,1.778c0.241,0.741,1.036,1.147,1.778,0.905
				c0.741-0.24,1.147-1.036,0.905-1.777c-0.194-0.597-0.747-0.976-1.341-0.976C81.973,42.023,81.827,42.046,81.682,42.093"
            />
          </defs>
          <clipPath id="SVGIDB_179_">
            <use xlink:href="#SVGIDB_178_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_180_"
            cx="-156"
            cy="571"
            r="1"
            gradientTransform="matrix(0.4361 1.3419 -1.3419 0.4361 916.3789 3.7787)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#4F4F4F" />
            <stop offset="0.046" style="stop-color:#4F4F4F" />
            <stop offset="0.2388" style="stop-color:#4A4A4A" />
            <stop offset="0.4727" style="stop-color:#3B3B3B" />
            <stop offset="0.7277" style="stop-color:#232323" />
            <stop offset="0.9963" style="stop-color:#010101" />
            <stop offset="1" style="stop-color:#000000" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_179_)"
            fill="url(#SVGIDB_180_)"
            points="79.654,42.309 80.836,45.949 84.581,44.732 83.398,41.092
					"
          />
        </g>
        <g>
          <defs>
            <polygon
              id="SVGIDB_181_"
              points="81.101,43.218 81.423,44.207 82.439,44.423 83.134,43.65 82.812,42.662 81.796,42.447 			"
            />
          </defs>
          <clipPath id="SVGIDB_182_">
            <use xlink:href="#SVGIDB_181_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_183_"
            cx="-156"
            cy="571.001"
            r="0.9996"
            gradientTransform="matrix(0.3003 0.9241 -0.9241 0.3003 656.6228 16.1266)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#CBCACA" />
            <stop offset="0.1261" style="stop-color:#C6C5C5" />
            <stop offset="0.279" style="stop-color:#B7B6B6" />
            <stop offset="0.446" style="stop-color:#9E9D9D" />
            <stop offset="0.6228" style="stop-color:#7C7B7B" />
            <stop offset="0.8058" style="stop-color:#515050" />
            <stop offset="0.8159" style="stop-color:#4E4D4D" />
            <stop offset="1" style="stop-color:#1A1A1A" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_182_)"
            fill="url(#SVGIDB_183_)"
            points="80.52,42.636 81.295,45.021 83.715,44.234 82.94,41.85
			"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_184_"
              d="M82.835,37.458c-0.63,0.458-0.77,1.34-0.312,1.971c0.458,0.63,1.34,0.769,1.971,0.311
				c0.63-0.458,0.77-1.34,0.312-1.97c-0.276-0.38-0.706-0.582-1.143-0.582C83.376,37.188,83.085,37.276,82.835,37.458"
            />
          </defs>
          <clipPath id="SVGIDB_185_">
            <use xlink:href="#SVGIDB_184_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_186_"
            cx="-156"
            cy="571"
            r="1"
            gradientTransform="matrix(-1.1415 0.8293 -0.8293 -1.1415 379.1353 819.7933)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#4F4F4F" />
            <stop offset="0.046" style="stop-color:#4F4F4F" />
            <stop offset="0.2388" style="stop-color:#4A4A4A" />
            <stop offset="0.4727" style="stop-color:#3B3B3B" />
            <stop offset="0.7277" style="stop-color:#232323" />
            <stop offset="0.9963" style="stop-color:#010101" />
            <stop offset="1" style="stop-color:#000000" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_185_)"
            fill="url(#SVGIDB_186_)"
            points="84.159,35.667 80.634,38.228 83.17,41.719 86.695,39.158
					"
          />
        </g>
        <g>
          <defs>
            <polygon
              id="SVGIDB_187_"
              points="82.716,38.177 82.824,39.209 83.773,39.632 84.613,39.022 84.505,37.989 83.556,37.565 			"
            />
          </defs>
          <clipPath id="SVGIDB_188_">
            <use xlink:href="#SVGIDB_187_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_189_"
            cx="-155.9995"
            cy="571"
            r="0.9998"
            gradientTransform="matrix(-0.7861 0.5711 -0.5711 -0.7861 287.1318 576.5467)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#CBCACA" />
            <stop offset="0.1261" style="stop-color:#C6C5C5" />
            <stop offset="0.279" style="stop-color:#B7B6B6" />
            <stop offset="0.446" style="stop-color:#9E9D9D" />
            <stop offset="0.6228" style="stop-color:#7C7B7B" />
            <stop offset="0.8058" style="stop-color:#515050" />
            <stop offset="0.8159" style="stop-color:#4E4D4D" />
            <stop offset="1" style="stop-color:#1A1A1A" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_188_)"
            fill="url(#SVGIDB_189_)"
            points="83.958,36.663 81.733,38.279 83.372,40.534 85.596,38.918
					"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_190_"
              d="M87.6,37.746c-0.458,0.63-0.318,1.513,0.313,1.971c0.63,0.459,1.512,0.319,1.971-0.312
				c0.458-0.63,0.317-1.513-0.313-1.971c-0.25-0.182-0.54-0.269-0.828-0.269C88.307,37.165,87.877,37.367,87.6,37.746"
            />
          </defs>
          <clipPath id="SVGIDB_191_">
            <use xlink:href="#SVGIDB_190_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_192_"
            cx="-156"
            cy="571"
            r="1"
            gradientTransform="matrix(-1.1415 -0.8293 0.8293 -1.1415 -562.8844 561.0138)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#4F4F4F" />
            <stop offset="0.046" style="stop-color:#4F4F4F" />
            <stop offset="0.2388" style="stop-color:#4A4A4A" />
            <stop offset="0.4727" style="stop-color:#3B3B3B" />
            <stop offset="0.7277" style="stop-color:#232323" />
            <stop offset="0.9963" style="stop-color:#010101" />
            <stop offset="1" style="stop-color:#000000" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_191_)"
            fill="url(#SVGIDB_192_)"
            points="91.774,38.205 88.248,35.644 85.71,39.136 89.236,41.698
					"
          />
        </g>
        <g>
          <defs>
            <polygon
              id="SVGIDB_193_"
              points="87.902,37.965 87.793,38.998 88.633,39.609 89.582,39.186 89.691,38.153 88.85,37.543 			"
            />
          </defs>
          <clipPath id="SVGIDB_194_">
            <use xlink:href="#SVGIDB_193_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_195_"
            cx="-156.002"
            cy="571"
            r="1.0007"
            gradientTransform="matrix(-0.7861 -0.5711 0.5711 -0.7861 -359.9843 398.3394)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#CBCACA" />
            <stop offset="0.1261" style="stop-color:#C6C5C5" />
            <stop offset="0.279" style="stop-color:#B7B6B6" />
            <stop offset="0.446" style="stop-color:#9E9D9D" />
            <stop offset="0.6228" style="stop-color:#7C7B7B" />
            <stop offset="0.8058" style="stop-color:#515050" />
            <stop offset="0.8159" style="stop-color:#4E4D4D" />
            <stop offset="1" style="stop-color:#1A1A1A" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_194_)"
            fill="url(#SVGIDB_195_)"
            points="90.673,38.257 88.449,36.641 86.811,38.896 89.035,40.512
					"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_196_"
              d="M88.991,42.961c-0.241,0.742,0.165,1.537,0.905,1.778c0.742,0.241,1.537-0.164,1.779-0.906
				c0.24-0.741-0.165-1.537-0.907-1.777c-0.145-0.048-0.292-0.07-0.436-0.07C89.737,41.986,89.184,42.365,88.991,42.961"
            />
          </defs>
          <clipPath id="SVGIDB_197_">
            <use xlink:href="#SVGIDB_196_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_198_"
            cx="-156"
            cy="571"
            r="1"
            gradientTransform="matrix(0.4361 -1.3419 1.3419 0.4361 -607.8682 -414.931)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#4F4F4F" />
            <stop offset="0.046" style="stop-color:#4F4F4F" />
            <stop offset="0.2388" style="stop-color:#4A4A4A" />
            <stop offset="0.4727" style="stop-color:#3B3B3B" />
            <stop offset="0.7277" style="stop-color:#232323" />
            <stop offset="0.9963" style="stop-color:#010101" />
            <stop offset="1" style="stop-color:#000000" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_197_)"
            fill="url(#SVGIDB_198_)"
            points="91.613,45.91 92.795,42.272 89.052,41.056 87.87,44.694
			"
          />
        </g>
        <g>
          <defs>
            <polygon
              id="SVGIDB_199_"
              points="89.638,42.625 89.317,43.614 90.011,44.385 91.027,44.169 91.349,43.182 90.653,42.409 			"
            />
          </defs>
          <clipPath id="SVGIDB_200_">
            <use xlink:href="#SVGIDB_199_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_201_"
            cx="-155.9985"
            cy="571.001"
            r="0.9991"
            gradientTransform="matrix(0.3003 -0.9241 0.9241 0.3003 -390.461 -272.2156)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#CBCACA" />
            <stop offset="0.1261" style="stop-color:#C6C5C5" />
            <stop offset="0.279" style="stop-color:#B7B6B6" />
            <stop offset="0.446" style="stop-color:#9E9D9D" />
            <stop offset="0.6228" style="stop-color:#7C7B7B" />
            <stop offset="0.8058" style="stop-color:#515050" />
            <stop offset="0.8159" style="stop-color:#4E4D4D" />
            <stop offset="1" style="stop-color:#1A1A1A" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_200_)"
            fill="url(#SVGIDB_201_)"
            points="91.155,44.982 91.93,42.598 89.511,41.812 88.736,44.196
					"
          />
        </g>
        <g>
          <path
            fill="#080808"
            :style="rearWheelClass"
            v-on:click="changeSeverity('rearWheel')"
            d="M86.229,80.028c20.914,0,37.868-16.962,37.868-37.876c0-20.913-16.954-37.867-37.868-37.867
			c-20.921,0-37.875,16.954-37.875,37.867C48.354,63.066,65.308,80.028,86.229,80.028 M86.229,14.358
			c15.35,0,27.794,12.444,27.794,27.794c0,15.35-12.444,27.803-27.794,27.803c-15.358,0-27.802-12.453-27.802-27.803
			C58.427,26.803,70.871,14.358,86.229,14.358"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_202_"
              d="M58.427,42.153c0-15.351,12.444-27.795,27.802-27.795c15.35,0,27.794,12.444,27.794,27.795
				c0,15.35-12.444,27.802-27.794,27.802C70.871,69.955,58.427,57.503,58.427,42.153 M85.759,4.297l0.445,1.44l-0.458,0.175
				L85.251,4.31c-0.272,0.007-0.545,0.008-0.815,0.02l0.497,1.428l-0.451,0.19l-0.553-1.587c-0.272,0.016-0.54,0.04-0.81,0.062
				l0.544,1.4L83.218,6.03L82.61,4.462c-0.27,0.025-0.538,0.057-0.807,0.089l0.593,1.382l-0.437,0.222l-0.661-1.54
				c-0.269,0.035-0.541,0.062-0.81,0.103l0.645,1.369l-0.429,0.237L79.99,4.806c-0.268,0.044-0.535,0.092-0.8,0.143l0.686,1.336
				l-0.42,0.251l-0.769-1.497c-0.267,0.053-0.528,0.117-0.791,0.177l0.732,1.31l-0.411,0.267L77.4,5.33
				c-0.265,0.063-0.53,0.123-0.792,0.191l0.781,1.291l-0.402,0.28L76.12,5.66c-0.262,0.073-0.524,0.145-0.783,0.222L76.16,7.14
				l-0.392,0.294l-0.92-1.407c-0.258,0.082-0.512,0.174-0.767,0.26l0.863,1.224l-0.382,0.308l-0.965-1.368
				c-0.255,0.09-0.51,0.182-0.763,0.279l0.907,1.194l-0.371,0.32l-1.009-1.329c-0.252,0.1-0.508,0.194-0.757,0.299l0.949,1.165
				l-0.359,0.333l-1.056-1.295c-0.248,0.108-0.494,0.222-0.739,0.335l0.983,1.122l-0.347,0.347l-1.102-1.259
				c-0.244,0.117-0.482,0.242-0.723,0.363l1.019,1.087l-0.334,0.357l-1.139-1.211c-0.24,0.125-0.483,0.247-0.721,0.378l1.06,1.052
				l-0.322,0.369l-1.177-1.169c-0.236,0.134-0.472,0.267-0.705,0.405l1.092,1.01l-0.31,0.38l-1.22-1.129
				c-0.23,0.141-0.454,0.29-0.681,0.437l1.12,0.967l-0.296,0.39l-1.254-1.083c-0.225,0.15-0.449,0.303-0.67,0.457l1.153,0.928
				l-0.282,0.4l-1.285-1.034c-0.222,0.158-0.447,0.311-0.664,0.473l1.189,0.889l-0.269,0.41l-1.32-0.988
				c-0.214,0.165-0.426,0.333-0.638,0.501l1.21,0.842l-0.253,0.419l-1.359-0.945c-0.208,0.172-0.408,0.353-0.612,0.529l1.235,0.796
				l-0.238,0.428l-1.383-0.891c-0.202,0.18-0.405,0.359-0.604,0.543l1.264,0.753l-0.223,0.437l-1.409-0.84
				c-0.197,0.187-0.396,0.371-0.588,0.561l1.29,0.709l-0.208,0.444l-1.44-0.791c-0.189,0.191-0.374,0.389-0.559,0.586l1.307,0.66
				l-0.192,0.45l-1.468-0.74c-0.183,0.198-0.359,0.403-0.537,0.605l1.329,0.614l-0.176,0.457l-1.486-0.686
				c-0.177,0.206-0.357,0.409-0.529,0.619l1.356,0.569l-0.16,0.463l-1.509-0.634c-0.169,0.212-0.337,0.423-0.502,0.639l1.37,0.521
				l-0.145,0.468l-1.536-0.584c-0.161,0.216-0.312,0.44-0.468,0.66l1.382,0.471l-0.128,0.472l-1.551-0.528
				c-0.153,0.223-0.303,0.447-0.452,0.673l1.401,0.423l-0.111,0.478l-1.564-0.472c-0.147,0.228-0.299,0.453-0.44,0.685l1.421,0.376
				l-0.094,0.48l-1.582-0.418c-0.138,0.233-0.272,0.468-0.405,0.704l1.426,0.324l-0.078,0.483l-1.602-0.365
				c-0.13,0.237-0.248,0.48-0.372,0.72l1.434,0.273l-0.061,0.486l-1.605-0.306c-0.122,0.242-0.244,0.483-0.361,0.728l1.449,0.224
				l-0.044,0.489l-1.614-0.25c-0.112,0.246-0.228,0.491-0.335,0.741l1.455,0.173l-0.027,0.489l-1.628-0.194
				c-0.103,0.249-0.198,0.502-0.296,0.753l1.453,0.122l-0.01,0.49l-1.631-0.137c-0.094,0.253-0.184,0.508-0.273,0.763l1.457,0.071
				l0.007,0.49l-1.628-0.079c-0.086,0.257-0.179,0.511-0.261,0.771l1.467,0.021l0.024,0.488l-1.631-0.022
				c-0.076,0.258-0.15,0.518-0.221,0.779l1.455-0.029l0.042,0.487l-1.637,0.035c-0.067,0.26-0.123,0.524-0.185,0.786l1.45-0.081
				l0.058,0.487l-1.622,0.09c-0.059,0.265-0.121,0.528-0.174,0.795l1.451-0.132l0.075,0.484l-1.615,0.146
				c-0.05,0.266-0.099,0.531-0.143,0.8l1.439-0.182l0.093,0.48l-1.616,0.205c-0.039,0.265-0.067,0.534-0.102,0.802l1.425-0.232
				l0.109,0.478l-1.598,0.259c-0.031,0.269-0.061,0.537-0.086,0.807l1.42-0.281l0.125,0.473l-1.583,0.314
				c-0.021,0.27-0.046,0.538-0.062,0.81l1.407-0.331l0.142,0.469l-1.575,0.37c-0.012,0.268-0.014,0.538-0.021,0.808l1.386-0.377
				l0.159,0.464l-1.558,0.424c-0.001,0.131-0.01,0.262-0.01,0.394c0,0.139,0.009,0.277,0.011,0.416l1.375-0.426l0.175,0.458
				l-1.538,0.476c0.008,0.271,0.009,0.543,0.021,0.813l1.364-0.475l0.19,0.451l-1.526,0.531c0.016,0.27,0.04,0.539,0.061,0.808
				l1.34-0.52l0.207,0.444l-1.508,0.585c0.025,0.269,0.056,0.537,0.086,0.806l1.325-0.568l0.222,0.437l-1.482,0.635
				c0.034,0.269,0.062,0.541,0.103,0.808l1.311-0.618l0.237,0.43l-1.464,0.688c0.045,0.267,0.093,0.532,0.143,0.798l1.282-0.659
				l0.251,0.42l-1.443,0.742c0.053,0.265,0.116,0.527,0.174,0.79l1.259-0.704l0.267,0.411l-1.412,0.789
				c0.063,0.264,0.12,0.53,0.189,0.792l1.242-0.753l0.279,0.403l-1.383,0.838c0.071,0.261,0.144,0.522,0.222,0.781l1.21-0.793
				l0.293,0.392l-1.361,0.891c0.081,0.259,0.174,0.511,0.259,0.766l1.18-0.832l0.308,0.381l-1.324,0.935
				c0.089,0.254,0.18,0.51,0.275,0.763l1.154-0.876l0.32,0.37l-1.287,0.978c0.098,0.252,0.193,0.507,0.297,0.756l1.125-0.917
				l0.333,0.359l-1.257,1.025c0.107,0.249,0.222,0.494,0.334,0.738l1.085-0.951l0.346,0.347l-1.221,1.07
				c0.116,0.243,0.239,0.484,0.36,0.725l1.053-0.988l0.357,0.335l-1.178,1.106c0.125,0.24,0.245,0.484,0.374,0.721l1.023-1.029
				l0.369,0.322l-1.139,1.147c0.133,0.236,0.267,0.47,0.404,0.703l0.981-1.059l0.38,0.309l-1.102,1.192
				c0.14,0.229,0.29,0.452,0.436,0.68l0.941-1.091l0.39,0.296l-1.056,1.224c0.149,0.225,0.299,0.45,0.453,0.672l0.905-1.125
				l0.4,0.282l-1.011,1.257c0.158,0.221,0.31,0.446,0.472,0.663l0.867-1.159l0.41,0.268l-0.967,1.293
				c0.163,0.215,0.332,0.427,0.5,0.637l0.822-1.181l0.419,0.253l-0.925,1.331c0.171,0.208,0.35,0.409,0.526,0.614l0.779-1.21
				l0.428,0.238l-0.874,1.357c0.18,0.203,0.357,0.407,0.54,0.607l0.739-1.241l0.437,0.223l-0.826,1.385
				c0.186,0.198,0.37,0.396,0.56,0.588l0.696-1.265l0.444,0.208l-0.78,1.419c0.192,0.19,0.389,0.373,0.585,0.559l0.65-1.286
				l0.45,0.192L60.564,70c0.199,0.183,0.402,0.362,0.604,0.54l0.605-1.31l0.457,0.177l-0.678,1.467
				c0.207,0.176,0.407,0.358,0.617,0.531l0.563-1.34l0.463,0.161l-0.627,1.492c0.211,0.169,0.424,0.337,0.638,0.502l0.515-1.354
				l0.468,0.144l-0.579,1.524c0.216,0.161,0.439,0.312,0.659,0.469l0.466-1.371l0.473,0.128l-0.524,1.538
				c0.223,0.154,0.446,0.307,0.672,0.457l0.42-1.393l0.477,0.112l-0.469,1.555c0.228,0.147,0.454,0.297,0.685,0.439l0.374-1.412
				l0.48,0.095l-0.416,1.576c0.232,0.138,0.467,0.271,0.702,0.405l0.323-1.42l0.484,0.078l-0.363,1.597
				c0.237,0.13,0.478,0.25,0.717,0.375l0.274-1.432l0.486,0.06l-0.306,1.605c0.242,0.121,0.482,0.246,0.728,0.363l0.224-1.451
				l0.489,0.045l-0.25,1.616c0.245,0.112,0.491,0.227,0.741,0.335l0.173-1.456l0.489,0.026l-0.194,1.633
				c0.248,0.104,0.502,0.198,0.753,0.297l0.122-1.459l0.49,0.009l-0.138,1.637c0.253,0.096,0.508,0.188,0.763,0.278l0.072-1.467
				l0.49-0.008l-0.08,1.638c0.257,0.088,0.512,0.179,0.772,0.261l0.021-1.477l0.488-0.024l-0.022,1.645
				c0.258,0.078,0.519,0.15,0.78,0.222l-0.03-1.469l0.487-0.042l0.035,1.65c0.261,0.069,0.524,0.126,0.787,0.189l-0.082-1.468
				l0.487-0.058l0.092,1.64c0.264,0.06,0.527,0.125,0.795,0.179l-0.134-1.474l0.484-0.075l0.148,1.638
				c0.267,0.049,0.532,0.098,0.8,0.142l-0.184-1.461l0.48-0.092l0.208,1.641c0.266,0.04,0.535,0.068,0.802,0.102l-0.235-1.451
				l0.478-0.109l0.263,1.624c0.269,0.031,0.537,0.064,0.808,0.089l-0.286-1.447l0.473-0.126l0.319,1.612
				c0.27,0.021,0.54,0.046,0.812,0.062l-0.338-1.437l0.469-0.142l0.377,1.608c0.269,0.013,0.54,0.014,0.81,0.021l-0.386-1.419
				l0.464-0.159l0.433,1.591c0.153,0.001,0.304,0.011,0.458,0.011c0.119,0,0.235-0.008,0.354-0.009l-0.437-1.411l0.458-0.174
				l0.487,1.573c0.272-0.007,0.543-0.009,0.814-0.021l-0.487-1.399l0.451-0.19l0.545,1.564c0.271-0.015,0.539-0.041,0.808-0.061
				l-0.535-1.379l0.445-0.206l0.599,1.546c0.271-0.025,0.54-0.054,0.809-0.084l-0.585-1.366l0.437-0.221l0.653,1.522
				c0.27-0.034,0.54-0.062,0.809-0.102l-0.637-1.353l0.429-0.236l0.709,1.507c0.268-0.044,0.534-0.094,0.799-0.143l-0.68-1.326
				l0.42-0.251l0.764,1.487c0.267-0.053,0.529-0.114,0.793-0.173l-0.729-1.304l0.411-0.266l0.814,1.456
				c0.265-0.062,0.533-0.118,0.796-0.186l-0.782-1.289l0.403-0.28l0.865,1.43c0.262-0.071,0.523-0.145,0.783-0.222l-0.822-1.257
				l0.392-0.293l0.923,1.409c0.258-0.081,0.511-0.173,0.767-0.26l-0.865-1.227l0.381-0.307l0.967,1.371
				c0.256-0.09,0.513-0.18,0.767-0.275L98.61,76.42l0.37-0.32l1.014,1.336c0.253-0.099,0.508-0.195,0.758-0.299l-0.955-1.171
				l0.359-0.333l1.065,1.305c0.248-0.108,0.493-0.222,0.74-0.335l-0.993-1.133l0.347-0.346l1.111,1.268
				c0.245-0.116,0.486-0.238,0.728-0.36l-1.032-1.098l0.335-0.359l1.15,1.226c0.241-0.126,0.486-0.245,0.724-0.375l-1.076-1.069
				l0.322-0.369l1.193,1.185c0.237-0.133,0.473-0.267,0.706-0.405l-1.108-1.027l0.309-0.38l1.241,1.149
				c0.23-0.141,0.454-0.292,0.682-0.438l-1.142-0.985l0.296-0.391l1.275,1.101c0.227-0.15,0.452-0.3,0.675-0.454l-1.179-0.947
				l0.282-0.402l1.311,1.055c0.222-0.158,0.447-0.311,0.665-0.473l-1.215-0.909l0.268-0.411l1.35,1.011
				c0.215-0.165,0.427-0.334,0.639-0.502l-1.24-0.863l0.253-0.42l1.389,0.966c0.209-0.171,0.411-0.351,0.617-0.527l-1.271-0.819
				l0.238-0.427l1.418,0.912c0.203-0.179,0.409-0.357,0.609-0.54l-1.304-0.778l0.223-0.437l1.448,0.864
				c0.198-0.186,0.396-0.371,0.59-0.562l-1.33-0.732l0.208-0.444l1.484,0.817c0.19-0.193,0.374-0.392,0.559-0.588l-1.351-0.683
				l0.192-0.451l1.512,0.764c0.184-0.2,0.363-0.403,0.542-0.605l-1.378-0.638l0.177-0.457l1.534,0.709
				c0.178-0.206,0.361-0.408,0.534-0.619l-1.41-0.592l0.161-0.463l1.562,0.657c0.169-0.212,0.337-0.425,0.503-0.64l-1.425-0.541
				l0.144-0.469l1.594,0.605c0.162-0.216,0.314-0.441,0.471-0.661l-1.443-0.491l0.128-0.473l1.61,0.548
				c0.155-0.223,0.308-0.447,0.457-0.674l-1.465-0.442l0.112-0.477l1.628,0.492c0.148-0.23,0.299-0.456,0.441-0.688l-1.487-0.393
				l0.095-0.481l1.65,0.437c0.139-0.234,0.272-0.469,0.406-0.706l-1.495-0.339l0.078-0.485l1.672,0.38
				c0.129-0.237,0.251-0.479,0.375-0.72l-1.507-0.288l0.06-0.486l1.679,0.321c0.123-0.243,0.248-0.485,0.365-0.731l-1.527-0.236
				l0.044-0.488l1.692,0.262c0.113-0.247,0.227-0.494,0.335-0.743l-1.532-0.183l0.027-0.49l1.708,0.204
				c0.104-0.249,0.2-0.503,0.298-0.756l-1.535-0.129l0.009-0.489l1.713,0.144c0.096-0.254,0.187-0.51,0.278-0.766l-1.543-0.076
				l-0.008-0.49l1.714,0.084c0.086-0.258,0.18-0.513,0.262-0.774l-1.554-0.021l-0.024-0.49l1.719,0.024
				c0.077-0.26,0.15-0.521,0.222-0.783l-1.544,0.033l-0.041-0.489l1.726-0.036c0.067-0.261,0.125-0.527,0.187-0.79l-1.542,0.086
				l-0.058-0.486l1.715-0.096c0.059-0.266,0.123-0.529,0.176-0.798l-1.546,0.141l-0.075-0.483l1.71-0.156
				c0.05-0.267,0.099-0.534,0.143-0.803l-1.534,0.194l-0.092-0.481l1.711-0.216c0.041-0.266,0.069-0.537,0.103-0.806l-1.522,0.247
				l-0.109-0.478l1.695-0.274c0.031-0.27,0.062-0.539,0.087-0.81l-1.516,0.3l-0.126-0.474l1.681-0.332
				c0.022-0.271,0.046-0.542,0.061-0.814l-1.505,0.353l-0.142-0.469l1.675-0.393c0.012-0.269,0.014-0.541,0.021-0.812l-1.486,0.404
				l-0.159-0.463l1.657-0.45c0.002-0.137,0.01-0.27,0.01-0.407c0-0.137-0.008-0.272-0.01-0.408l-1.475,0.456l-0.174-0.458
				l1.637-0.506c-0.008-0.272-0.009-0.546-0.021-0.817l-1.463,0.51l-0.19-0.451l1.625-0.567c-0.016-0.271-0.04-0.54-0.061-0.81
				l-1.44,0.558l-0.206-0.445l1.606-0.623c-0.025-0.27-0.056-0.54-0.086-0.81l-1.424,0.611l-0.221-0.437l1.581-0.678
				c-0.035-0.27-0.063-0.542-0.103-0.811l-1.411,0.663l-0.237-0.428l1.562-0.736c-0.044-0.268-0.093-0.534-0.143-0.801l-1.38,0.709
				l-0.251-0.421l1.541-0.792c-0.053-0.266-0.116-0.529-0.176-0.794l-1.355,0.758l-0.266-0.411l1.507-0.842
				c-0.063-0.266-0.121-0.532-0.19-0.795l-1.336,0.809l-0.28-0.402l1.478-0.895c-0.072-0.263-0.145-0.525-0.223-0.785l-1.304,0.853
				l-0.293-0.392l1.453-0.951c-0.081-0.259-0.173-0.513-0.26-0.77l-1.271,0.897l-0.307-0.382l1.414-0.997
				c-0.09-0.258-0.181-0.513-0.278-0.767l-1.242,0.943l-0.32-0.371l1.376-1.044c-0.099-0.254-0.194-0.51-0.3-0.76l-1.21,0.987
				l-0.333-0.359l1.342-1.094c-0.108-0.25-0.223-0.495-0.336-0.742l-1.169,1.024l-0.346-0.347l1.305-1.142
				c-0.117-0.245-0.242-0.485-0.363-0.727l-1.133,1.063l-0.358-0.334l1.258-1.182c-0.125-0.242-0.247-0.486-0.378-0.725
				l-1.098,1.107l-0.369-0.322l1.215-1.224c-0.134-0.236-0.268-0.473-0.406-0.706l-1.056,1.14l-0.38-0.31l1.176-1.269
				c-0.142-0.231-0.292-0.456-0.439-0.684l-1.011,1.172l-0.391-0.296l1.127-1.305c-0.15-0.227-0.303-0.451-0.457-0.674l-0.971,1.208
				l-0.401-0.282l1.077-1.34c-0.158-0.221-0.31-0.447-0.473-0.665l-0.932,1.245l-0.41-0.268l1.031-1.378
				c-0.166-0.215-0.334-0.428-0.504-0.639l-0.882,1.268l-0.419-0.253l0.986-1.418c-0.172-0.209-0.354-0.408-0.531-0.614
				l-0.835,1.296l-0.427-0.238l0.929-1.443c-0.18-0.203-0.36-0.407-0.544-0.607l-0.791,1.328l-0.437-0.224l0.878-1.471
				c-0.187-0.198-0.372-0.397-0.563-0.591l-0.745,1.355l-0.444-0.208l0.828-1.505c-0.193-0.19-0.391-0.375-0.589-0.561l-0.694,1.374
				l-0.45-0.192l0.775-1.535c-0.2-0.182-0.405-0.36-0.608-0.539l-0.646,1.398l-0.457-0.176l0.718-1.555
				c-0.207-0.177-0.41-0.357-0.621-0.53l-0.599,1.426l-0.463-0.16l0.664-1.579c-0.213-0.169-0.425-0.338-0.641-0.503l-0.547,1.441
				l-0.469-0.144l0.61-1.608c-0.217-0.161-0.44-0.314-0.662-0.47l-0.495,1.455l-0.473-0.128l0.553-1.623
				c-0.224-0.153-0.45-0.304-0.676-0.453l-0.445,1.474l-0.477-0.111l0.494-1.638c-0.229-0.146-0.455-0.298-0.687-0.441l-0.396,1.496
				l-0.481-0.094l0.437-1.656c-0.233-0.138-0.469-0.273-0.705-0.406l-0.34,1.501l-0.485-0.078l0.382-1.678
				c-0.238-0.13-0.481-0.247-0.722-0.372l-0.288,1.51l-0.486-0.061l0.321-1.681c-0.243-0.121-0.486-0.244-0.731-0.361l-0.236,1.525
				l-0.488-0.044l0.261-1.69c-0.246-0.113-0.493-0.227-0.743-0.335l-0.182,1.531l-0.49-0.027l0.204-1.703
				c-0.25-0.104-0.504-0.2-0.756-0.298l-0.129,1.53l-0.49-0.01l0.144-1.707C99.252,6.589,98.995,6.5,98.74,6.41l-0.076,1.534
				l-0.49,0.007l0.084-1.704C98,6.161,97.744,6.067,97.484,5.986l-0.022,1.543l-0.489,0.024l0.023-1.705
				c-0.259-0.077-0.52-0.151-0.782-0.223l0.033,1.531l-0.489,0.042l-0.036-1.712c-0.26-0.068-0.527-0.122-0.789-0.184l0.085,1.524
				l-0.486,0.059l-0.095-1.697c-0.265-0.059-0.529-0.12-0.797-0.173l0.139,1.524l-0.483,0.076l-0.154-1.689
				c-0.267-0.049-0.533-0.099-0.802-0.143l0.191,1.512L92.05,6.388l-0.213-1.687c-0.267-0.04-0.536-0.068-0.804-0.102l0.242,1.496
				l-0.478,0.109l-0.27-1.669c-0.269-0.03-0.538-0.059-0.809-0.083l0.295,1.488L89.54,6.065l-0.328-1.652
				c-0.271-0.021-0.54-0.046-0.812-0.062l0.346,1.476l-0.469,0.142l-0.385-1.641c-0.269-0.012-0.54-0.015-0.811-0.021l0.395,1.453
				l-0.463,0.158l-0.442-1.624c-0.115-0.001-0.227-0.009-0.342-0.009C86.071,4.285,85.916,4.295,85.759,4.297"
            />
          </defs>
          <clipPath id="SVGIDB_203_">
            <use xlink:href="#SVGIDB_202_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_204_"
            cx="-156"
            cy="571"
            r="1"
            gradientTransform="matrix(37.8716 0 0 37.8716 5994.2061 -21582.5137)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#272726" />
            <stop offset="0.6946" style="stop-color:#272726" />
            <stop offset="0.9079" style="stop-color:#575756" />
            <stop offset="1" style="stop-color:#2E2D2C" />
          </radialGradient>
          <rect
            x="48.353"
            y="4.285"
            :style="rearWheelClass"
            v-on:click="changeSeverity('rearWheel')"
            clip-path="url(#SVGIDB_203_)"
            fill="url(#SVGIDB_204_)"
            width="75.743"
            height="75.743"
          />
        </g>
        <g>
          <path
            d="M379.198,42.157c0-16.029,12.994-29.023,29.023-29.023c16.027,0,29.021,12.994,29.021,29.023
			c0,16.029-12.994,29.022-29.021,29.022C392.192,71.179,379.198,58.186,379.198,42.157"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_205_"
              d="M406.557,22.852c-0.587,0.051-1.17,0.129-1.746,0.232c-0.92,0.165-1.824,0.397-2.707,0.691
				c-0.961,0.32-1.893,0.715-2.791,1.18c-0.896,0.464-1.758,0.999-2.573,1.598c-0.811,0.596-1.577,1.255-2.29,1.974
				c-0.713,0.719-1.372,1.498-1.971,2.332c-0.58,0.809-1.103,1.67-1.56,2.578c-0.456,0.908-0.847,1.865-1.164,2.866
				c-0.013,0.041-0.026,0.082-0.039,0.123c-0.303,0.979-0.524,1.965-0.669,2.949c-0.148,1.025-0.216,2.049-0.201,3.063
				s0.109,2.018,0.28,3.004c0.09,0.524,0.202,1.043,0.335,1.555c0,0,0,0,0,0.001c0.007,0.025,0.013,0.051,0.021,0.076
				c0.005,0.018,0.01,0.036,0.014,0.054c0.002,0.007,0.004,0.014,0.006,0.022c0.067,0.249,0.139,0.496,0.215,0.741
				c0.134,0.432,0.282,0.856,0.444,1.273c0.005,0.012,0.009,0.023,0.014,0.035c0.003,0.009,0.007,0.018,0.01,0.026
				c0.248,0.631,0.528,1.249,0.841,1.85c0.457,0.88,0.979,1.726,1.565,2.528c0.568,0.776,1.194,1.511,1.876,2.2
				c0.001,0.001,0.002,0.002,0.003,0.003c0.018,0.017,0.035,0.034,0.053,0.052c0.006,0.006,0.011,0.011,0.017,0.017
				c0.002,0.002,0.004,0.004,0.006,0.006c0.287,0.286,0.581,0.562,0.884,0.828c2.536,2.233,5.748,3.79,8.998,4.446
				c0.006,0.001,0.012,0.002,0.02,0.004c0.019,0.003,0.037,0.007,0.056,0.011c0.012,0.002,0.024,0.004,0.036,0.007
				c0.017,0.003,0.033,0.006,0.05,0.01c0.009,0.001,0.019,0.003,0.027,0.005c0.019,0.003,0.037,0.007,0.055,0.01
				c0.298,0.056,0.595,0.105,0.891,0.146c0.009,0.001,0.018,0.002,0.025,0.004c0.017,0.002,0.034,0.004,0.051,0.007
				c0.959,0.129,1.917,0.186,2.866,0.173c1.014-0.015,2.018-0.109,3.005-0.28c0.614-0.106,1.222-0.242,1.821-0.406
				c0.005-0.002,0.009-0.003,0.014-0.004c0.023-0.007,0.046-0.013,0.069-0.019c0.014-0.004,0.028-0.008,0.042-0.012
				c0.013-0.004,0.025-0.008,0.039-0.011c0.021-0.007,0.044-0.013,0.065-0.019c0.007-0.002,0.013-0.004,0.019-0.005
				c0.207-0.06,0.412-0.123,0.616-0.189c0.317-0.104,0.632-0.215,0.941-0.333c0.009-0.004,0.02-0.008,0.028-0.011
				c0.014-0.005,0.028-0.011,0.041-0.016c0.025-0.009,0.049-0.019,0.073-0.028h0.001c0.635-0.249,1.257-0.532,1.861-0.845
				c0.879-0.457,1.726-0.98,2.528-1.567c0.8-0.585,1.558-1.234,2.265-1.94c0.003-0.003,0.008-0.006,0.011-0.01
				c0.704-0.705,1.357-1.47,1.951-2.288c0.598-0.82,1.134-1.695,1.602-2.619c0.469-0.925,0.868-1.899,1.19-2.919
				c0.291-0.915,0.511-1.837,0.66-2.757c0.001-0.005,0.002-0.009,0.003-0.014c0.005-0.025,0.009-0.051,0.013-0.077
				c0.001-0.005,0.002-0.01,0.002-0.015c0.01-0.059,0.019-0.118,0.027-0.177c0-0.006,0.001-0.012,0.002-0.018
				c0.149-1.014,0.217-2.027,0.204-3.031c-0.005-0.432-0.024-0.863-0.059-1.291c-0.047-0.588-0.121-1.173-0.22-1.752
				c-0.123-0.709-0.285-1.409-0.484-2.096c-0.313-1.077-0.716-2.124-1.206-3.127c-0.106-0.218-0.217-0.433-0.331-0.647
				c-0.004-0.007-0.008-0.014-0.011-0.021c-0.009-0.017-0.019-0.033-0.027-0.05c-0.451-0.832-0.965-1.636-1.539-2.404
				c-0.193-0.259-0.395-0.514-0.603-0.764c-0.011-0.015-0.023-0.029-0.035-0.043c-0.003-0.003-0.006-0.007-0.009-0.011
				c-0.324-0.388-0.664-0.764-1.02-1.126c-0.673-0.688-1.4-1.328-2.179-1.914c-0.762-0.573-1.571-1.093-2.425-1.555
				c-0.376-0.203-0.763-0.396-1.159-0.577c-2.493-1.138-5.332-1.759-8.147-1.759C407.614,22.785,407.084,22.807,406.557,22.852"
            />
          </defs>
          <clipPath id="SVGIDB_206_">
            <use xlink:href="#SVGIDB_205_" overflow="visible" />
          </clipPath>
          <g clip-path="url(#SVGIDB_206_)">
            <g>
              <defs>
                <rect
                  id="SVGIDB_207_"
                  x="388.831"
                  y="22.785"
                  width="38.778"
                  height="38.76"
                />
              </defs>
              <clipPath id="SVGIDB_208_">
                <use xlink:href="#SVGIDB_207_" overflow="visible" />
              </clipPath>
              <g
                transform="matrix(1 0 0 1 1.384612e-005 -2.950492e-007)"
                clip-path="url(#SVGIDB_208_)"
              >
                <image
                  overflow="visible"
                  width="81"
                  height="81"
                  xlink:href="data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAlgCWAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA
EAMCAwYAAAIRAAADcwAABVr/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX
Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa
JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAFMAUwMBIgACEQEDEQH/
xACTAAACAwEBAQAAAAAAAAAAAAAABAMFBgECBwEBAAAAAAAAAAAAAAAAAAAAABAAAgMAAgEDBQEA
AAAAAAAAAgMBBAUAEhMQIBFQMSIUFQYRAAEDAgMFBAgHAAAAAAAAAAEAEQIhAzFBEnGBIhMEEFFh
MiCRsdFCIzMUocGissJDUxIBAAAAAAAAAAAAAAAAAAAAUP/aAAwDAQACEQMRAAAA+gAsSx4y9PCb
dYarsOaNp3M6U6AeVE1xdHTVA9VORjNEzdBYVNUbMrwWrrpcqm5Fzvn15BNuUrJ7WUULAKqp1qZU
2bGcLHj1WTSweiuh1yZCaEOpPcMQ062ec/c0Jqctq0CHSJvgAAAeAKOkA1bwHQAAP//aAAgBAgAB
BQD6J//aAAgBAwABBQD6J//aAAgBAQABBQD0c9KBC0LY1dG8maWvpNND2SsdCt3+/su2/wBZNm1Z
ZZyrUGO2r8MoezWFCkaFmSPC0rS+RMTHCKAFoC+NLNmOUHlXfoxDqWGHZ2xahYV0MtNpURUCXhBc
3NGa51tQJgXKeOplFHM2x+zUwxgJfLdG3VqIpKtaoDxmocM/qr+NKrD7B5MTI1ryJTpPXyVqF/wQ
qG3Tzlus6FmRzLbOKxTnn88vFZcAOm6mOHqVw4ewopMm9CGexWmU5XuVphetXLg6CZ5+2Hx/oTYi
3E2GzVyWuKU081VGWX7dQRtjQvfE2sVLIdRsJmGuXPid4tWiNxNXOAIsWlVgs2GXXpUNXPxm9bu1
TkGZepMQSk2BjIFtjqPpoESF3rhNLIqdj0ygK+efW1aVD6z1nXdl3WGSx6j6EMFF3/Nx5aFaUjrn
+NUvh9Qu6LWS60ebk188Paf21unWr089Dr4/Z//aAAgBAgIGPwAT/9oACAEDAgY/ABP/2gAIAQEB
Bj8A7NV2QiMnT28MiUeVc0N3Afm6ad8kbI+5CU6rROWiWWrA7/RMgNVz4Yo3b8jKT07hsCAdGS3r
ciAULN57lk4E1MdicYHsMjgEXxKMohCEqVXMFaI+BWkFO1HQMgyFp8cOy3YjnxSPsVSmLF0b1mrV
ornTz88QaK/OWECUYQrEGpQM21IxiUJxNYlwtTU+3+4/HS3rUpSDsAAnjTYvlycdxWjqbZ05nEId
Z0En/wBbWbZsr1mx5r9wtLIQYSJPrXK6f5t74pCtUWjIAp5OuIFaG/p5O7mcxSEsR7liqrTbtayh
dv24WQaRAHzJHwZkYzIrLRxvp1MDpJiQmudHCIHxRDhVgAe5lgFRk/g+52USPLci4PiMVR0DN2Wu
QBmMEervfTtVhHJdZYljKWuO0I9H1g1aaAnFG5Zz7kwdMXWluL7Lmb+Zq/agW47ZeOzMIGQREWBC
0g8LotQkKb4SJXPthjjRC3MunAFVEEcALy2BYDBsMu7sNyI4c2yRiChIhaR3J/FPmycUCjCLknJV
82faYyDg0IKN7pC8TU2zlsK4o6SMiiE/im8EY24sM5HALh47p81w+wellvUvp/rdDyY560G5e7V/
L0f/2Q=="
                  transform="matrix(0.48 0 0 0.48 388.8311 22.7852)"
                ></image>
              </g>
            </g>
          </g>
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_209_"
              d="M394.625,42.157c0,7.508,6.087,13.595,13.596,13.595c7.508,0,13.596-6.087,13.596-13.595
				c0-7.508-6.088-13.595-13.596-13.595C400.712,28.562,394.625,34.649,394.625,42.157"
            />
          </defs>
          <clipPath id="SVGIDB_210_">
            <use xlink:href="#SVGIDB_209_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_211_"
            cx="-155.9995"
            cy="571"
            r="1"
            gradientTransform="matrix(-13.595 0 0 13.595 -1712.605 -7720.6172)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#1A1A1A" />
            <stop offset="0.8368" style="stop-color:#1A1A1A" />
            <stop offset="1" style="stop-color:#4E4D4D" />
          </radialGradient>
          <rect
            x="394.625"
            y="28.562"
            clip-path="url(#SVGIDB_210_)"
            fill="url(#SVGIDB_211_)"
            width="27.191"
            height="27.19"
          />
        </g>
        <g>
          <g>
            <g>
              <defs>
                <rect
                  id="SVGIDB_212_"
                  x="388.844"
                  y="22.78"
                  width="38.754"
                  height="38.735"
                />
              </defs>
              <clipPath id="SVGIDB_213_">
                <use xlink:href="#SVGIDB_212_" overflow="visible" />
              </clipPath>
              <g clip-path="url(#SVGIDB_213_)">
                <defs>
                  <path
                    id="SVGIDB_214_"
                    d="M388.844,42.148c0-10.697,8.675-19.368,19.377-19.368c10.701,0,19.377,8.671,19.377,19.368
							c0,10.696-8.676,19.367-19.377,19.367C397.519,61.515,388.844,52.844,388.844,42.148"
                  />
                </defs>
                <clipPath id="SVGIDB_215_">
                  <use xlink:href="#SVGIDB_214_" overflow="visible" />
                </clipPath>

                <radialGradient
                  id="SVGIDB_216_"
                  cx="-155.9995"
                  cy="571"
                  r="1"
                  gradientTransform="matrix(-19.3771 0 0 19.3673 -2614.6045 -11016.5967)"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop offset="0" style="stop-color:#FFFFFF" />
                  <stop offset="0.5732" style="stop-color:#FFFFFF" />
                  <stop offset="0.7573" style="stop-color:#808080" />
                  <stop offset="1" style="stop-color:#676767" />
                </radialGradient>
                <rect
                  x="388.844"
                  y="22.78"
                  clip-path="url(#SVGIDB_215_)"
                  fill="url(#SVGIDB_216_)"
                  width="38.754"
                  height="38.735"
                />
              </g>
            </g>
          </g>
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_217_"
              d="M389.881,31.596c-0.951,1.734-2.188,5.782-2.205,5.866c-0.521,2.427-0.625,4.986-0.245,7.583
				c0.38,2.592,1.169,5.031,2.4,7.173c0.675,1.176,2.056,3.223,3.409,4.626c1.817,1.884,3.9,3.363,6.13,4.43
				c0.303,0.145,0.667,0.037,0.851-0.244l2.313-3.844c0.472-0.682,0.397-1.602-0.178-2.198c-0.897-0.638-1.665-1.232-2.367-1.841
				c-2.006-1.741-3.518-3.977-4.501-6.445c-0.007-0.017-0.015-0.034-0.021-0.051c-0.403-1.015-0.691-2.083-0.771-3.173
				c-0.13-1.791,0.035-3.599,0.469-5.355c0.242-0.978,0.519-2.005,0.798-3.128c0.121-0.831-0.361-1.633-1.152-1.914l-4.117-1.775
				c-0.078-0.03-0.159-0.045-0.239-0.045C390.221,31.261,389.998,31.383,389.881,31.596"
            />
          </defs>
          <clipPath id="SVGIDB_218_">
            <use xlink:href="#SVGIDB_217_" overflow="visible" />
          </clipPath>

          <linearGradient
            id="SVGIDB_219_"
            gradientUnits="userSpaceOnUse"
            x1="-155.9995"
            y1="571"
            x2="-154.9995"
            y2="571"
            gradientTransform="matrix(0 30.0773 30.0773 0 -16779.127 4723.3193)"
          >
            <stop offset="0" style="stop-color:#0E0405" />
            <stop offset="0.5021" style="stop-color:#681418" />
            <stop offset="1" style="stop-color:#0E0405" />
          </linearGradient>
          <rect
            x="387.051"
            y="31.261"
            clip-path="url(#SVGIDB_218_)"
            fill="url(#SVGIDB_219_)"
            width="15.954"
            height="30.158"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_220_"
              d="M385.521,42.153c0-12.537,10.166-22.696,22.702-22.696c12.53,0,22.697,10.159,22.697,22.696
				c0,12.538-10.167,22.696-22.697,22.696C395.688,64.849,385.521,54.691,385.521,42.153 M380.422,42.153
				c0,15.35,12.445,27.802,27.802,27.802c15.352,0,27.795-12.452,27.795-27.802c0-15.351-12.443-27.795-27.795-27.795
				C392.867,14.358,380.422,26.802,380.422,42.153"
            />
          </defs>
          <clipPath id="SVGIDB_221_">
            <use xlink:href="#SVGIDB_220_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_222_"
            cx="-156"
            cy="571"
            r="1"
            gradientTransform="matrix(-27.7983 0 0 27.7983 -3928.3218 -15830.6855)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#7C7C7B" />
            <stop offset="0.8536" style="stop-color:#7C7C7B" />
            <stop offset="1" style="stop-color:#F0F0F0" />
          </radialGradient>
          <rect
            x="380.422"
            y="14.358"
            :style="frontWheelClass"
            v-on:click="changeSeverity('frontWheel')"
            clip-path="url(#SVGIDB_221_)"
            fill="url(#SVGIDB_222_)"
            width="55.597"
            height="55.597"
          />
        </g>
        <g>
          <path
            fill="#4D4D4D"
            d="M398.939,48.592l-9.794,5.875l6.749,6.754l5.901-9.826c1.705-1.216,3.854-0.325,4.415,1.88l-2.822,11.06
			h9.652l-2.829-11.131c0.356-2.054,2.5-2.936,4.452-1.773l5.872,9.792l6.754-6.753l-9.854-5.923
			c-1.195-1.702-0.307-3.835,1.89-4.396l11.088,2.776v-9.545l-11.147,2.769c-2.053-0.349-2.938-2.482-1.793-4.431l9.815-5.882
			l-6.749-6.75l-5.909,9.818c-1.698,1.222-3.838,0.346-4.416-1.838l2.78-11.104l-9.502-0.042l2.722,11.134
			c-0.327,2.077-2.465,2.978-4.422,1.843l-5.887-9.809l-6.75,6.749l9.793,5.875c1.241,1.702,0.362,3.856-1.831,4.435l-11.087-2.765
			v9.545l11.088-2.778C399.195,44.483,400.093,46.632,398.939,48.592"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_223_"
              d="M403.525,19.815l2.703,11.322c-0.324,2.061-2.446,2.955-4.39,1.829l-6.034-9.929
				c-0.036,0.027-6.671,6.666-6.701,6.701l9.912,6.022c1.233,1.689,0.361,3.828-1.816,4.402l-11.275-2.746
				c-0.005,0.047-0.004,9.434,0,9.477l11.275-2.758c2.062,0.331,2.953,2.464,1.809,4.409l-9.914,6.023
				c0.028,0.035,6.664,6.675,6.701,6.705l6.048-9.945c1.693-1.207,3.825-0.324,4.382,1.865l-2.801,11.249
				c0.046,0.003,9.538,0.006,9.581,0l-2.808-11.319c0.354-2.039,2.48-2.914,4.419-1.76l6.019,9.911
				c0.038-0.03,6.678-6.669,6.705-6.704l-9.972-6.069c-1.188-1.691-0.304-3.807,1.875-4.365l11.275,2.758
				c0.007-0.047,0.007-9.432,0-9.477l-11.334,2.75c-2.038-0.348-2.916-2.464-1.78-4.4l9.935-6.028
				c-0.026-0.032-6.663-6.671-6.701-6.701l-6.055,9.937c-1.687,1.213-3.81,0.344-4.383-1.826l2.76-11.292
				c-0.043-0.004-8.452-0.042-9.356-0.042C403.554,19.814,403.527,19.815,403.525,19.815"
            />
          </defs>
          <clipPath id="SVGIDB_224_">
            <use xlink:href="#SVGIDB_223_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_225_"
            cx="-156"
            cy="571"
            r="1"
            gradientTransform="matrix(22.3588 0.3211 0.3211 -22.3588 3712.8259 12859.1367)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#737372" />
            <stop offset="0.5272" style="stop-color:#727271" />
            <stop offset="1" style="stop-color:#737372" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_224_)"
            fill="url(#SVGIDB_225_)"
            points="385.928,19.173 431.166,19.823 430.516,65.087
			385.278,64.438 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_226_"
              d="M403.558,19.709l2.686,11.51c-0.322,2.045-2.428,2.933-4.356,1.814l-6.181-10.047
				c-0.072,0.054-6.591,6.582-6.653,6.652l10.032,6.169c1.223,1.677,0.358,3.8-1.804,4.369l-11.464-2.726
				c-0.011,0.094-0.009,9.323,0,9.409l11.464-2.739c2.047,0.329,2.932,2.445,1.795,4.377l-10.033,6.169
				c0.056,0.07,6.58,6.597,6.652,6.657l6.195-10.065c1.681-1.198,3.797-0.32,4.351,1.852l-2.782,11.438
				c0.093,0.006,9.424,0.009,9.511,0l-2.787-11.507c0.352-2.024,2.462-2.893,4.386-1.747l6.166,10.031
				c0.075-0.062,6.602-6.586,6.657-6.657l-10.091-6.216c-1.179-1.677-0.303-3.778,1.86-4.331l11.464,2.738
				c0.01-0.093,0.01-9.319,0-9.41l-11.521,2.732c-2.023-0.345-2.896-2.446-1.767-4.367l10.053-6.176
				c-0.054-0.064-6.575-6.592-6.652-6.652l-6.202,10.056c-1.673,1.204-3.782,0.341-4.351-1.812l2.741-11.48
				c-0.081-0.009-7.667-0.042-9.127-0.042C403.651,19.708,403.566,19.708,403.558,19.709"
            />
          </defs>
          <clipPath id="SVGIDB_227_">
            <use xlink:href="#SVGIDB_226_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_228_"
            cx="-156.0005"
            cy="571"
            r="1.0002"
            gradientTransform="matrix(22.522 0.6702 0.6702 -22.522 3538.9705 13006.7939)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#767675" />
            <stop offset="0.5272" style="stop-color:#747473" />
            <stop offset="1" style="stop-color:#767675" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_227_)"
            fill="url(#SVGIDB_228_)"
            points="385.847,18.375 431.969,19.748 430.596,65.89
			384.474,64.518 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_229_"
              d="M403.591,19.603l2.667,11.698c-0.32,2.03-2.41,2.911-4.324,1.801l-6.327-10.168
				c-0.108,0.082-6.513,6.5-6.605,6.605l10.151,6.316c1.215,1.664,0.355,3.771-1.789,4.337l-11.652-2.708
				c-0.015,0.141-0.012,9.21,0,9.341l11.652-2.72c2.03,0.327,2.908,2.427,1.78,4.344l-10.152,6.316
				c0.084,0.106,6.496,6.518,6.604,6.609l6.342-10.184c1.669-1.188,3.769-0.318,4.317,1.838l-2.761,11.627
				c0.139,0.009,9.311,0.014,9.44,0l-2.767-11.696c0.349-2.009,2.445-2.871,4.354-1.733l6.312,10.149
				c0.114-0.092,6.526-6.502,6.61-6.608l-10.211-6.362c-1.17-1.665-0.301-3.75,1.847-4.298l11.653,2.718
				c0.015-0.139,0.015-9.205,0-9.341l-11.711,2.711c-2.008-0.342-2.872-2.427-1.754-4.333l10.174-6.323
				c-0.082-0.097-6.49-6.515-6.605-6.605l-6.348,10.177c-1.66,1.194-3.754,0.337-4.318-1.799l2.722-11.668
				c-0.114-0.013-6.823-0.043-8.774-0.043C403.802,19.601,403.611,19.602,403.591,19.603"
            />
          </defs>
          <clipPath id="SVGIDB_230_">
            <use xlink:href="#SVGIDB_229_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_231_"
            cx="-156"
            cy="571"
            r="1"
            gradientTransform="matrix(22.6762 1.0499 1.0499 -22.6762 3346.2246 13154.0498)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#797978" />
            <stop offset="0.5272" style="stop-color:#767675" />
            <stop offset="1" style="stop-color:#797978" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_230_)"
            fill="url(#SVGIDB_231_)"
            points="385.792,17.52 432.829,19.697 430.65,66.75
			383.614,64.573 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_232_"
              d="M403.625,19.498l2.646,11.884c-0.315,2.015-2.391,2.89-4.29,1.788l-6.475-10.286
				c-0.144,0.108-6.433,6.415-6.557,6.556l10.271,6.462c1.205,1.652,0.354,3.743-1.775,4.304l-11.84-2.688
				c-0.022,0.188-0.017,9.099,0,9.273l11.84-2.7c2.016,0.323,2.887,2.408,1.768,4.31l-10.271,6.463
				c0.111,0.141,6.409,6.44,6.556,6.56l6.489-10.302c1.654-1.18,3.738-0.316,4.285,1.825l-2.742,11.813
				c0.185,0.012,9.195,0.021,9.371,0l-2.747-11.883c0.346-1.994,2.426-2.849,4.32-1.721l6.458,10.269
				c0.152-0.122,6.451-6.418,6.562-6.559l-10.329-6.51c-1.16-1.651-0.298-3.721,1.833-4.266l11.841,2.7
				c0.021-0.185,0.021-9.092,0-9.273l-11.896,2.692c-1.994-0.34-2.853-2.409-1.741-4.301l10.292-6.47
				c-0.108-0.129-6.403-6.435-6.558-6.556l-6.493,10.295c-1.648,1.187-3.726,0.336-4.285-1.784l2.702-11.856
				c-0.146-0.017-6.102-0.044-8.37-0.044C403.981,19.494,403.658,19.495,403.625,19.498"
            />
          </defs>
          <clipPath id="SVGIDB_233_">
            <use xlink:href="#SVGIDB_232_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_234_"
            cx="-156.0005"
            cy="571"
            r="1.0002"
            gradientTransform="matrix(22.8186 1.4631 1.4631 -22.8186 3132.4915 13299.8125)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#7C7C7C" />
            <stop offset="0.5272" style="stop-color:#787877" />
            <stop offset="1" style="stop-color:#7C7C7C" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_233_)"
            fill="url(#SVGIDB_234_)"
            points="385.769,16.603 433.75,19.68 430.673,67.672
			382.691,64.596 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_235_"
              d="M403.658,19.392l2.63,12.072c-0.315,1.999-2.374,2.868-4.259,1.774l-6.622-10.405
				c-0.179,0.135-6.354,6.332-6.508,6.507l10.39,6.609c1.196,1.64,0.35,3.715-1.763,4.272l-12.028-2.669
				c-0.027,0.234-0.02,8.987,0,9.204l12.029-2.68c2,0.321,2.864,2.39,1.754,4.278l-10.392,6.609c0.14,0.176,6.325,6.362,6.509,6.513
				l6.634-10.422c1.643-1.171,3.712-0.313,4.253,1.811l-2.721,12.002c0.23,0.015,9.082,0.025,9.301,0l-2.727-12.071
				c0.344-1.978,2.407-2.828,4.287-1.707l6.606,10.388c0.188-0.153,6.373-6.334,6.513-6.511l-10.448-6.655
				c-1.151-1.64-0.297-3.694,1.818-4.234l12.029,2.679c0.024-0.23,0.024-8.977,0-9.204l-12.085,2.673
				c-1.979-0.337-2.83-2.391-1.728-4.269l10.411-6.616c-0.136-0.162-6.316-6.358-6.509-6.508l-6.641,10.414
				c-1.636,1.178-3.696,0.333-4.253-1.771l2.683-12.044c-0.174-0.02-5.572-0.046-8.003-0.046
				C404.152,19.385,403.708,19.387,403.658,19.392"
            />
          </defs>
          <clipPath id="SVGIDB_236_">
            <use xlink:href="#SVGIDB_235_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_237_"
            cx="-156.0005"
            cy="571"
            r="1.0002"
            gradientTransform="matrix(22.9459 1.9131 1.9131 -22.9459 2895.4238 13442.71)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#807F7F" />
            <stop offset="0.5272" style="stop-color:#7A7A7A" />
            <stop offset="1" style="stop-color:#807F7F" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_236_)"
            fill="url(#SVGIDB_237_)"
            points="385.785,15.618 434.736,19.699 430.655,68.659
			381.703,64.578 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_238_"
              d="M403.69,19.286l2.611,12.259c-0.312,1.985-2.354,2.846-4.226,1.762l-6.769-10.526
				c-0.215,0.163-6.274,6.249-6.46,6.46l10.511,6.756c1.187,1.626,0.347,3.686-1.75,4.239l-12.218-2.65
				c-0.03,0.281-0.023,8.876,0,9.136l12.219-2.661c1.983,0.319,2.843,2.372,1.739,4.246l-10.511,6.755
				c0.168,0.212,6.241,6.283,6.461,6.465l6.781-10.542c1.63-1.161,3.683-0.31,4.219,1.798l-2.7,12.19
				c0.278,0.019,8.969,0.031,9.231,0l-2.707-12.259c0.341-1.963,2.39-2.805,4.256-1.693l6.752,10.507
				c0.227-0.184,6.298-6.25,6.464-6.463l-10.566-6.801c-1.144-1.627-0.293-3.666,1.806-4.202l12.216,2.66
				c0.03-0.277,0.031-8.864,0-9.137l-12.271,2.654c-1.963-0.333-2.81-2.372-1.716-4.235l10.53-6.763
				c-0.162-0.195-6.229-6.28-6.46-6.461l-6.787,10.535c-1.622,1.167-3.668,0.33-4.22-1.758l2.663-12.233
				c-0.199-0.023-5.021-0.047-7.565-0.047C404.362,19.277,403.761,19.28,403.69,19.286"
            />
          </defs>
          <clipPath id="SVGIDB_239_">
            <use xlink:href="#SVGIDB_238_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_240_"
            cx="-156"
            cy="571"
            r="1"
            gradientTransform="matrix(23.054 2.4032 2.4032 -23.054 2632.4482 13580.873)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#838282" />
            <stop offset="0.5272" style="stop-color:#7C7C7C" />
            <stop offset="1" style="stop-color:#838282" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_239_)"
            fill="url(#SVGIDB_240_)"
            points="385.852,14.563 435.796,19.769 430.59,69.719
			380.645,64.513 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_241_"
              d="M403.724,19.181l2.594,12.446c-0.311,1.969-2.337,2.825-4.194,1.747l-6.914-10.644
				c-0.252,0.19-6.196,6.166-6.412,6.412l10.629,6.902c1.178,1.614,0.346,3.658-1.735,4.206l-12.405-2.63
				c-0.037,0.328-0.029,8.765,0,9.068l12.406-2.642c1.969,0.316,2.819,2.354,1.727,4.213l-10.63,6.902
				c0.195,0.247,6.155,6.205,6.412,6.417l6.928-10.661c1.617-1.153,3.654-0.308,4.188,1.784l-2.682,12.378
				c0.324,0.023,8.855,0.036,9.161,0.001l-2.686-12.447c0.338-1.948,2.371-2.784,4.222-1.681l6.899,10.627
				c0.264-0.214,6.222-6.166,6.416-6.415l-10.686-6.948c-1.134-1.614-0.292-3.637,1.791-4.169l12.404,2.641
				c0.035-0.323,0.035-8.751,0-9.068l-12.46,2.634c-1.948-0.331-2.787-2.354-1.701-4.203l10.649-6.909
				c-0.189-0.227-6.144-6.202-6.411-6.412l-6.935,10.652c-1.611,1.16-3.64,0.329-4.188-1.743l2.644-12.421
				c-0.223-0.026-4.594-0.049-7.175-0.049C404.557,19.169,403.816,19.173,403.724,19.181"
            />
          </defs>
          <clipPath id="SVGIDB_242_">
            <use xlink:href="#SVGIDB_241_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_243_"
            cx="-156"
            cy="571.001"
            r="0.9996"
            gradientTransform="matrix(23.1377 2.937 2.937 -23.1377 2340.6992 13711.9297)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#868585" />
            <stop offset="0.5272" style="stop-color:#7F7E7E" />
            <stop offset="1" style="stop-color:#868585" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_242_)"
            fill="url(#SVGIDB_243_)"
            points="385.977,13.43 436.931,19.897 430.463,70.854
			379.509,64.386 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_244_"
              d="M403.757,19.075l2.575,12.634c-0.308,1.954-2.32,2.802-4.161,1.734l-7.061-10.764
				c-0.287,0.217-6.118,6.083-6.364,6.364l10.748,7.049c1.169,1.601,0.342,3.629-1.723,4.174l-12.593-2.612
				c-0.042,0.375-0.032,8.653,0,9l12.595-2.623c1.953,0.313,2.799,2.336,1.713,4.181l-10.749,7.049
				c0.223,0.281,6.069,6.126,6.363,6.368l7.074-10.78c1.604-1.143,3.626-0.306,4.154,1.769l-2.66,12.568
				c0.371,0.026,8.74,0.04,9.09,0l-2.664-12.635c0.334-1.933,2.352-2.762,4.188-1.667l7.046,10.746
				c0.302-0.245,6.146-6.083,6.368-6.367l-10.806-7.094c-1.125-1.602-0.288-3.609,1.778-4.136l12.593,2.621
				c0.039-0.369,0.04-8.638,0-9l-12.647,2.615c-1.934-0.329-2.767-2.336-1.688-4.17l10.77-7.056
				c-0.218-0.26-6.058-6.124-6.364-6.364l-7.08,10.772c-1.599,1.15-3.612,0.325-4.156-1.73l2.625-12.609
				c-0.248-0.028-4.328-0.052-6.901-0.052C404.702,19.06,403.869,19.065,403.757,19.075"
            />
          </defs>
          <clipPath id="SVGIDB_245_">
            <use xlink:href="#SVGIDB_244_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_246_"
            cx="-156"
            cy="571"
            r="1"
            gradientTransform="matrix(23.1906 3.5181 3.5181 -23.1906 2017.1155 13832.7852)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#898888" />
            <stop offset="0.5272" style="stop-color:#818080" />
            <stop offset="1" style="stop-color:#898888" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_245_)"
            fill="url(#SVGIDB_246_)"
            points="386.176,12.214 438.148,20.099 430.265,72.072
			378.291,64.188 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_247_"
              d="M403.79,18.97l2.556,12.821c-0.304,1.939-2.3,2.78-4.128,1.72l-7.208-10.884
				c-0.322,0.244-6.038,6-6.315,6.316l10.868,7.196c1.159,1.589,0.34,3.601-1.709,4.141l-12.781-2.592
				c-0.047,0.422-0.036,8.542,0,8.932l12.783-2.603c1.938,0.311,2.775,2.317,1.699,4.147l-10.87,7.196
				c0.251,0.317,5.986,6.047,6.317,6.32l7.22-10.899c1.593-1.135,3.599-0.304,4.122,1.755l-2.639,12.757
				c0.416,0.028,8.625,0.045,9.019,0l-2.645-12.823c0.333-1.918,2.335-2.741,4.157-1.655l7.192,10.866
				c0.339-0.275,6.069-5.999,6.319-6.318l-10.923-7.241c-1.117-1.589-0.287-3.581,1.763-4.104l12.781,2.602
				c0.045-0.415,0.046-8.524,0-8.932l-12.836,2.596c-1.917-0.327-2.743-2.318-1.674-4.138l10.887-7.203
				c-0.244-0.292-5.969-6.046-6.315-6.316l-7.226,10.892c-1.586,1.141-3.584,0.323-4.123-1.717l2.605-12.797
				c-0.27-0.03-4.014-0.053-6.563-0.053C404.884,18.952,403.927,18.957,403.79,18.97"
            />
          </defs>
          <clipPath id="SVGIDB_248_">
            <use xlink:href="#SVGIDB_247_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_249_"
            cx="-155.999"
            cy="571.001"
            r="0.9991"
            gradientTransform="matrix(23.2047 4.1501 4.1501 -23.2047 1658.4346 13939.4756)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#8B8B8B" />
            <stop offset="0.5272" style="stop-color:#838282" />
            <stop offset="1" style="stop-color:#8B8B8B" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_248_)"
            fill="url(#SVGIDB_249_)"
            points="386.463,10.913 439.454,20.39 429.978,73.377
			376.986,63.9 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_250_"
              d="M403.823,18.864l2.538,13.009c-0.303,1.923-2.283,2.758-4.096,1.706l-7.354-11.003
				c-0.359,0.272-5.959,5.917-6.269,6.268l10.988,7.343c1.15,1.576,0.337,3.572-1.695,4.107l-12.97-2.573
				c-0.052,0.469-0.041,8.43,0,8.864l12.97-2.583c1.925,0.309,2.756,2.299,1.688,4.114l-10.988,7.343
				c0.279,0.352,5.9,5.969,6.269,6.271l7.365-11.017c1.58-1.126,3.57-0.302,4.091,1.741l-2.619,12.945
				c0.463,0.031,8.512,0.05,8.949,0l-2.624-13.011c0.329-1.902,2.315-2.718,4.124-1.641l7.339,10.984
				c0.376-0.306,5.993-5.914,6.271-6.269l-11.043-7.387c-1.107-1.577-0.284-3.552,1.75-4.072l12.969,2.582
				c0.05-0.46,0.051-8.41,0-8.864l-13.022,2.577c-1.903-0.324-2.724-2.299-1.661-4.105l11.007-7.349
				c-0.271-0.324-5.884-5.967-6.268-6.268l-7.373,11.012c-1.573,1.131-3.557,0.319-4.09-1.704l2.585-12.985
				c-0.289-0.033-3.758-0.056-6.265-0.056C405.049,18.843,403.984,18.849,403.823,18.864"
            />
          </defs>
          <clipPath id="SVGIDB_251_">
            <use xlink:href="#SVGIDB_250_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_252_"
            cx="-156.0005"
            cy="571.001"
            r="0.9998"
            gradientTransform="matrix(23.1705 4.8363 4.8363 -23.1705 1261.2959 14026.9893)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#8E8E8E" />
            <stop offset="0.5272" style="stop-color:#858584" />
            <stop offset="1" style="stop-color:#8E8E8E" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_251_)"
            fill="url(#SVGIDB_252_)"
            points="386.859,9.521 440.847,20.789 429.579,74.772
			375.592,63.503 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_253_"
              d="M403.856,18.758l2.52,13.196c-0.3,1.908-2.265,2.737-4.063,1.693l-7.502-11.122
				c-0.394,0.299-5.88,5.833-6.219,6.22l11.108,7.489c1.14,1.564,0.334,3.544-1.684,4.076l-13.157-2.555
				c-0.058,0.516-0.045,8.319,0,8.796l13.157-2.564c1.909,0.307,2.734,2.281,1.675,4.082l-11.107,7.489
				c0.307,0.388,5.815,5.891,6.219,6.224l7.515-11.138c1.566-1.117,3.54-0.298,4.056,1.728l-2.598,13.133
				c0.509,0.035,8.397,0.056,8.879,0l-2.604-13.198c0.328-1.888,2.297-2.698,4.091-1.628l7.486,11.104
				c0.414-0.337,5.918-5.832,6.223-6.222l-11.16-7.533c-1.1-1.564-0.283-3.524,1.734-4.04l13.157,2.563
				c0.055-0.507,0.056-8.297,0-8.796l-13.211,2.558c-1.887-0.321-2.7-2.281-1.648-4.072l11.127-7.497
				c-0.299-0.357-5.798-5.889-6.22-6.219l-7.52,11.13c-1.561,1.123-3.527,0.318-4.058-1.689l2.566-13.174
				c-0.312-0.035-3.576-0.058-6.036-0.058C405.181,18.734,404.041,18.741,403.856,18.758"
            />
          </defs>
          <clipPath id="SVGIDB_254_">
            <use xlink:href="#SVGIDB_253_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_255_"
            cx="-156"
            cy="571"
            r="1"
            gradientTransform="matrix(23.076 5.5792 5.5792 -23.076 822.3837 14088.9004)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#919190" />
            <stop offset="0.5272" style="stop-color:#878786" />
            <stop offset="1" style="stop-color:#919190" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_254_)"
            fill="url(#SVGIDB_255_)"
            points="387.389,8.036 442.333,21.32 429.051,76.259
			374.105,62.975 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_256_"
              d="M403.889,18.653l2.502,13.383c-0.298,1.893-2.246,2.714-4.03,1.679l-7.648-11.242
				c-0.43,0.326-5.801,5.751-6.172,6.172l11.227,7.636c1.133,1.552,0.332,3.516-1.668,4.043l-13.346-2.534
				c-0.063,0.562-0.049,8.207,0,8.727l13.346-2.544c1.895,0.304,2.712,2.262,1.661,4.049l-11.228,7.636
				c0.335,0.422,5.731,5.812,6.172,6.174l7.66-11.255c1.555-1.108,3.512-0.297,4.023,1.713l-2.578,13.322
				c0.557,0.037,8.284,0.06,8.81,0l-2.584-13.386c0.325-1.873,2.279-2.676,4.058-1.616l7.633,11.224
				c0.452-0.368,5.842-5.748,6.176-6.174l-11.281-7.68c-1.089-1.551-0.279-3.495,1.722-4.006l13.346,2.543
				c0.06-0.554,0.061-8.184,0-8.727l-13.398,2.538c-1.872-0.319-2.678-2.263-1.635-4.04l11.245-7.643
				c-0.325-0.389-5.71-5.812-6.171-6.172l-7.666,11.25c-1.548,1.115-3.5,0.315-4.024-1.675l2.546-13.363
				c-0.331-0.037-3.381-0.06-5.783-0.06C405.329,18.625,404.1,18.633,403.889,18.653"
            />
          </defs>
          <clipPath id="SVGIDB_257_">
            <use xlink:href="#SVGIDB_256_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_258_"
            cx="-156"
            cy="571"
            r="1"
            gradientTransform="matrix(22.9068 6.38 6.38 -22.9068 338.6845 14117.2002)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#949493" />
            <stop offset="0.5272" style="stop-color:#898988" />
            <stop offset="1" style="stop-color:#949493" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_257_)"
            fill="url(#SVGIDB_258_)"
            points="388.077,6.462 443.908,22.012 428.36,77.835
			372.528,62.285 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_259_"
              d="M403.922,18.548l2.483,13.57c-0.295,1.877-2.229,2.693-3.997,1.666l-7.795-11.362
				c-0.467,0.353-5.723,5.667-6.124,6.124l11.347,7.783c1.123,1.539,0.329,3.487-1.655,4.01l-13.534-2.515
				c-0.068,0.609-0.054,8.095,0,8.659l13.534-2.526c1.878,0.303,2.69,2.245,1.647,4.017l-11.346,7.783
				c0.361,0.457,5.646,5.734,6.123,6.127l7.806-11.376c1.542-1.098,3.483-0.294,3.992,1.7l-2.559,13.51
				c0.603,0.041,8.17,0.065,8.739,0l-2.563-13.573c0.321-1.858,2.26-2.655,4.024-1.603l7.779,11.342
				c0.49-0.397,5.766-5.664,6.126-6.125l-11.398-7.825c-1.082-1.539-0.277-3.468,1.707-3.975l13.534,2.524
				c0.064-0.6,0.065-8.07,0-8.66l-13.587,2.519c-1.857-0.316-2.657-2.244-1.621-4.007l11.365-7.79
				c-0.354-0.421-5.625-5.732-6.124-6.123l-7.813,11.37c-1.534,1.104-3.47,0.312-3.991-1.663l2.526-13.55
				c-0.35-0.04-3.225-0.063-5.568-0.063C405.458,18.516,404.16,18.526,403.922,18.548"
            />
          </defs>
          <clipPath id="SVGIDB_260_">
            <use xlink:href="#SVGIDB_259_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_261_"
            cx="-156.001"
            cy="571"
            r="1.0004"
            gradientTransform="matrix(22.6455 7.2381 7.2381 -22.6455 -192.051 14101.877)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#979796" />
            <stop offset="0.5272" style="stop-color:#8B8A8A" />
            <stop offset="1" style="stop-color:#979796" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_260_)"
            fill="url(#SVGIDB_261_)"
            points="388.961,4.805 445.566,22.897 427.477,79.495
			370.87,61.402 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_262_"
              d="M403.955,18.441L406.42,32.2c-0.293,1.862-2.21,2.67-3.966,1.652l-7.941-11.48
				c-0.502,0.38-5.642,5.582-6.075,6.074l11.467,7.931c1.113,1.526,0.327,3.458-1.643,3.977l-13.722-2.497
				c-0.074,0.657-0.057,7.985,0,8.592l13.723-2.506c1.862,0.3,2.668,2.226,1.634,3.983l-11.466,7.93
				c0.391,0.493,5.563,5.656,6.075,6.079l7.952-11.495c1.53-1.09,3.456-0.292,3.96,1.687l-2.538,13.698
				c0.649,0.044,8.056,0.07,8.669,0l-2.543-13.762c0.32-1.843,2.241-2.633,3.992-1.59l7.927,11.463
				c0.527-0.43,5.689-5.581,6.078-6.077l-11.518-7.973c-1.073-1.527-0.276-3.438,1.692-3.942l13.723,2.505
				c0.068-0.646,0.069-7.957,0-8.592l-13.774,2.5c-1.842-0.314-2.635-2.226-1.608-3.974l11.483-7.937
				c-0.379-0.454-5.537-5.655-6.074-6.075l-7.959,11.488c-1.522,1.097-3.441,0.311-3.96-1.648l2.508-13.738
				c-0.372-0.043-3.119-0.067-5.412-0.067C405.556,18.406,404.217,18.417,403.955,18.441"
            />
          </defs>
          <clipPath id="SVGIDB_263_">
            <use xlink:href="#SVGIDB_262_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_264_"
            cx="-156"
            cy="571"
            r="1"
            gradientTransform="matrix(22.2716 8.1496 8.1496 -22.2716 -770.826 14030.585)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#9A9999" />
            <stop offset="0.5272" style="stop-color:#8D8C8C" />
            <stop offset="1" style="stop-color:#9A9999" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_263_)"
            fill="url(#SVGIDB_264_)"
            points="390.075,3.076 447.295,24.014 426.36,81.225
			369.141,60.287 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_265_"
              d="M403.988,18.336l2.446,13.946c-0.291,1.846-2.191,2.647-3.933,1.639l-8.088-11.601
				c-0.538,0.407-5.564,5.499-6.027,6.027l11.585,8.077c1.105,1.513,0.324,3.43-1.628,3.944l-13.91-2.477
				c-0.078,0.704-0.061,7.874,0,8.523l13.911-2.485c1.848,0.296,2.646,2.207,1.62,3.951l-11.586,8.075
				c0.419,0.529,5.479,5.578,6.027,6.03l8.1-11.613c1.518-1.081,3.427-0.289,3.926,1.673l-2.517,13.886
				c0.695,0.048,7.942,0.075,8.599,0l-2.522-13.949c0.316-1.828,2.224-2.612,3.96-1.577l8.073,11.581
				c0.564-0.459,5.611-5.496,6.028-6.028l-11.636-8.119c-1.063-1.514-0.274-3.411,1.679-3.91l13.91,2.485
				c0.075-0.691,0.076-7.842,0-8.523l-13.962,2.481c-1.826-0.311-2.613-2.208-1.595-3.941l11.603-8.084
				c-0.405-0.487-5.45-5.577-6.025-6.027l-8.106,11.608c-1.51,1.087-3.413,0.308-3.927-1.636l2.488-13.925
				c-0.392-0.045-3.003-0.07-5.238-0.07C405.666,18.297,404.276,18.309,403.988,18.336"
            />
          </defs>
          <clipPath id="SVGIDB_266_">
            <use xlink:href="#SVGIDB_265_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_267_"
            cx="-156"
            cy="571"
            r="1"
            gradientTransform="matrix(21.7947 9.1198 9.1198 -21.7947 -1399.1893 13909.5957)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#9C9C9C" />
            <stop offset="0.5272" style="stop-color:#8F8E8E" />
            <stop offset="1" style="stop-color:#9C9C9C" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_266_)"
            fill="url(#SVGIDB_267_)"
            points="391.467,1.302 449.07,25.406 424.971,83.001
			367.366,58.897 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_268_"
              d="M404.021,18.231l2.429,14.133c-0.288,1.831-2.174,2.626-3.901,1.624l-8.234-11.719
				c-0.573,0.434-5.485,5.416-5.979,5.978l11.706,8.224c1.095,1.501,0.32,3.402-1.615,3.912l-14.099-2.457
				c-0.084,0.749-0.065,7.761,0,8.454l14.1-2.467c1.831,0.295,2.623,2.19,1.607,3.919l-11.706,8.223
				c0.446,0.564,5.393,5.498,5.979,5.981l8.246-11.732c1.504-1.072,3.399-0.287,3.895,1.658l-2.497,14.076
				c0.742,0.049,7.829,0.08,8.528,0L409.977,51.9c0.314-1.812,2.205-2.589,3.927-1.563l8.22,11.7c0.603-0.489,5.537-5.413,5.98-5.98
				l-11.755-8.265c-1.055-1.502-0.271-3.383,1.666-3.878l14.098,2.466c0.079-0.737,0.081-7.729,0-8.454l-14.149,2.461
				c-1.811-0.309-2.592-2.19-1.582-3.91l11.723-8.23c-0.434-0.518-5.364-5.498-5.979-5.978l-8.251,11.727
				c-1.499,1.077-3.386,0.305-3.896-1.622l2.469-14.114c-0.409-0.047-2.893-0.072-5.068-0.072
				C405.774,18.188,404.336,18.201,404.021,18.231"
            />
          </defs>
          <clipPath id="SVGIDB_269_">
            <use xlink:href="#SVGIDB_268_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_270_"
            cx="-156"
            cy="571"
            r="1"
            gradientTransform="matrix(21.5941 10.3336 10.3336 -21.5941 -2123.6064 13984.4258)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#9F9F9F" />
            <stop offset="0.5272" style="stop-color:#909090" />
            <stop offset="1" style="stop-color:#9F9F9F" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_269_)"
            fill="url(#SVGIDB_270_)"
            points="393.178,-0.482 450.855,27.119 423.259,84.789
			365.58,57.187 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_271_"
              d="M404.055,18.125l2.41,14.32c-0.286,1.817-2.157,2.604-3.868,1.611l-8.382-11.838
				c-0.609,0.461-5.405,5.332-5.931,5.93l11.825,8.371c1.086,1.488,0.317,3.373-1.602,3.879l-14.288-2.439
				c-0.089,0.797-0.068,7.65,0,8.387l14.289-2.447c1.816,0.291,2.603,2.171,1.593,3.885l-11.823,8.37
				c0.474,0.599,5.307,5.42,5.93,5.934l8.392-11.852c1.492-1.063,3.371-0.285,3.862,1.644l-2.477,14.264
				c0.788,0.053,7.714,0.085,8.459,0l-2.483-14.326c0.313-1.796,2.188-2.568,3.896-1.55l8.365,11.821
				c0.642-0.521,5.461-5.33,5.935-5.933l-11.876-8.411c-1.046-1.489-0.269-3.355,1.652-3.845l14.285,2.446
				c0.085-0.783,0.086-7.616,0-8.387l-14.337,2.442c-1.796-0.306-2.57-2.17-1.568-3.876l11.842-8.377
				c-0.461-0.552-5.278-5.42-5.931-5.93l-8.397,11.846c-1.485,1.069-3.357,0.303-3.862-1.609l2.449-14.302
				c-0.431-0.048-2.833-0.075-4.964-0.075C405.844,18.078,404.393,18.093,404.055,18.125"
            />
          </defs>
          <clipPath id="SVGIDB_272_">
            <use xlink:href="#SVGIDB_271_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_273_"
            cx="-155.9995"
            cy="571"
            r="0.9998"
            gradientTransform="matrix(21.234 11.636 11.636 -21.234 -2923.4209 13981.9912)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#A2A2A1" />
            <stop offset="0.5272" style="stop-color:#929292" />
            <stop offset="1" style="stop-color:#A2A2A1" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_272_)"
            fill="url(#SVGIDB_273_)"
            points="395.256,-2.224 452.597,29.198 421.179,86.531
			363.839,55.109 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_274_"
              d="M404.088,18.019l2.391,14.508c-0.282,1.8-2.137,2.582-3.835,1.598l-8.528-11.958
				c-0.646,0.488-5.326,5.249-5.882,5.881l11.943,8.519c1.078,1.476,0.315,3.344-1.587,3.846l-14.476-2.42
				c-0.095,0.844-0.074,7.538,0,8.319l14.477-2.428c1.801,0.289,2.579,2.152,1.579,3.852l-11.944,8.517
				c0.503,0.634,5.224,5.342,5.884,5.885l8.539-11.971c1.479-1.054,3.342-0.281,3.828,1.631l-2.455,14.452
				c0.834,0.057,7.599,0.09,8.388,0l-2.462-14.513c0.31-1.782,2.168-2.546,3.86-1.537l8.514,11.939
				c0.679-0.551,5.386-5.246,5.885-5.884l-11.993-8.557c-1.038-1.477-0.267-3.327,1.638-3.813l14.475,2.427
				c0.089-0.83,0.09-7.503,0-8.319L417.8,40.416c-1.782-0.304-2.548-2.153-1.556-3.843l11.961-8.525
				c-0.488-0.583-5.191-5.341-5.882-5.881l-8.544,11.965c-1.474,1.06-3.329,0.3-3.83-1.595l2.429-14.49
				c-0.45-0.051-2.752-0.078-4.83-0.078C405.932,17.969,404.453,17.985,404.088,18.019"
            />
          </defs>
          <clipPath id="SVGIDB_275_">
            <use xlink:href="#SVGIDB_274_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_276_"
            cx="-156"
            cy="571"
            r="1"
            gradientTransform="matrix(20.6764 13.0085 13.0085 -20.6764 -3794.1172 13877.6904)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#A5A5A4" />
            <stop offset="0.5272" style="stop-color:#949494" />
            <stop offset="1" style="stop-color:#A5A5A4" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_275_)"
            fill="url(#SVGIDB_276_)"
            points="397.744,-3.844 454.218,31.686 418.691,88.153
			362.218,52.623 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_277_"
              d="M404.12,17.914l2.374,14.694c-0.281,1.786-2.119,2.561-3.803,1.585l-8.676-12.078
				c-0.681,0.516-5.247,5.166-5.834,5.834l12.064,8.664c1.066,1.465,0.312,3.317-1.574,3.814l-14.665-2.4
				c-0.099,0.891-0.077,7.427,0,8.251l14.665-2.409c1.786,0.287,2.559,2.135,1.567,3.82l-12.064,8.664
				c0.53,0.669,5.138,5.262,5.835,5.837l8.686-12.09c1.467-1.046,3.313-0.28,3.797,1.616l-2.437,14.641
				c0.88,0.059,7.486,0.095,8.317,0l-2.44-14.702c0.307-1.767,2.149-2.525,3.827-1.524l8.661,12.059
				c0.715-0.582,5.308-5.162,5.837-5.835l-12.114-8.705c-1.026-1.463-0.263-3.298,1.625-3.78l14.662,2.408
				c0.095-0.876,0.096-7.39,0-8.251l-14.712,2.404c-1.766-0.301-2.527-2.135-1.542-3.811l12.079-8.671
				c-0.515-0.616-5.104-5.263-5.834-5.834L413.732,34.2c-1.461,1.051-3.302,0.297-3.799-1.581l2.411-14.678
				c-0.469-0.053-2.682-0.081-4.708-0.081C406.014,17.86,404.512,17.878,404.12,17.914"
            />
          </defs>
          <clipPath id="SVGIDB_278_">
            <use xlink:href="#SVGIDB_277_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_279_"
            cx="-156"
            cy="571"
            r="1"
            gradientTransform="matrix(19.8817 14.4193 14.4193 -19.8817 -4723.6284 13643.9922)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#A8A8A7" />
            <stop offset="0.5272" style="stop-color:#969695" />
            <stop offset="1" style="stop-color:#A8A8A7" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_278_)"
            fill="url(#SVGIDB_279_)"
            points="400.666,-5.247 455.62,34.609 415.768,89.559
			360.813,49.703 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_280_"
              d="M404.154,17.808l2.354,14.882c-0.278,1.771-2.102,2.539-3.77,1.571l-8.823-12.197
				c-0.717,0.543-5.168,5.083-5.785,5.786l12.184,8.811c1.059,1.451,0.31,3.288-1.561,3.781l-14.853-2.381
				c-0.105,0.938-0.081,7.316,0,8.182l14.853-2.388c1.771,0.284,2.536,2.116,1.552,3.787l-12.181,8.81
				c0.557,0.704,5.052,5.184,5.785,5.788l8.832-12.209c1.455-1.036,3.285-0.277,3.764,1.603l-2.415,14.83
				c0.927,0.062,7.372,0.1,8.247,0l-2.421-14.89c0.304-1.751,2.131-2.503,3.797-1.511l8.806,12.178
				c0.754-0.612,5.233-5.079,5.788-5.787l-12.23-8.851c-1.021-1.452-0.262-3.27,1.61-3.747l14.85,2.387
				c0.099-0.921,0.101-7.275,0-8.182l-14.899,2.384c-1.752-0.297-2.506-2.115-1.529-3.778l12.198-8.817
				c-0.542-0.649-5.018-5.186-5.785-5.786l-8.837,12.205c-1.447,1.041-3.273,0.294-3.766-1.568l2.391-14.867
				c-0.487-0.055-2.622-0.084-4.6-0.084C406.088,17.75,404.571,17.769,404.154,17.808"
            />
          </defs>
          <clipPath id="SVGIDB_281_">
            <use xlink:href="#SVGIDB_280_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_282_"
            cx="-156"
            cy="571"
            r="1"
            gradientTransform="matrix(18.8143 15.8201 15.8201 -18.8143 -5690.0361 13253.0859)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#ABAAAA" />
            <stop offset="0.5272" style="stop-color:#989897" />
            <stop offset="1" style="stop-color:#ABAAAA" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_281_)"
            fill="url(#SVGIDB_282_)"
            points="404.025,-6.309 456.683,37.968 412.408,90.623
			359.751,46.346 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_283_"
              d="M404.188,17.703l2.336,15.069c-0.276,1.755-2.082,2.517-3.737,1.557l-8.969-12.316
				c-0.753,0.569-5.089,4.999-5.737,5.737l12.303,8.959c1.049,1.438,0.308,3.26-1.547,3.748l-15.041-2.362
				c-0.111,0.984-0.086,7.204,0,8.114l15.041-2.37c1.755,0.283,2.514,2.098,1.539,3.755l-12.302,8.957
				c0.586,0.739,4.968,5.106,5.737,5.74l8.979-12.328c1.442-1.027,3.257-0.274,3.732,1.589l-2.396,15.018
				c0.973,0.065,7.257,0.105,8.177,0l-2.399-15.078c0.301-1.736,2.112-2.481,3.763-1.498l8.953,12.298
				c0.791-0.642,5.157-4.995,5.74-5.739l-12.352-8.997c-1.01-1.439-0.259-3.241,1.598-3.716l15.037,2.369
				c0.105-0.967,0.106-7.162,0-8.114l-15.087,2.365c-1.736-0.295-2.483-2.098-1.516-3.745l12.318-8.965
				c-0.569-0.68-4.933-5.107-5.737-5.737l-8.984,12.323c-1.436,1.034-3.245,0.293-3.731-1.553l2.37-15.055
				c-0.508-0.058-2.565-0.087-4.494-0.087C406.161,17.641,404.632,17.661,404.188,17.703"
            />
          </defs>
          <clipPath id="SVGIDB_284_">
            <use xlink:href="#SVGIDB_283_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_285_"
            cx="-156"
            cy="571"
            r="1"
            gradientTransform="matrix(17.4812 17.1762 17.1762 -17.4812 -6672.333 12703.4248)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#ADADAD" />
            <stop offset="0.5272" style="stop-color:#9A9A99" />
            <stop offset="1" style="stop-color:#ADADAD" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_284_)"
            fill="url(#SVGIDB_285_)"
            points="407.785,-6.888 457.262,41.727 408.648,91.204
			359.171,42.589 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_286_"
              d="M404.22,17.597l2.319,15.257c-0.275,1.74-2.066,2.495-3.706,1.544l-9.116-12.437
				c-0.788,0.598-5.009,4.917-5.688,5.69l12.422,9.105c1.041,1.426,0.305,3.231-1.533,3.716l-15.228-2.343
				c-0.116,1.031-0.091,7.093,0,8.046l15.228-2.35c1.74,0.28,2.493,2.08,1.526,3.722l-12.422,9.103
				c0.614,0.775,4.884,5.027,5.69,5.692l9.125-12.447c1.429-1.018,3.229-0.272,3.699,1.576l-2.375,15.205
				c1.02,0.069,7.144,0.11,8.106,0l-2.38-15.265c0.298-1.722,2.096-2.46,3.73-1.486l9.1,12.418c0.829-0.674,5.08-4.911,5.692-5.691
				l-12.469-9.143c-1.004-1.426-0.258-3.213,1.582-3.683l15.226,2.349c0.109-1.014,0.111-7.048,0-8.046l-15.274,2.346
				c-1.721-0.293-2.463-2.08-1.503-3.713l12.438-9.111c-0.597-0.714-4.845-5.029-5.689-5.69l-9.131,12.444
				c-1.423,1.024-3.215,0.29-3.699-1.541l2.352-15.242c-0.525-0.061-2.515-0.09-4.396-0.09
				C406.229,17.532,404.691,17.554,404.22,17.597"
            />
          </defs>
          <clipPath id="SVGIDB_287_">
            <use xlink:href="#SVGIDB_286_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_288_"
            cx="-156"
            cy="571"
            r="1"
            gradientTransform="matrix(16.1669 18.7586 18.7586 -16.1669 -7780.9199 12199.7988)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#B0B0B0" />
            <stop offset="0.5272" style="stop-color:#9C9C9B" />
            <stop offset="1" style="stop-color:#B0B0B0" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_287_)"
            fill="url(#SVGIDB_288_)"
            points="411.854,-6.842 457.217,45.794 404.579,91.16
			359.216,38.524 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_289_"
              d="M404.253,17.491l2.3,15.445c-0.271,1.724-2.047,2.472-3.672,1.53l-9.263-12.556
				c-0.825,0.625-4.931,4.833-5.642,5.641l12.542,9.252c1.031,1.414,0.303,3.203-1.521,3.683l-15.417-2.323
				c-0.12,1.078-0.093,6.981,0,7.978l15.418-2.331c1.725,0.277,2.471,2.062,1.512,3.689l-12.539,9.251
				c0.641,0.809,4.798,4.948,5.642,5.643l9.271-12.566c1.415-1.01,3.199-0.27,3.665,1.561l-2.354,15.394
				c1.065,0.072,7.029,0.115,8.037,0l-2.36-15.453c0.296-1.706,2.076-2.438,3.697-1.472l9.247,12.537
				c0.866-0.704,5.005-4.828,5.644-5.643l-12.588-9.289c-0.993-1.414-0.255-3.185,1.568-3.65l15.415,2.329
				c0.113-1.06,0.115-6.935,0-7.978l-15.464,2.327c-1.705-0.291-2.439-2.061-1.489-3.68l12.557-9.259
				c-0.624-0.745-4.758-4.95-5.641-5.641l-9.277,12.563c-1.41,1.014-3.187,0.287-3.667-1.527l2.332-15.431
				c-0.547-0.062-2.483-0.093-4.327-0.093C406.279,17.422,404.748,17.445,404.253,17.491"
            />
          </defs>
          <clipPath id="SVGIDB_290_">
            <use xlink:href="#SVGIDB_289_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_291_"
            cx="-156"
            cy="570.999"
            r="1.0004"
            gradientTransform="matrix(14.5763 20.2596 20.2596 -14.5763 -8886.0918 11525.7285)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#B3B3B2" />
            <stop offset="0.5272" style="stop-color:#9E9D9D" />
            <stop offset="1" style="stop-color:#B3B3B2" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_290_)"
            fill="url(#SVGIDB_291_)"
            points="416.084,-6.05 456.427,50.022 400.349,90.369
			360.006,34.297 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_292_"
              d="M404.286,17.386l2.282,15.632c-0.27,1.709-2.029,2.451-3.641,1.515l-9.41-12.674
				c-0.859,0.651-4.851,4.75-5.592,5.593l12.661,9.399c1.022,1.4,0.3,3.174-1.507,3.65l-15.605-2.304
				c-0.126,1.125-0.098,6.869,0,7.91l15.606-2.312c1.709,0.275,2.448,2.043,1.499,3.657l-12.66,9.397
				c0.67,0.845,4.714,4.87,5.593,5.595l9.418-12.685c1.405-1.001,3.173-0.268,3.636,1.547l-2.334,15.583
				c1.111,0.075,6.914,0.12,7.966,0l-2.339-15.641c0.293-1.691,2.057-2.416,3.664-1.46l9.394,12.657
				c0.903-0.735,4.928-4.744,5.595-5.594l-12.707-9.437c-0.984-1.4-0.253-3.156,1.555-3.618l15.603,2.311
				c0.119-1.107,0.12-6.822,0-7.911l-15.651,2.308c-1.689-0.287-2.419-2.043-1.476-3.647l12.675-9.405
				c-0.648-0.778-4.671-4.872-5.592-5.593l-9.423,12.682c-1.398,1.006-3.159,0.285-3.634-1.513l2.312-15.62
				c-0.564-0.064-2.434-0.096-4.231-0.096C406.347,17.312,404.809,17.337,404.286,17.386"
            />
          </defs>
          <clipPath id="SVGIDB_293_">
            <use xlink:href="#SVGIDB_292_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_294_"
            cx="-156"
            cy="570.999"
            r="1.0004"
            gradientTransform="matrix(12.66 21.4947 21.4947 -12.66 -9890.3066 10624.2158)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#B6B5B5" />
            <stop offset="0.5272" style="stop-color:#A09F9F" />
            <stop offset="1" style="stop-color:#B6B5B5" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_293_)"
            fill="url(#SVGIDB_294_)"
            points="420.273,-4.436 454.813,54.209 396.158,88.757
			361.617,30.112 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_295_"
              d="M404.319,17.28l2.264,15.82c-0.267,1.693-2.011,2.428-3.607,1.502l-9.557-12.794
				c-0.896,0.678-4.772,4.666-5.544,5.544l12.78,9.547c1.014,1.387,0.297,3.145-1.493,3.617l-15.793-2.285
				c-0.131,1.172-0.103,6.758,0,7.841l15.794-2.291c1.694,0.271,2.427,2.024,1.485,3.623l-12.779,9.544
				c0.698,0.88,4.629,4.792,5.545,5.548l9.564-12.806c1.393-0.991,3.144-0.265,3.602,1.534l-2.314,15.772
				c1.158,0.078,6.803,0.125,7.897,0l-2.319-15.83c0.291-1.675,2.039-2.395,3.631-1.446l9.541,12.776
				c0.941-0.766,4.853-4.661,5.547-5.546l-12.825-9.583c-0.977-1.388-0.25-3.128,1.54-3.585l15.791,2.29
				c0.124-1.152,0.126-6.707,0-7.841l-15.838,2.288c-1.676-0.285-2.397-2.025-1.464-3.615l12.796-9.552
				c-0.679-0.81-4.586-4.794-5.546-5.545l-9.568,12.802c-1.386,0.997-3.131,0.283-3.603-1.499l2.292-15.808
				c-0.583-0.067-2.395-0.099-4.149-0.099C406.405,17.203,404.869,17.229,404.319,17.28"
            />
          </defs>
          <clipPath id="SVGIDB_296_">
            <use xlink:href="#SVGIDB_295_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_297_"
            cx="-156"
            cy="571"
            r="1"
            gradientTransform="matrix(10.4881 22.3661 22.3661 -10.4881 -10726.6904 9519.9434)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#B8B8B8" />
            <stop offset="0.5272" style="stop-color:#A1A1A1" />
            <stop offset="1" style="stop-color:#B8B8B8" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_296_)"
            fill="url(#SVGIDB_297_)"
            points="424.189,-2 452.383,58.123 392.243,86.324 364.05,26.201
					"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_298_"
              d="M404.354,17.174l2.243,16.007c-0.264,1.678-1.991,2.407-3.573,1.489l-9.703-12.913
				c-0.933,0.706-4.694,4.583-5.497,5.496l12.9,9.692c1.003,1.377,0.294,3.118-1.479,3.586l-15.982-2.266
				c-0.136,1.219-0.104,6.646,0,7.773l15.983-2.272c1.679,0.27,2.404,2.007,1.472,3.591l-12.898,9.69
				c0.725,0.915,4.544,4.713,5.497,5.499l9.711-12.924c1.379-0.982,3.114-0.263,3.568,1.52l-2.294,15.96
				c1.204,0.081,6.688,0.13,7.827,0l-2.299-16.018c0.288-1.66,2.021-2.372,3.599-1.432l9.688,12.895
				c0.979-0.797,4.775-4.577,5.499-5.498l-12.945-9.729c-0.966-1.375-0.248-3.1,1.527-3.553l15.978,2.271
				c0.129-1.198,0.132-6.594,0-7.773l-16.025,2.269c-1.66-0.283-2.375-2.006-1.449-3.582l12.914-9.699
				c-0.705-0.843-4.498-4.716-5.497-5.496l-9.716,12.92c-1.372,0.988-3.103,0.279-3.569-1.486l2.272-15.995
				c-0.604-0.069-2.373-0.102-4.094-0.102C406.448,17.094,404.926,17.121,404.354,17.174"
            />
          </defs>
          <clipPath id="SVGIDB_299_">
            <use xlink:href="#SVGIDB_298_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_300_"
            cx="-155.999"
            cy="571"
            r="0.9996"
            gradientTransform="matrix(8.3641 23.3564 23.3564 -8.3641 -11623.5205 8461.6348)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#BBBBBA" />
            <stop offset="0.5272" style="stop-color:#A3A3A3" />
            <stop offset="1" style="stop-color:#BBBBBA" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_299_)"
            fill="url(#SVGIDB_300_)"
            points="427.603,1.167 449.22,61.533 388.83,83.159
			367.212,22.793 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_301_"
              d="M404.386,17.069l2.227,16.194c-0.262,1.663-1.975,2.385-3.542,1.476l-9.851-13.033
				c-0.968,0.732-4.613,4.5-5.448,5.448l13.021,9.839c0.995,1.364,0.292,3.089-1.466,3.552l-16.17-2.246
				c-0.143,1.265-0.11,6.535,0,7.705l16.171-2.253c1.663,0.267,2.382,1.988,1.458,3.558l-13.019,9.838
				c0.755,0.95,4.459,4.634,5.449,5.45l9.858-13.043c1.366-0.973,3.086-0.261,3.536,1.506l-2.273,16.148
				c1.25,0.085,6.573,0.135,7.756,0l-2.277-16.205c0.284-1.645,2.002-2.351,3.564-1.42l9.834,13.015
				c1.018-0.827,4.701-4.493,5.45-5.45l-13.063-9.875c-0.958-1.364-0.245-3.072,1.514-3.521l16.166,2.252
				c0.134-1.244,0.136-6.481,0-7.705l-16.213,2.25c-1.646-0.281-2.354-1.989-1.438-3.55l13.033-9.846
				c-0.731-0.874-4.411-4.637-5.447-5.447l-9.862,13.04c-1.36,0.978-3.074,0.276-3.537-1.473l2.254-16.184
				c-0.623-0.071-2.336-0.105-4.014-0.105C406.507,16.984,404.987,17.013,404.386,17.069"
            />
          </defs>
          <clipPath id="SVGIDB_302_">
            <use xlink:href="#SVGIDB_301_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_303_"
            cx="-155.999"
            cy="571"
            r="0.9996"
            gradientTransform="matrix(6.2478 24.454 24.454 -6.2478 -12580.3477 7424.4629)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#BDBDBD" />
            <stop offset="0.5272" style="stop-color:#A5A5A5" />
            <stop offset="1" style="stop-color:#BDBDBD" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_302_)"
            fill="url(#SVGIDB_303_)"
            points="430.327,4.896 445.494,64.257 386.103,79.431
			370.936,20.07 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_304_"
              d="M404.418,16.964l2.209,16.381c-0.259,1.647-1.956,2.363-3.509,1.462l-9.997-13.153
				c-1.004,0.76-4.535,4.417-5.4,5.4l13.141,9.987c0.984,1.35,0.288,3.061-1.453,3.519l-16.358-2.228
				c-0.146,1.313-0.115,6.425,0,7.638l16.358-2.233c1.648,0.264,2.36,1.969,1.445,3.525l-13.138,9.984
				c0.781,0.985,4.374,4.556,5.4,5.402l10.004-13.162c1.354-0.965,3.059-0.258,3.504,1.492l-2.252,16.336
				c1.296,0.088,6.46,0.14,7.685,0.001L409.8,50.922c0.283-1.63,1.984-2.33,3.533-1.407l9.979,13.133
				c1.056-0.856,4.625-4.409,5.403-5.401l-13.183-10.021c-0.949-1.351-0.244-3.044,1.499-3.488l16.354,2.232
				c0.139-1.29,0.142-6.368,0-7.638l-16.401,2.231c-1.63-0.278-2.332-1.97-1.423-3.517l13.152-9.992
				c-0.759-0.908-4.326-4.559-5.399-5.4l-10.01,13.159c-1.348,0.971-3.046,0.275-3.505-1.459l2.235-16.371
				c-0.643-0.073-2.306-0.108-3.944-0.108C406.557,16.875,405.046,16.905,404.418,16.964"
            />
          </defs>
          <clipPath id="SVGIDB_305_">
            <use xlink:href="#SVGIDB_304_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_306_"
            cx="-155.9995"
            cy="571"
            r="0.9998"
            gradientTransform="matrix(4.0274 25.1386 25.1386 -4.0274 -13317.6221 6263.4346)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#C0C0C0" />
            <stop offset="0.5272" style="stop-color:#A7A7A7" />
            <stop offset="1" style="stop-color:#C0C0C0" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_305_)"
            fill="url(#SVGIDB_306_)"
            points="432.261,8.967 441.429,66.188 384.17,75.362
			375.003,18.141 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_307_"
              d="M404.452,16.857l2.188,16.569c-0.256,1.633-1.937,2.341-3.476,1.449l-10.144-13.272
				c-1.039,0.788-4.455,4.334-5.353,5.352l13.26,10.134c0.977,1.337,0.285,3.032-1.438,3.486l-16.547-2.208
				c-0.153,1.359-0.118,6.312,0,7.569l16.547-2.215c1.632,0.263,2.339,1.952,1.432,3.493l-13.257,10.131
				c0.809,1.021,4.289,4.477,5.352,5.354l10.151-13.281c1.341-0.956,3.03-0.256,3.471,1.478l-2.231,16.525
				c1.343,0.091,6.346,0.145,7.614,0l-2.236-16.58c0.281-1.616,1.966-2.309,3.5-1.395L423.413,62.7
				c1.092-0.889,4.548-4.326,5.353-5.353l-13.301-10.169c-0.94-1.338-0.241-3.015,1.485-3.456l16.543,2.214
				c0.144-1.336,0.146-6.255,0-7.569l-16.589,2.211c-1.615-0.275-2.311-1.951-1.41-3.484l13.271-10.139
				c-0.786-0.94-4.237-4.482-5.351-5.352l-10.155,13.279c-1.336,0.96-3.019,0.272-3.472-1.446l2.215-16.56
				c-0.662-0.075-2.284-0.111-3.886-0.111C406.602,16.765,405.105,16.797,404.452,16.857"
            />
          </defs>
          <clipPath id="SVGIDB_308_">
            <use xlink:href="#SVGIDB_307_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_309_"
            cx="-155.999"
            cy="571"
            r="0.9995"
            gradientTransform="matrix(1.8176 25.4222 25.4222 -1.8176 -13824.2871 5045.8789)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#C3C2C2" />
            <stop offset="0.5272" style="stop-color:#A9A9A9" />
            <stop offset="1" style="stop-color:#C3C2C2" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_308_)"
            fill="url(#SVGIDB_309_)"
            points="433.38,13.148 437.253,67.308 383.049,71.183
			379.176,17.023 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_310_"
              d="M404.485,16.752l2.172,16.756c-0.255,1.618-1.92,2.32-3.445,1.435l-10.289-13.391
				c-1.077,0.814-4.378,4.25-5.304,5.304l13.378,10.279c0.967,1.326,0.283,3.005-1.425,3.455l-16.736-2.189
				c-0.157,1.406-0.121,6.201,0,7.5l16.736-2.194c1.617,0.26,2.315,1.933,1.418,3.46l-13.376,10.277
				c0.837,1.056,4.204,4.4,5.304,5.306l10.298-13.4c1.328-0.947,3-0.254,3.438,1.464l-2.211,16.713c1.388,0.094,6.23,0.151,7.544,0
				l-2.216-16.768c0.276-1.601,1.945-2.286,3.466-1.381l10.274,13.372c1.13-0.918,4.473-4.241,5.306-5.304l-13.421-10.314
				c-0.931-1.326-0.238-2.987,1.472-3.424l16.73,2.193c0.148-1.382,0.151-6.14,0-7.5l-16.776,2.192
				c-1.6-0.273-2.289-1.934-1.397-3.452l13.392-10.285c-0.813-0.973-4.151-4.403-5.304-5.304L413.211,34.95
				c-1.323,0.951-2.99,0.269-3.439-1.433l2.195-16.747c-0.681-0.078-2.257-0.114-3.822-0.114
				C406.649,16.656,405.164,16.689,404.485,16.752"
            />
          </defs>
          <clipPath id="SVGIDB_311_">
            <use xlink:href="#SVGIDB_310_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_312_"
            cx="-155.999"
            cy="571"
            r="0.9995"
            gradientTransform="matrix(-0.288 25.4881 25.4881 0.288 -14190.4258 3853.8284)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#C5C5C5" />
            <stop offset="0.5272" style="stop-color:#ABABAA" />
            <stop offset="1" style="stop-color:#C5C5C5" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_311_)"
            fill="url(#SVGIDB_312_)"
            points="434.326,16.663 433.743,68.255 382.103,67.671
			382.686,16.079 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_313_"
              d="M404.518,16.647l2.153,16.943c-0.252,1.602-1.902,2.297-3.411,1.421L392.823,21.5
				c-1.112,0.842-4.299,4.168-5.255,5.257l13.498,10.426c0.957,1.313,0.279,2.975-1.412,3.422l-16.924-2.17
				c-0.163,1.453-0.127,6.088,0,7.432l16.924-2.175c1.602,0.257,2.295,1.915,1.404,3.427l-13.496,10.425
				c0.865,1.091,4.119,4.321,5.257,5.257l10.443-13.519c1.315-0.938,2.973-0.251,3.406,1.45l-2.19,16.902
				c1.435,0.097,6.116,0.155,7.474,0l-2.197-16.956c0.276-1.585,1.929-2.266,3.437-1.368l10.42,13.492
				c1.168-0.95,4.396-4.159,5.257-5.257l-13.539-10.46c-0.923-1.314-0.237-2.959,1.457-3.392l16.919,2.174
				c0.154-1.428,0.156-6.026,0-7.433l-16.964,2.174c-1.585-0.27-2.268-1.916-1.383-3.42l13.51-10.431
				c-0.84-1.006-4.066-4.326-5.256-5.257l-10.448,13.518c-1.311,0.943-2.961,0.267-3.407-1.419l2.176-16.936
				c-0.697-0.08-2.229-0.117-3.755-0.117C406.699,16.546,405.225,16.581,404.518,16.647"
            />
          </defs>
          <clipPath id="SVGIDB_314_">
            <use xlink:href="#SVGIDB_313_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_315_"
            cx="-155.999"
            cy="571"
            r="0.9995"
            gradientTransform="matrix(-2.2736 25.6161 25.6161 2.2736 -14573.2686 2740.0625)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#C8C8C7" />
            <stop offset="0.5272" style="stop-color:#ADADAC" />
            <stop offset="1" style="stop-color:#C8C8C7" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_314_)"
            fill="url(#SVGIDB_315_)"
            points="438.373,16.946 433.46,72.306 378.055,67.389
			382.968,12.029 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_316_"
              d="M404.551,16.541l2.134,17.131c-0.249,1.586-1.882,2.275-3.378,1.408l-10.583-13.631
				c-1.147,0.869-4.22,4.084-5.208,5.208l13.617,10.574c0.95,1.3,0.278,2.946-1.396,3.388l-17.112-2.151
				c-0.168,1.501-0.131,5.978,0,7.365l17.112-2.156c1.586,0.255,2.271,1.897,1.391,3.394l-13.615,10.572
				c0.894,1.127,4.035,4.242,5.208,5.209l10.59-13.639c1.305-0.928,2.944-0.248,3.374,1.437l-2.171,17.09
				c1.481,0.101,6.003,0.16,7.404,0l-2.176-17.144c0.272-1.57,1.91-2.243,3.401-1.355l10.567,13.612
				c1.206-0.98,4.32-4.074,5.209-5.209l-13.658-10.607c-0.914-1.3-0.233-2.93,1.443-3.359l17.105,2.155
				c0.16-1.474,0.162-5.913,0-7.365l-17.15,2.154c-1.569-0.267-2.245-1.896-1.37-3.386l13.629-10.579
				c-0.867-1.037-3.979-4.247-5.207-5.208l-10.594,13.637c-1.298,0.933-2.934,0.265-3.374-1.405l2.156-17.124
				c-0.721-0.082-2.218-0.121-3.71-0.121C406.734,16.436,405.283,16.473,404.551,16.541"
            />
          </defs>
          <clipPath id="SVGIDB_317_">
            <use xlink:href="#SVGIDB_316_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_318_"
            cx="-155.999"
            cy="571"
            r="0.9996"
            gradientTransform="matrix(-4.1187 25.5231 25.5231 4.1187 -14807.9854 1672.0026)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#CACACA" />
            <stop offset="0.5272" style="stop-color:#AFAFAE" />
            <stop offset="1" style="stop-color:#CACACA" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_317_)"
            fill="url(#SVGIDB_318_)"
            points="442.066,17.742 432.664,76.002 374.362,66.594
			383.764,8.334 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_319_"
              d="M404.584,16.435l2.117,17.318c-0.248,1.572-1.865,2.254-3.348,1.394l-10.729-13.749
				c-1.184,0.895-4.14,4-5.159,5.16l13.737,10.72c0.939,1.287,0.274,2.918-1.385,3.356l-17.301-2.132
				c-0.173,1.547-0.134,5.867,0,7.297l17.302-2.136c1.57,0.252,2.25,1.878,1.377,3.362l-13.734,10.717
				c0.92,1.162,3.95,4.164,5.159,5.161l10.737-13.758c1.291-0.92,2.916-0.246,3.341,1.423l-2.15,17.279
				c1.528,0.102,5.89,0.165,7.334,0l-2.155-17.332c0.27-1.555,1.891-2.222,3.368-1.342l10.714,13.73
				c1.244-1.01,4.244-3.99,5.161-5.16L415.193,46.99c-0.905-1.288-0.232-2.902,1.429-3.326l17.295,2.135
				c0.164-1.52,0.167-5.8,0-7.297l-17.339,2.135c-1.554-0.264-2.225-1.878-1.357-3.354l13.748-10.725
				c-0.894-1.071-3.892-4.169-5.159-5.16l-10.74,13.756c-1.285,0.925-2.904,0.261-3.341-1.391l2.137-17.312
				c-0.739-0.085-2.196-0.124-3.654-0.124C406.777,16.327,405.342,16.365,404.584,16.435"
            />
          </defs>
          <clipPath id="SVGIDB_320_">
            <use xlink:href="#SVGIDB_319_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_321_"
            cx="-155.999"
            cy="571.001"
            r="0.9992"
            gradientTransform="matrix(-5.7876 25.209 25.209 5.7876 -14889.0176 670.0475)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#CDCDCD" />
            <stop offset="0.5272" style="stop-color:#B1B0B0" />
            <stop offset="1" style="stop-color:#CDCDCD" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_320_)"
            fill="url(#SVGIDB_321_)"
            points="445.355,18.915 431.493,79.296 371.072,65.424
			384.935,5.043 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_322_"
              d="M404.617,16.33l2.098,17.505c-0.245,1.556-1.847,2.232-3.313,1.381l-10.876-13.868
				c-1.221,0.922-4.063,3.915-5.111,5.11l13.855,10.867c0.932,1.276,0.273,2.89-1.371,3.324l-17.487-2.112
				c-0.179,1.593-0.14,5.754,0,7.228l17.488-2.117c1.557,0.25,2.229,1.86,1.364,3.329L387.41,57.841
				c0.949,1.197,3.866,4.086,5.111,5.113l10.884-13.877c1.277-0.91,2.887-0.244,3.308,1.409l-2.13,17.467
				c1.574,0.106,5.775,0.17,7.264,0l-2.136-17.52c0.268-1.539,1.874-2.2,3.336-1.329l10.862,13.85
				c1.28-1.041,4.168-3.906,5.112-5.111l-13.896-10.9c-0.896-1.276-0.23-2.874,1.415-3.294l17.483,2.116
				c0.169-1.566,0.172-5.687,0-7.228l-17.527,2.115c-1.539-0.262-2.201-1.861-1.343-3.321l13.868-10.873
				c-0.923-1.102-3.807-4.09-5.111-5.111l-10.889,13.875c-1.271,0.916-2.875,0.259-3.309-1.378l2.118-17.5
				c-0.758-0.086-2.176-0.127-3.6-0.127C406.819,16.217,405.402,16.257,404.617,16.33"
            />
          </defs>
          <clipPath id="SVGIDB_323_">
            <use xlink:href="#SVGIDB_322_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_324_"
            cx="-155.999"
            cy="571"
            r="0.9996"
            gradientTransform="matrix(-7.2664 24.7338 24.7338 7.2664 -14848.3799 -248.5095)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#D0CFCF" />
            <stop offset="0.5272" style="stop-color:#B2B2B2" />
            <stop offset="1" style="stop-color:#D0CFCF" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_323_)"
            fill="url(#SVGIDB_324_)"
            points="448.232,20.341 430.066,82.176 368.194,63.999
			386.36,2.164 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_325_"
              d="M404.651,16.224l2.079,17.693c-0.243,1.541-1.828,2.209-3.281,1.367l-11.024-13.988
				c-1.255,0.95-3.981,3.833-5.063,5.063l13.977,11.014c0.921,1.263,0.27,2.861-1.358,3.29l-17.677-2.093
				c-0.183,1.642-0.143,5.644,0,7.16l17.678-2.097c1.54,0.248,2.206,1.842,1.351,3.296l-13.973,11.012
				c0.976,1.232,3.78,4.006,5.063,5.064l11.03-13.996c1.266-0.902,2.858-0.241,3.276,1.395l-2.11,17.655
				c1.621,0.11,5.661,0.176,7.194,0l-2.115-17.708c0.264-1.524,1.854-2.178,3.303-1.315l11.008,13.969
				c1.318-1.071,4.091-3.823,5.064-5.063l-14.016-11.046c-0.887-1.264-0.228-2.846,1.401-3.262l17.671,2.096
				c0.175-1.612,0.177-5.572,0-7.16l-17.714,2.096c-1.523-0.259-2.18-1.841-1.331-3.288l13.987-11.019
				c-0.948-1.135-3.72-4.013-5.063-5.063L412.975,35.29c-1.26,0.908-2.848,0.257-3.275-1.364l2.098-17.689
				c-0.779-0.088-2.163-0.129-3.554-0.129C406.855,16.108,405.46,16.149,404.651,16.224"
            />
          </defs>
          <clipPath id="SVGIDB_326_">
            <use xlink:href="#SVGIDB_325_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_327_"
            cx="-155.999"
            cy="571"
            r="0.9996"
            gradientTransform="matrix(-8.5568 24.1501 24.1501 8.5568 -14716.3223 -1076.3672)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#D2D2D2" />
            <stop offset="0.5272" style="stop-color:#B4B4B4" />
            <stop offset="1" style="stop-color:#D2D2D2" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_326_)"
            fill="url(#SVGIDB_327_)"
            points="450.716,21.922 428.485,84.663 365.712,62.421
			387.941,-0.32 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_328_"
              d="M404.683,16.119l2.063,17.88c-0.241,1.525-1.812,2.187-3.248,1.353l-11.171-14.107
				c-1.292,0.976-3.903,3.749-5.016,5.015l14.097,11.161c0.912,1.25,0.267,2.833-1.345,3.258l-17.864-2.075
				c-0.19,1.689-0.147,5.532,0,7.092l17.864-2.078c1.526,0.246,2.186,1.823,1.339,3.263L387.308,58.04
				c1.005,1.267,3.696,3.928,5.016,5.015l11.176-14.114c1.253-0.893,2.831-0.239,3.244,1.381l-2.09,17.843
				c1.667,0.114,5.547,0.181,7.124,0l-2.096-17.895c0.263-1.509,1.836-2.156,3.271-1.302l11.155,14.088
				c1.355-1.102,4.015-3.739,5.015-5.015l-14.133-11.193c-0.879-1.25-0.226-2.817,1.388-3.229l17.858,2.077
				c0.179-1.659,0.182-5.459,0-7.092l-17.902,2.077c-1.508-0.257-2.158-1.823-1.317-3.256l14.106-11.165
				c-0.976-1.168-3.632-3.934-5.014-5.015l-11.181,14.114c-1.248,0.897-2.819,0.253-3.245-1.351l2.079-17.877
				c-0.797-0.091-2.144-0.132-3.502-0.132C406.895,15.999,405.52,16.041,404.683,16.119"
            />
          </defs>
          <clipPath id="SVGIDB_329_">
            <use xlink:href="#SVGIDB_328_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_330_"
            cx="-155.999"
            cy="571"
            r="0.9996"
            gradientTransform="matrix(-9.67 23.5 23.5 9.67 -14518.793 -1813.3916)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#D5D5D5" />
            <stop offset="0.5272" style="stop-color:#B6B6B6" />
            <stop offset="1" style="stop-color:#D5D5D5" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_329_)"
            fill="url(#SVGIDB_330_)"
            points="452.838,23.579 426.828,86.789 363.587,60.766
			389.597,-2.444 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_331_"
              d="M404.716,16.013l2.043,18.068c-0.237,1.51-1.792,2.165-3.216,1.34l-11.316-14.227
				c-1.327,1.003-3.823,3.666-4.967,4.966l14.215,11.307c0.903,1.238,0.266,2.806-1.331,3.226l-18.053-2.055
				c-0.194,1.736-0.149,5.421,0,7.024l18.053-2.058c1.511,0.243,2.164,1.805,1.325,3.231l-14.212,11.304
				c1.032,1.302,3.611,3.85,4.966,4.968l11.324-14.235c1.24-0.884,2.802-0.237,3.21,1.368l-2.069,18.033
				c1.715,0.115,5.435,0.184,7.055,0l-2.075-18.085c0.259-1.494,1.818-2.135,3.238-1.289l11.301,14.209
				c1.394-1.134,3.94-3.656,4.968-4.968l-14.253-11.339c-0.87-1.237-0.223-2.789,1.374-3.197l18.046,2.058
				c0.186-1.705,0.188-5.346,0-7.024l-18.089,2.058c-1.494-0.254-2.137-1.806-1.304-3.223l14.225-11.313
				c-1.002-1.2-3.546-3.856-4.966-4.966L412.88,35.426c-1.235,0.889-2.791,0.252-3.211-1.336l2.06-18.065
				c-0.816-0.093-2.129-0.136-3.453-0.136C406.934,15.889,405.58,15.933,404.716,16.013"
            />
          </defs>
          <clipPath id="SVGIDB_332_">
            <use xlink:href="#SVGIDB_331_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_333_"
            cx="-156"
            cy="571"
            r="1"
            gradientTransform="matrix(-10.8673 23.3421 23.3421 10.8673 -14615.3887 -2521.7078)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#D7D7D7" />
            <stop offset="0.5272" style="stop-color:#B8B8B7" />
            <stop offset="1" style="stop-color:#D7D7D7" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_332_)"
            fill="url(#SVGIDB_333_)"
            points="454.644,25.253 425.153,88.596 361.783,59.093
			391.272,-4.25 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_334_"
              d="M404.75,15.907l2.024,18.256c-0.235,1.495-1.774,2.143-3.184,1.325l-11.464-14.346
				c-1.363,1.032-3.745,3.583-4.919,4.919l14.336,11.454c0.894,1.225,0.262,2.777-1.318,3.192l-18.24-2.034
				c-0.2,1.781-0.155,5.308,0,6.955l18.24-2.039c1.495,0.241,2.143,1.787,1.312,3.198l-14.331,11.452
				c1.06,1.337,3.526,3.77,4.918,4.919l11.47-14.353c1.228-0.875,2.774-0.235,3.178,1.352l-2.049,18.222
				c1.761,0.119,5.319,0.19,6.983,0l-2.053-18.272c0.256-1.479,1.799-2.113,3.205-1.276l11.446,14.327
				c1.433-1.164,3.864-3.572,4.919-4.919l-14.37-11.484c-0.861-1.226-0.222-2.762,1.359-3.165l18.235,2.038
				c0.188-1.751,0.191-5.233,0-6.955L416.17,40.71c-1.478-0.251-2.115-1.786-1.29-3.189l14.344-11.46
				c-1.029-1.232-3.46-3.778-4.918-4.919l-11.473,14.353c-1.223,0.88-2.764,0.249-3.179-1.324l2.04-18.252
				c-0.836-0.096-2.117-0.139-3.41-0.139C406.968,15.78,405.638,15.825,404.75,15.907"
            />
          </defs>
          <clipPath id="SVGIDB_335_">
            <use xlink:href="#SVGIDB_334_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_336_"
            cx="-155.999"
            cy="571.001"
            r="0.9993"
            gradientTransform="matrix(-11.9599 23.1422 23.1422 11.9599 -14671.7471 -3176.7788)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#DADADA" />
            <stop offset="0.5272" style="stop-color:#BAB9B9" />
            <stop offset="1" style="stop-color:#DADADA" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_335_)"
            fill="url(#SVGIDB_336_)"
            points="456.171,26.907 423.499,90.127 360.254,57.442
			392.926,-5.778 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_337_"
              d="M404.783,15.802l2.006,18.443c-0.233,1.478-1.756,2.121-3.151,1.312l-11.609-14.466
				c-1.399,1.058-3.666,3.5-4.871,4.87l14.455,11.602c0.885,1.212,0.259,2.748-1.305,3.16l-18.429-2.017
				c-0.206,1.829-0.16,5.197,0,6.888l18.429-2.02c1.48,0.238,2.119,1.768,1.299,3.165l-14.451,11.599
				c1.088,1.372,3.44,3.692,4.87,4.87l11.616-14.472c1.216-0.865,2.745-0.232,3.146,1.34l-2.029,18.409
				c1.808,0.122,5.205,0.195,6.912,0l-2.032-18.46c0.254-1.463,1.78-2.091,3.172-1.263l11.596,14.447
				c1.468-1.194,3.787-3.488,4.87-4.871l-14.49-11.631c-0.853-1.212-0.218-2.733,1.346-3.132l18.423,2.019
				c0.194-1.797,0.197-5.12,0-6.888l-18.465,2.019c-1.463-0.249-2.094-1.768-1.278-3.158l14.465-11.606
				c-1.057-1.265-3.373-3.699-4.87-4.87l-11.619,14.472c-1.21,0.87-2.736,0.247-3.147-1.31l2.021-18.441
				c-0.854-0.098-2.1-0.142-3.358-0.142C407.008,15.67,405.699,15.717,404.783,15.802"
            />
          </defs>
          <clipPath id="SVGIDB_338_">
            <use xlink:href="#SVGIDB_337_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_339_"
            cx="-155.9985"
            cy="571"
            r="0.9995"
            gradientTransform="matrix(-12.9442 22.8936 22.8936 12.9442 -14683.3428 -3777.5889)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#DCDCDC" />
            <stop offset="0.5272" style="stop-color:#BBBBBB" />
            <stop offset="1" style="stop-color:#DCDCDC" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_338_)"
            fill="url(#SVGIDB_339_)"
            points="457.463,28.511 421.894,91.421 358.961,55.839
			394.53,-7.071 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_340_"
              d="M404.816,15.696l1.987,18.63c-0.229,1.464-1.738,2.099-3.118,1.299L391.928,21.04
				c-1.435,1.085-3.586,3.416-4.821,4.822l14.573,11.749c0.876,1.199,0.258,2.718-1.29,3.126l-18.618-1.997
				c-0.209,1.876-0.162,5.086,0,6.819l18.618-1.999c1.464,0.234,2.099,1.75,1.284,3.132l-14.57,11.745
				c1.116,1.408,3.356,3.614,4.822,4.823l11.762-14.592c1.204-0.857,2.718-0.23,3.114,1.326l-2.008,18.597
				c1.853,0.125,5.091,0.201,6.841,0l-2.012-18.647c0.251-1.449,1.763-2.07,3.139-1.25l11.742,14.566
				c1.506-1.225,3.711-3.405,4.823-4.823l-14.61-11.777c-0.843-1.201-0.216-2.704,1.332-3.1l18.611,1.999
				c0.199-1.842,0.203-5.005,0-6.819l-18.652,2c-1.448-0.247-2.072-1.751-1.265-3.125l14.583-11.753
				c-1.084-1.297-3.286-3.622-4.822-4.822l-11.765,14.591c-1.198,0.862-2.707,0.244-3.114-1.296l2-18.63
				c-0.872-0.099-2.085-0.145-3.313-0.145C407.044,15.56,405.759,15.609,404.816,15.696"
            />
          </defs>
          <clipPath id="SVGIDB_341_">
            <use xlink:href="#SVGIDB_340_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_342_"
            cx="-155.999"
            cy="571"
            r="0.9996"
            gradientTransform="matrix(-13.83 22.6135 22.6135 13.83 -14661.5713 -4327.0835)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#DFDFDF" />
            <stop offset="0.5272" style="stop-color:#BDBDBD" />
            <stop offset="1" style="stop-color:#DFDFDF" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_341_)"
            fill="url(#SVGIDB_342_)"
            points="458.557,30.051 420.354,92.516 357.868,54.301
			396.071,-8.164 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_343_"
              d="M404.849,15.59l1.971,18.817c-0.229,1.449-1.721,2.079-3.086,1.287l-11.904-14.706
				c-1.471,1.114-3.508,3.334-4.774,4.774l14.694,11.895c0.866,1.188,0.253,2.691-1.277,3.095l-18.807-1.978
				c-0.215,1.923-0.166,4.975,0,6.751l18.807-1.981c1.449,0.233,2.075,1.733,1.271,3.1l-14.69,11.892
				c1.145,1.443,3.271,3.536,4.773,4.775l11.91-14.711c1.189-0.848,2.688-0.227,3.081,1.312l-1.988,18.786
				c1.899,0.128,4.977,0.206,6.771,0l-1.99-18.836c0.248-1.433,1.744-2.048,3.104-1.236l11.89,14.685
				c1.543-1.256,3.636-3.321,4.773-4.775l-14.728-11.924c-0.835-1.187-0.215-2.675,1.317-3.067l18.799,1.98
				c0.205-1.888,0.207-4.891,0-6.751l-18.839,1.981c-1.434-0.245-2.052-1.732-1.252-3.092l14.702-11.901
				c-1.111-1.329-3.199-3.542-4.773-4.774l-11.912,14.711c-1.186,0.853-2.679,0.241-3.081-1.283l1.98-18.817
				c-0.894-0.102-2.078-0.148-3.276-0.148C407.073,15.451,405.816,15.5,404.849,15.59"
            />
          </defs>
          <clipPath id="SVGIDB_344_">
            <use xlink:href="#SVGIDB_343_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_345_"
            cx="-155.999"
            cy="571"
            r="0.9996"
            gradientTransform="matrix(-14.6275 22.3148 22.3148 14.6275 -14615.4482 -4829.042)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#E1E1E1" />
            <stop offset="0.5272" style="stop-color:#BFBFBE" />
            <stop offset="1" style="stop-color:#E1E1E1" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_344_)"
            fill="url(#SVGIDB_345_)"
            points="459.48,31.516 418.887,93.444 356.942,52.839
			397.536,-9.089 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_346_"
              d="M404.882,15.485l1.951,19.004c-0.225,1.434-1.701,2.056-3.053,1.271l-12.052-14.824
				c-1.505,1.14-3.428,3.25-4.726,4.726l14.813,12.042c0.857,1.175,0.252,2.662-1.264,3.062l-18.994-1.96
				c-0.22,1.971-0.171,4.864,0,6.684l18.995-1.961c1.434,0.229,2.054,1.713,1.257,3.067l-14.81,12.038
				c1.172,1.478,3.187,3.457,4.726,4.726l12.057-14.829c1.178-0.84,2.66-0.225,3.048,1.298l-1.967,18.975
				c1.944,0.131,4.862,0.209,6.701,0l-1.973-19.024c0.247-1.418,1.727-2.027,3.074-1.224l12.035,14.804
				c1.582-1.285,3.559-3.236,4.726-4.726l-14.847-12.07c-0.825-1.175-0.211-2.647,1.304-3.034l18.987,1.96
				c0.209-1.935,0.213-4.778,0-6.684l-19.027,1.963c-1.418-0.242-2.028-1.714-1.238-3.06l14.82-12.047
				c-1.137-1.362-3.112-3.465-4.725-4.726l-12.06,14.83c-1.171,0.844-2.648,0.239-3.048-1.269l1.962-19.006
				c-0.912-0.104-2.063-0.151-3.229-0.151C407.11,15.341,405.876,15.393,404.882,15.485"
            />
          </defs>
          <clipPath id="SVGIDB_347_">
            <use xlink:href="#SVGIDB_346_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_348_"
            cx="-155.9995"
            cy="571"
            r="0.9998"
            gradientTransform="matrix(-15.3465 22.0073 22.0073 15.3465 -14552.0225 -5287.562)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#E4E4E4" />
            <stop offset="0.5272" style="stop-color:#C1C0C0" />
            <stop offset="1" style="stop-color:#E4E4E4" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_347_)"
            fill="url(#SVGIDB_348_)"
            points="460.268,32.902 417.5,94.231 356.156,51.453
			398.924,-9.875 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_349_"
              d="M404.915,15.38l1.933,19.191c-0.223,1.419-1.684,2.034-3.02,1.258L391.63,20.886
				c-1.542,1.167-3.35,3.167-4.677,4.678l14.932,12.189c0.849,1.162,0.248,2.633-1.25,3.028l-19.182-1.939
				c-0.227,2.016-0.176,4.752,0,6.615l19.183-1.942c1.418,0.228,2.031,1.695,1.243,3.034l-14.928,12.185
				c1.199,1.514,3.101,3.379,4.677,4.679l12.203-14.949c1.164-0.83,2.631-0.223,3.015,1.284l-1.946,19.163
				c1.991,0.135,4.749,0.215,6.631,0l-1.951-19.212c0.244-1.403,1.707-2.005,3.041-1.21l12.181,14.924
				c1.621-1.317,3.483-3.154,4.678-4.679l-14.965-12.215c-0.817-1.163-0.21-2.62,1.289-3.003l19.176,1.941
				c0.215-1.981,0.218-4.665,0-6.615l-19.215,1.942c-1.402-0.239-2.008-1.696-1.225-3.027l14.939-12.193
				c-1.164-1.394-3.026-3.387-4.677-4.678l-12.205,14.95c-1.161,0.834-2.622,0.236-3.016-1.257l1.942-19.193
				c-0.932-0.105-2.053-0.154-3.188-0.154C407.144,15.231,405.936,15.285,404.915,15.38"
            />
          </defs>
          <clipPath id="SVGIDB_350_">
            <use xlink:href="#SVGIDB_349_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_351_"
            cx="-155.999"
            cy="571"
            r="0.9997"
            gradientTransform="matrix(-15.9963 21.698 21.698 15.9963 -14476.7783 -5706.8413)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#E6E6E6" />
            <stop offset="0.5272" style="stop-color:#C2C2C2" />
            <stop offset="1" style="stop-color:#E6E6E6" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_350_)"
            fill="url(#SVGIDB_351_)"
            points="460.938,34.208 416.192,94.903 355.485,50.148
			400.23,-10.546 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_352_"
              d="M404.948,15.273l1.915,19.38c-0.222,1.403-1.665,2.012-2.988,1.245L391.53,20.835
				c-1.577,1.194-3.271,3.083-4.628,4.629l15.051,12.335c0.84,1.151,0.246,2.607-1.236,2.998l-19.371-1.921
				c-0.23,2.063-0.179,4.64,0,6.547l19.371-1.923c1.404,0.226,2.01,1.678,1.231,3.002L386.9,58.833
				c1.227,1.549,3.017,3.301,4.629,4.63l12.349-15.068c1.152-0.821,2.604-0.219,2.983,1.271l-1.928,19.351
				c2.038,0.138,4.636,0.22,6.562,0l-1.931-19.399c0.24-1.388,1.688-1.983,3.008-1.198l12.329,15.044
				c1.656-1.347,3.406-3.07,4.629-4.63l-15.085-12.363c-0.809-1.15-0.207-2.591,1.275-2.97l19.364,1.922
				c0.219-2.027,0.222-4.552,0-6.547l-19.403,1.923c-1.388-0.236-1.985-1.677-1.212-2.994l15.061-12.341
				c-1.192-1.426-2.94-3.308-4.629-4.629l-12.353,15.068c-1.147,0.826-2.593,0.234-2.983-1.242l1.924-19.381
				c-0.953-0.109-2.046-0.158-3.153-0.158C407.172,15.122,405.994,15.177,404.948,15.273"
            />
          </defs>
          <clipPath id="SVGIDB_353_">
            <use xlink:href="#SVGIDB_352_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_354_"
            cx="-155.998"
            cy="571.001"
            r="0.999"
            gradientTransform="matrix(-16.5851 21.392 21.392 16.5851 -14393.8799 -6090.7993)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#E9E9E8" />
            <stop offset="0.5272" style="stop-color:#C4C4C4" />
            <stop offset="1" style="stop-color:#E9E9E8" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_353_)"
            fill="url(#SVGIDB_354_)"
            points="461.511,35.438 414.962,95.479 354.911,48.921
			401.46,-11.12 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_355_"
              d="M404.981,15.168l1.896,19.567c-0.218,1.388-1.646,1.99-2.955,1.231l-12.491-15.182
				c-1.612,1.221-3.19,3-4.581,4.581l15.172,12.482c0.829,1.138,0.243,2.578-1.224,2.964L381.24,38.91
				c-0.237,2.11-0.185,4.528,0,6.478l19.558-1.902c1.39,0.223,1.989,1.658,1.218,2.968l-15.167,12.478
				c1.255,1.584,2.933,3.222,4.581,4.582l12.495-15.186c1.141-0.813,2.575-0.218,2.95,1.256l-1.906,19.54
				c2.084,0.14,4.521,0.225,6.491,0l-1.911-19.588c0.239-1.372,1.671-1.962,2.977-1.184L425,63.514
				c1.695-1.378,3.331-2.986,4.581-4.581l-15.203-12.509c-0.8-1.137-0.206-2.563,1.261-2.937l19.553,1.901
				c0.224-2.072,0.228-4.438,0-6.478l-19.591,1.904c-1.372-0.234-1.964-1.659-1.198-2.962l15.179-12.487
				c-1.219-1.459-2.854-3.23-4.581-4.581l-12.498,15.188c-1.135,0.816-2.564,0.231-2.951-1.229l1.903-19.569
				c-0.971-0.111-2.035-0.161-3.111-0.161C407.205,15.013,406.053,15.069,404.981,15.168"
            />
          </defs>
          <clipPath id="SVGIDB_356_">
            <use xlink:href="#SVGIDB_355_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_357_"
            cx="-155.999"
            cy="571"
            r="0.9997"
            gradientTransform="matrix(-17.1214 21.0939 21.0939 17.1214 -14307.3594 -6443.5308)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#EBEBEB" />
            <stop offset="0.5272" style="stop-color:#C6C6C5" />
            <stop offset="1" style="stop-color:#EBEBEB" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_356_)"
            fill="url(#SVGIDB_357_)"
            points="462.006,36.593 413.807,95.975 354.416,47.769
			402.615,-11.613 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_358_"
              d="M405.014,15.063l1.878,19.754c-0.216,1.372-1.629,1.967-2.922,1.217l-12.639-15.301
				c-1.649,1.248-3.112,2.916-4.532,4.532l15.291,12.63c0.821,1.125,0.24,2.549-1.21,2.93l-19.747-1.882
				c-0.242,2.158-0.188,4.418,0,6.411l19.747-1.883c1.373,0.221,1.967,1.64,1.205,2.936l-15.287,12.625
				c1.283,1.619,2.847,3.143,4.533,4.534l12.642-15.307c1.127-0.803,2.546-0.215,2.918,1.242l-1.887,19.729
				c2.13,0.144,4.407,0.231,6.421,0l-1.89-19.775c0.236-1.358,1.652-1.94,2.941-1.171l12.622,15.282
				c1.733-1.409,3.255-2.903,4.533-4.534l-15.323-12.655c-0.79-1.125-0.201-2.535,1.249-2.906l19.739,1.883
				c0.229-2.118,0.232-4.324,0-6.411l-19.778,1.885c-1.356-0.23-1.941-1.64-1.185-2.929l15.298-12.634
				c-1.247-1.491-2.767-3.152-4.533-4.532L412.454,36.04c-1.122,0.807-2.536,0.229-2.917-1.215l1.883-19.759
				c-0.989-0.112-2.021-0.163-3.066-0.163C407.24,14.903,406.114,14.961,405.014,15.063"
            />
          </defs>
          <clipPath id="SVGIDB_359_">
            <use xlink:href="#SVGIDB_358_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_360_"
            cx="-155.9985"
            cy="571.001"
            r="0.9991"
            gradientTransform="matrix(-17.6147 20.8095 20.8095 17.6147 -14221.8848 -6769.5693)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#EDEDED" />
            <stop offset="0.5272" style="stop-color:#C8C7C7" />
            <stop offset="1" style="stop-color:#EDEDED" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_359_)"
            fill="url(#SVGIDB_360_)"
            points="462.434,37.677 412.722,96.405 353.986,46.687
			403.698,-12.041 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_361_"
              d="M405.047,14.957l1.86,19.941c-0.214,1.357-1.61,1.947-2.891,1.204l-12.784-15.42
				c-1.686,1.275-3.033,2.833-4.484,4.484l15.41,12.777c0.812,1.111,0.238,2.52-1.196,2.898l-19.936-1.863
				c-0.246,2.204-0.19,4.305,0,6.342l19.936-1.864c1.357,0.218,1.944,1.623,1.191,2.903l-15.406,12.772
				c1.311,1.654,2.762,3.065,4.485,4.485l12.787-15.425c1.115-0.794,2.519-0.212,2.886,1.228l-1.866,19.917
				c2.177,0.147,4.293,0.235,6.351,0l-1.87-19.962c0.233-1.343,1.635-1.919,2.909-1.159l12.77,15.401
				c1.771-1.439,3.179-2.819,4.484-4.485l-15.44-12.801c-0.782-1.113-0.201-2.507,1.233-2.873l19.929,1.863
				c0.233-2.165,0.236-4.211,0-6.342l-19.967,1.865c-1.343-0.228-1.921-1.622-1.173-2.896l15.417-12.781
				c-1.271-1.523-2.68-3.073-4.483-4.484l-12.79,15.426c-1.11,0.799-2.51,0.226-2.887-1.202l1.864-19.946
				c-1.009-0.115-2.016-0.166-3.032-0.166C407.269,14.794,406.172,14.853,405.047,14.957"
            />
          </defs>
          <clipPath id="SVGIDB_362_">
            <use xlink:href="#SVGIDB_361_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_363_"
            cx="-155.9985"
            cy="571"
            r="0.9995"
            gradientTransform="matrix(-18.0729 20.5422 20.5422 18.0729 -14140.7295 -7072.8916)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#F0F0F0" />
            <stop offset="0.5272" style="stop-color:#C9C9C9" />
            <stop offset="1" style="stop-color:#F0F0F0" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_362_)"
            fill="url(#SVGIDB_363_)"
            points="462.807,38.694 411.704,96.778 353.614,45.671
			404.717,-12.413 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_364_"
              d="M405.081,14.851l1.841,20.129c-0.211,1.342-1.593,1.924-2.856,1.191L391.133,20.63
				c-1.721,1.302-2.954,2.751-4.437,4.436l15.53,12.923c0.803,1.1,0.235,2.493-1.183,2.866l-20.124-1.843
				c-0.252,2.25-0.195,4.194,0,6.274l20.124-1.844c1.342,0.215,1.923,1.603,1.177,2.87L386.695,59.23
				c1.34,1.691,2.678,2.987,4.438,4.437l12.935-15.545c1.102-0.784,2.489-0.209,2.853,1.216l-1.846,20.105
				c2.223,0.15,4.179,0.24,6.281,0l-1.851-20.151c0.23-1.328,1.616-1.897,2.876-1.145l12.916,15.52
				c1.809-1.469,3.104-2.735,4.437-4.437l-15.561-12.947c-0.772-1.101-0.198-2.479,1.221-2.84l20.116,1.843
				c0.238-2.212,0.242-4.097,0-6.274l-20.153,1.846c-1.327-0.226-1.899-1.604-1.159-2.864l15.536-12.928
				c-1.301-1.556-2.594-2.995-4.437-4.436L412.36,36.176c-1.098,0.79-2.481,0.224-2.854-1.188l1.845-20.134
				c-1.027-0.117-2.007-0.17-2.992-0.17C407.3,14.684,406.232,14.745,405.081,14.851"
            />
          </defs>
          <clipPath id="SVGIDB_365_">
            <use xlink:href="#SVGIDB_364_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_366_"
            cx="-155.999"
            cy="571"
            r="0.9997"
            gradientTransform="matrix(-18.5055 20.2973 20.2973 18.5055 -14068.3926 -7358.106)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#F2F2F2" />
            <stop offset="0.5272" style="stop-color:#CBCBCB" />
            <stop offset="1" style="stop-color:#F2F2F2" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_365_)"
            fill="url(#SVGIDB_366_)"
            points="463.135,39.649 410.748,97.108 353.285,44.718
			405.672,-12.741 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_367_"
              d="M405.114,14.746l1.821,20.316c-0.207,1.326-1.573,1.902-2.824,1.177l-13.077-15.66
				c-1.757,1.329-2.876,2.667-4.39,4.388l15.65,13.07c0.793,1.087,0.232,2.463-1.169,2.833l-20.312-1.825
				c-0.258,2.298-0.2,4.083,0,6.207l20.312-1.826c1.327,0.214,1.9,1.586,1.164,2.838L386.645,59.33
				c1.366,1.725,2.593,2.908,4.39,4.389l13.08-15.664c1.09-0.777,2.462-0.208,2.82,1.201l-1.825,20.293
				c2.269,0.154,4.065,0.245,6.21,0l-1.828-20.338c0.227-1.313,1.596-1.876,2.844-1.133l13.062,15.641
				c1.846-1.501,3.026-2.652,4.389-4.389l-15.679-13.095c-0.765-1.087-0.196-2.45,1.206-2.808l20.304,1.825
				c0.244-2.258,0.247-3.984,0-6.207l-20.342,1.827c-1.312-0.223-1.876-1.585-1.146-2.83l15.656-13.075
				c-1.328-1.588-2.508-2.917-4.389-4.388l-13.084,15.665c-1.084,0.781-2.451,0.221-2.82-1.174l1.826-20.322
				c-1.05-0.12-2-0.174-2.959-0.174C407.329,14.574,406.29,14.636,405.114,14.746"
            />
          </defs>
          <clipPath id="SVGIDB_368_">
            <use xlink:href="#SVGIDB_367_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_369_"
            cx="-155.999"
            cy="571"
            r="0.9997"
            gradientTransform="matrix(-18.9135 20.0705 20.0705 18.9135 -14002.5547 -7626.4385)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#F5F5F5" />
            <stop offset="0.5272" style="stop-color:#CDCDCC" />
            <stop offset="1" style="stop-color:#F5F5F5" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_368_)"
            fill="url(#SVGIDB_369_)"
            points="463.425,40.546 409.85,97.398 352.995,43.821
			406.57,-13.03 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_370_"
              d="M405.146,14.64l1.805,20.504c-0.206,1.311-1.557,1.88-2.792,1.163l-13.225-15.779
				c-1.794,1.357-2.797,2.584-4.341,4.34l15.771,13.217c0.782,1.074,0.229,2.434-1.156,2.8l-20.5-1.806
				c-0.263,2.345-0.205,3.972,0,6.138l20.5-1.805c1.311,0.21,1.878,1.567,1.15,2.804l-15.765,13.213
				c1.396,1.76,2.507,2.83,4.34,4.34l13.229-15.782c1.077-0.768,2.432-0.206,2.787,1.187l-1.805,20.482
				c2.315,0.157,3.951,0.25,6.14,0l-1.809-20.527c0.226-1.297,1.578-1.853,2.812-1.119l13.208,15.759
				c1.884-1.531,2.951-2.568,4.34-4.34l-15.798-13.241c-0.755-1.074-0.193-2.421,1.193-2.775l20.491,1.804
				c0.248-2.303,0.253-3.87,0-6.138l-20.528,1.808c-1.297-0.221-1.856-1.567-1.133-2.798l15.774-13.221
				c-1.354-1.621-2.42-2.839-4.34-4.34l-13.23,15.785c-1.071,0.771-2.423,0.218-2.788-1.161l1.808-20.511
				c-1.068-0.122-1.992-0.176-2.921-0.176C407.359,14.464,406.35,14.528,405.146,14.64"
            />
          </defs>
          <clipPath id="SVGIDB_371_">
            <use xlink:href="#SVGIDB_370_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_372_"
            cx="-155.999"
            cy="571.001"
            r="0.9993"
            gradientTransform="matrix(-19.2975 19.8585 19.8585 19.2975 -13941.3652 -7878.8037)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#F7F7F7" />
            <stop offset="0.5272" style="stop-color:#CECECE" />
            <stop offset="1" style="stop-color:#F7F7F7" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_371_)"
            fill="url(#SVGIDB_372_)"
            points="463.685,41.391 409.006,97.66 352.735,42.979
			407.414,-13.29 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_373_"
              d="M405.18,14.535l1.786,20.691c-0.204,1.296-1.538,1.858-2.759,1.149l-13.372-15.899
				c-1.829,1.385-2.718,2.501-4.293,4.292l15.89,13.364c0.775,1.062,0.228,2.406-1.143,2.767l-20.688-1.785
				c-0.268,2.391-0.208,3.86,0,6.069l20.689-1.785c1.296,0.207,1.856,1.548,1.137,2.771l-15.885,13.359
				c1.423,1.796,2.423,2.752,4.293,4.292l13.374-15.902c1.064-0.758,2.404-0.202,2.755,1.174l-1.784,20.67
				c2.361,0.159,3.836,0.256,6.069,0l-1.788-20.714c0.222-1.283,1.561-1.833,2.778-1.106l13.354,15.878
				c1.922-1.561,2.876-2.484,4.292-4.292l-15.917-13.387c-0.746-1.062-0.19-2.393,1.18-2.743l20.68,1.785
				c0.254-2.349,0.258-3.756,0-6.069l-20.717,1.788c-1.281-0.218-1.833-1.549-1.119-2.766l15.894-13.368
				c-1.381-1.653-2.333-2.76-4.292-4.292L412.219,36.38c-1.061,0.763-2.396,0.216-2.756-1.147l1.786-20.698
				c-1.086-0.124-1.983-0.18-2.884-0.18C407.389,14.355,406.41,14.42,405.18,14.535"
            />
          </defs>
          <clipPath id="SVGIDB_374_">
            <use xlink:href="#SVGIDB_373_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_375_"
            cx="-155.999"
            cy="571"
            r="0.9997"
            gradientTransform="matrix(-19.659 19.659 19.659 19.659 -13883.8672 -8116.3193)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#FAFAFA" />
            <stop offset="0.5272" style="stop-color:#D0D0D0" />
            <stop offset="1" style="stop-color:#FAFAFA" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_374_)"
            :style="frontWheelClass"
            v-on:click="changeSeverity('frontWheel')"
            fill="url(#SVGIDB_375_)"
            points="463.918,42.187 408.209,97.895 352.502,42.187
			408.209,-13.521 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_376_"
              d="M406.796,46.353c0,0.78,0.632,1.411,1.411,1.411c0.78,0,1.411-0.631,1.411-1.411
				c0-0.779-0.631-1.411-1.411-1.411C407.428,44.942,406.796,45.574,406.796,46.353"
            />
          </defs>
          <clipPath id="SVGIDB_377_">
            <use xlink:href="#SVGIDB_376_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_378_"
            cx="-156"
            cy="571"
            r="1"
            gradientTransform="matrix(-1.411 0 0 1.411 188.0909 -759.3264)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#4F4F4F" />
            <stop offset="0.046" style="stop-color:#4F4F4F" />
            <stop offset="0.2388" style="stop-color:#4A4A4A" />
            <stop offset="0.4727" style="stop-color:#3B3B3B" />
            <stop offset="0.7277" style="stop-color:#232323" />
            <stop offset="0.9963" style="stop-color:#010101" />
            <stop offset="1" style="stop-color:#000000" />
          </radialGradient>
          <rect
            x="406.796"
            y="44.942"
            clip-path="url(#SVGIDB_377_)"
            fill="url(#SVGIDB_378_)"
            width="2.822"
            height="2.822"
          />
        </g>
        <g>
          <defs>
            <polygon
              id="SVGIDB_379_"
              points="407.688,45.453 407.169,46.353 407.688,47.252 408.727,47.252 409.246,46.353 408.727,45.453
							"
            />
          </defs>
          <clipPath id="SVGIDB_380_">
            <use xlink:href="#SVGIDB_379_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_381_"
            cx="-156.001"
            cy="571"
            r="0.9999"
            gradientTransform="matrix(-0.9716 0 0 0.9716 256.6318 -508.4519)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#CBCACA" />
            <stop offset="0.1261" style="stop-color:#C6C5C5" />
            <stop offset="0.279" style="stop-color:#B7B6B6" />
            <stop offset="0.446" style="stop-color:#9E9D9D" />
            <stop offset="0.6228" style="stop-color:#7C7B7B" />
            <stop offset="0.8058" style="stop-color:#515050" />
            <stop offset="0.8159" style="stop-color:#4E4D4D" />
            <stop offset="1" style="stop-color:#1A1A1A" />
          </radialGradient>
          <rect
            x="407.169"
            y="45.453"
            clip-path="url(#SVGIDB_380_)"
            fill="url(#SVGIDB_381_)"
            width="2.077"
            height="1.799"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_382_"
              d="M410.987,42.951c-0.242,0.742,0.164,1.537,0.904,1.778c0.741,0.241,1.537-0.164,1.778-0.906
				c0.241-0.74-0.164-1.537-0.906-1.777c-0.145-0.047-0.292-0.07-0.436-0.07C411.733,41.976,411.18,42.355,410.987,42.951"
            />
          </defs>
          <clipPath id="SVGIDB_383_">
            <use xlink:href="#SVGIDB_382_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_384_"
            cx="-156"
            cy="571"
            r="1"
            gradientTransform="matrix(-0.436 1.3419 1.3419 0.436 -421.9249 3.7522)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#4F4F4F" />
            <stop offset="0.046" style="stop-color:#4F4F4F" />
            <stop offset="0.2388" style="stop-color:#4A4A4A" />
            <stop offset="0.4727" style="stop-color:#3B3B3B" />
            <stop offset="0.7277" style="stop-color:#232323" />
            <stop offset="0.9963" style="stop-color:#010101" />
            <stop offset="1" style="stop-color:#000000" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_383_)"
            fill="url(#SVGIDB_384_)"
            points="414.791,42.262 413.608,45.9 409.865,44.684
			411.047,41.045 		"
          />
        </g>
        <g>
          <defs>
            <polygon
              id="SVGIDB_385_"
              points="411.634,42.615 411.313,43.604 412.007,44.375 413.023,44.159 413.344,43.172 412.65,42.399
				"
            />
          </defs>
          <clipPath id="SVGIDB_386_">
            <use xlink:href="#SVGIDB_385_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_387_"
            cx="-156"
            cy="571"
            r="1"
            gradientTransform="matrix(-0.3003 0.9241 0.9241 0.3003 -162.1771 16.0928)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#CBCACA" />
            <stop offset="0.1261" style="stop-color:#C6C5C5" />
            <stop offset="0.279" style="stop-color:#B7B6B6" />
            <stop offset="0.446" style="stop-color:#9E9D9D" />
            <stop offset="0.6228" style="stop-color:#7C7B7B" />
            <stop offset="0.8058" style="stop-color:#515050" />
            <stop offset="0.8159" style="stop-color:#4E4D4D" />
            <stop offset="1" style="stop-color:#1A1A1A" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_386_)"
            fill="url(#SVGIDB_387_)"
            points="413.925,42.588 413.15,44.972 410.731,44.187
			411.506,41.802 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_388_"
              d="M409.64,37.722c-0.458,0.63-0.318,1.513,0.313,1.971c0.63,0.458,1.512,0.318,1.971-0.312
				c0.458-0.63,0.318-1.513-0.312-1.971c-0.251-0.182-0.541-0.27-0.828-0.27C410.346,37.14,409.916,37.342,409.64,37.722"
            />
          </defs>
          <clipPath id="SVGIDB_389_">
            <use xlink:href="#SVGIDB_388_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_390_"
            cx="-156"
            cy="571"
            r="1"
            gradientTransform="matrix(1.1415 0.8294 0.8294 -1.1415 115.2903 819.7441)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#4F4F4F" />
            <stop offset="0.046" style="stop-color:#4F4F4F" />
            <stop offset="0.2388" style="stop-color:#4A4A4A" />
            <stop offset="0.4727" style="stop-color:#3B3B3B" />
            <stop offset="0.7277" style="stop-color:#232323" />
            <stop offset="0.9963" style="stop-color:#010101" />
            <stop offset="1" style="stop-color:#000000" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_389_)"
            fill="url(#SVGIDB_390_)"
            points="410.287,35.619 413.813,38.18 411.275,41.672
			407.75,39.111 		"
          />
        </g>
        <g>
          <defs>
            <polygon
              id="SVGIDB_391_"
              points="409.941,37.941 409.833,38.974 410.672,39.584 411.622,39.162 411.73,38.129 410.89,37.519
				"
            />
          </defs>
          <clipPath id="SVGIDB_392_">
            <use xlink:href="#SVGIDB_391_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_393_"
            cx="-156"
            cy="570.999"
            r="1.0003"
            gradientTransform="matrix(0.7861 0.5711 0.5711 -0.7861 207.3014 576.4923)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#CBCACA" />
            <stop offset="0.1261" style="stop-color:#C6C5C5" />
            <stop offset="0.279" style="stop-color:#B7B6B6" />
            <stop offset="0.446" style="stop-color:#9E9D9D" />
            <stop offset="0.6228" style="stop-color:#7C7B7B" />
            <stop offset="0.8058" style="stop-color:#515050" />
            <stop offset="0.8159" style="stop-color:#4E4D4D" />
            <stop offset="1" style="stop-color:#1A1A1A" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_392_)"
            fill="url(#SVGIDB_393_)"
            points="410.488,36.617 412.712,38.232 411.074,40.486
			408.851,38.871 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_394_"
              d="M404.875,37.387c-0.63,0.458-0.771,1.34-0.313,1.97c0.457,0.631,1.341,0.771,1.971,0.313
				c0.631-0.458,0.771-1.34,0.313-1.971c-0.275-0.38-0.706-0.581-1.143-0.581C405.416,37.118,405.125,37.205,404.875,37.387"
            />
          </defs>
          <clipPath id="SVGIDB_395_">
            <use xlink:href="#SVGIDB_394_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_396_"
            cx="-156"
            cy="571"
            r="1"
            gradientTransform="matrix(1.1415 -0.8293 -0.8293 -1.1415 1057.3284 560.9401)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#4F4F4F" />
            <stop offset="0.046" style="stop-color:#4F4F4F" />
            <stop offset="0.2388" style="stop-color:#4A4A4A" />
            <stop offset="0.4727" style="stop-color:#3B3B3B" />
            <stop offset="0.7277" style="stop-color:#232323" />
            <stop offset="0.9963" style="stop-color:#010101" />
            <stop offset="1" style="stop-color:#000000" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_395_)"
            fill="url(#SVGIDB_396_)"
            points="402.673,38.158 406.198,35.596 408.735,39.088
			405.21,41.65 		"
          />
        </g>
        <g>
          <defs>
            <polygon
              id="SVGIDB_397_"
              points="404.755,38.106 404.864,39.139 405.813,39.562 406.653,38.951 406.544,37.918 405.595,37.495
							"
            />
          </defs>
          <clipPath id="SVGIDB_398_">
            <use xlink:href="#SVGIDB_397_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_399_"
            cx="-156"
            cy="571"
            r="1"
            gradientTransform="matrix(0.7861 -0.5711 -0.5711 -0.7861 854.4443 398.2872)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#CBCACA" />
            <stop offset="0.1261" style="stop-color:#C6C5C5" />
            <stop offset="0.279" style="stop-color:#B7B6B6" />
            <stop offset="0.446" style="stop-color:#9E9D9D" />
            <stop offset="0.6228" style="stop-color:#7C7B7B" />
            <stop offset="0.8058" style="stop-color:#515050" />
            <stop offset="0.8159" style="stop-color:#4E4D4D" />
            <stop offset="1" style="stop-color:#1A1A1A" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_398_)"
            fill="url(#SVGIDB_399_)"
            points="403.772,38.209 405.997,36.592 407.636,38.848
			405.411,40.465 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_400_"
              d="M403.678,42.008c-0.742,0.241-1.146,1.037-0.906,1.778c0.241,0.741,1.036,1.147,1.778,0.906
				c0.74-0.241,1.146-1.037,0.905-1.778c-0.193-0.597-0.747-0.975-1.342-0.975C403.969,41.939,403.822,41.961,403.678,42.008"
            />
          </defs>
          <clipPath id="SVGIDB_401_">
            <use xlink:href="#SVGIDB_400_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_402_"
            cx="-156"
            cy="571"
            r="1"
            gradientTransform="matrix(-0.436 -1.3419 -1.3419 0.436 1102.3187 -414.9565)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#4F4F4F" />
            <stop offset="0.046" style="stop-color:#4F4F4F" />
            <stop offset="0.2388" style="stop-color:#4A4A4A" />
            <stop offset="0.4727" style="stop-color:#3B3B3B" />
            <stop offset="0.7277" style="stop-color:#232323" />
            <stop offset="0.9963" style="stop-color:#010101" />
            <stop offset="1" style="stop-color:#000000" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_401_)"
            fill="url(#SVGIDB_402_)"
            points="402.833,45.863 401.651,42.225 405.394,41.009
			406.576,44.647 		"
          />
        </g>
        <g>
          <defs>
            <polygon
              id="SVGIDB_403_"
              points="403.097,43.134 403.418,44.122 404.435,44.338 405.129,43.566 404.809,42.578 403.793,42.362
							"
            />
          </defs>
          <clipPath id="SVGIDB_404_">
            <use xlink:href="#SVGIDB_403_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_405_"
            cx="-155.999"
            cy="571"
            r="0.9996"
            gradientTransform="matrix(-0.3003 -0.9241 -0.9241 0.3003 884.9335 -272.2645)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#CBCACA" />
            <stop offset="0.1261" style="stop-color:#C6C5C5" />
            <stop offset="0.279" style="stop-color:#B7B6B6" />
            <stop offset="0.446" style="stop-color:#9E9D9D" />
            <stop offset="0.6228" style="stop-color:#7C7B7B" />
            <stop offset="0.8058" style="stop-color:#515050" />
            <stop offset="0.8159" style="stop-color:#4E4D4D" />
            <stop offset="1" style="stop-color:#1A1A1A" />
          </radialGradient>
          <polygon
            clip-path="url(#SVGIDB_404_)"
            fill="url(#SVGIDB_405_)"
            points="403.291,44.935 402.517,42.551 404.935,41.765
			405.71,44.149 		"
          />
        </g>
        <g>
          <path
            fill="#080808"
            :style="frontWheelClass"
            v-on:click="changeSeverity('frontWheel')"
            d="M408.225,80.028c20.914,0,37.868-16.962,37.868-37.876c0-20.913-16.954-37.867-37.868-37.867
			c-20.921,0-37.875,16.954-37.875,37.867C370.35,63.066,387.304,80.028,408.225,80.028 M408.225,14.358
			c15.351,0,27.794,12.444,27.794,27.794c0,15.35-12.443,27.803-27.794,27.803c-15.357,0-27.802-12.453-27.802-27.803
			C380.423,26.803,392.867,14.358,408.225,14.358"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_406_"
              d="M380.422,42.153c0-15.351,12.445-27.795,27.802-27.795c15.352,0,27.795,12.444,27.795,27.795
				c0,15.35-12.443,27.802-27.795,27.802C392.867,69.955,380.422,57.503,380.422,42.153 M407.755,4.297l0.445,1.44l-0.457,0.175
				l-0.496-1.602c-0.272,0.007-0.545,0.008-0.815,0.02l0.496,1.428l-0.451,0.19l-0.552-1.587c-0.271,0.016-0.54,0.04-0.81,0.062
				l0.544,1.4l-0.445,0.207l-0.608-1.568c-0.27,0.025-0.538,0.057-0.807,0.089l0.592,1.382l-0.436,0.222l-0.66-1.54
				c-0.27,0.035-0.543,0.062-0.81,0.103l0.644,1.369L402.7,6.324l-0.714-1.518c-0.269,0.044-0.534,0.092-0.802,0.143l0.688,1.336
				l-0.42,0.251l-0.771-1.497c-0.265,0.053-0.526,0.117-0.791,0.177l0.733,1.31l-0.411,0.267l-0.818-1.463
				c-0.264,0.063-0.529,0.123-0.791,0.191l0.781,1.291l-0.401,0.28l-0.867-1.432c-0.263,0.073-0.524,0.145-0.783,0.222l0.823,1.258
				l-0.392,0.294l-0.921-1.407c-0.258,0.082-0.512,0.174-0.768,0.26l0.863,1.224l-0.381,0.308l-0.966-1.368
				c-0.256,0.09-0.51,0.182-0.763,0.279l0.907,1.194l-0.371,0.32l-1.009-1.329c-0.254,0.1-0.508,0.194-0.759,0.299l0.95,1.165
				l-0.358,0.333l-1.057-1.295c-0.248,0.108-0.494,0.222-0.739,0.335l0.983,1.122l-0.347,0.347l-1.103-1.259
				c-0.244,0.117-0.481,0.242-0.724,0.363l1.02,1.087l-0.335,0.357l-1.138-1.211c-0.241,0.125-0.483,0.247-0.721,0.378l1.06,1.052
				l-0.322,0.369l-1.177-1.169c-0.235,0.134-0.472,0.267-0.705,0.405l1.092,1.01l-0.31,0.38l-1.22-1.129
				c-0.23,0.141-0.455,0.29-0.683,0.437l1.121,0.967l-0.296,0.39l-1.254-1.083c-0.226,0.15-0.448,0.303-0.67,0.457l1.152,0.928
				l-0.281,0.4l-1.285-1.034c-0.222,0.158-0.447,0.311-0.665,0.473l1.189,0.889l-0.268,0.41l-1.32-0.988
				c-0.215,0.165-0.428,0.333-0.639,0.501l1.21,0.842l-0.254,0.419l-1.357-0.945c-0.209,0.172-0.407,0.353-0.612,0.529l1.235,0.796
				l-0.238,0.428l-1.382-0.891c-0.203,0.18-0.406,0.359-0.606,0.543l1.266,0.753l-0.223,0.437l-1.41-0.84
				c-0.195,0.187-0.396,0.371-0.588,0.561l1.289,0.709l-0.208,0.444l-1.439-0.791c-0.189,0.191-0.373,0.389-0.56,0.586l1.308,0.66
				l-0.191,0.45l-1.467-0.74c-0.184,0.198-0.359,0.403-0.539,0.605l1.33,0.614l-0.177,0.457l-1.486-0.686
				c-0.176,0.206-0.356,0.409-0.528,0.619l1.356,0.569l-0.161,0.463l-1.508-0.634c-0.169,0.212-0.339,0.423-0.502,0.639l1.368,0.521
				l-0.144,0.468l-1.536-0.584c-0.16,0.216-0.312,0.44-0.469,0.66l1.383,0.471l-0.128,0.472l-1.55-0.528
				c-0.154,0.223-0.305,0.447-0.454,0.673l1.402,0.423l-0.112,0.478l-1.563-0.472c-0.146,0.228-0.298,0.453-0.439,0.685l1.421,0.376
				l-0.094,0.48l-1.583-0.418c-0.139,0.233-0.271,0.468-0.404,0.704l1.426,0.324l-0.079,0.483l-1.602-0.365
				c-0.128,0.237-0.247,0.48-0.371,0.72l1.434,0.273l-0.061,0.486l-1.606-0.306c-0.121,0.242-0.243,0.483-0.359,0.728l1.448,0.224
				l-0.044,0.489l-1.613-0.25c-0.113,0.246-0.228,0.491-0.335,0.741l1.453,0.173l-0.026,0.489l-1.627-0.194
				c-0.104,0.249-0.199,0.502-0.297,0.753l1.454,0.122l-0.011,0.49l-1.631-0.137c-0.095,0.253-0.185,0.508-0.273,0.763l1.458,0.071
				l0.008,0.49l-1.628-0.079c-0.087,0.257-0.182,0.511-0.263,0.771l1.468,0.021l0.023,0.488l-1.631-0.022
				c-0.076,0.258-0.149,0.518-0.221,0.779l1.455-0.029l0.041,0.487l-1.637,0.035c-0.066,0.26-0.122,0.524-0.185,0.786l1.45-0.081
				l0.058,0.487l-1.623,0.09c-0.058,0.265-0.12,0.528-0.173,0.795l1.451-0.132l0.075,0.484l-1.615,0.146
				c-0.05,0.266-0.099,0.531-0.143,0.8l1.438-0.182l0.092,0.48l-1.614,0.205c-0.04,0.265-0.068,0.534-0.103,0.802l1.425-0.232
				l0.109,0.478l-1.6,0.259c-0.029,0.269-0.06,0.537-0.085,0.807l1.419-0.281l0.127,0.473l-1.583,0.314
				c-0.022,0.27-0.047,0.538-0.063,0.81l1.408-0.331l0.142,0.469l-1.576,0.37c-0.013,0.268-0.015,0.538-0.021,0.808l1.386-0.377
				l0.159,0.464l-1.557,0.424c-0.002,0.131-0.011,0.262-0.011,0.394c0,0.139,0.01,0.277,0.011,0.416l1.376-0.426l0.174,0.458
				l-1.537,0.476c0.006,0.271,0.008,0.543,0.02,0.813l1.363-0.475l0.191,0.451l-1.526,0.531c0.017,0.27,0.04,0.539,0.062,0.808
				l1.34-0.52l0.206,0.444l-1.507,0.585c0.025,0.269,0.056,0.537,0.087,0.806l1.323-0.568l0.222,0.437l-1.481,0.635
				c0.034,0.269,0.063,0.541,0.103,0.808l1.312-0.618l0.237,0.43l-1.464,0.688c0.044,0.267,0.093,0.532,0.142,0.798l1.283-0.659
				l0.251,0.42l-1.444,0.742c0.053,0.265,0.116,0.527,0.175,0.79l1.261-0.704l0.265,0.411l-1.411,0.789
				c0.063,0.264,0.12,0.53,0.188,0.792l1.241-0.753l0.281,0.403l-1.384,0.838c0.071,0.261,0.144,0.522,0.221,0.781l1.211-0.793
				l0.294,0.392l-1.362,0.891c0.081,0.259,0.174,0.511,0.26,0.766l1.18-0.832l0.308,0.381l-1.324,0.935
				c0.09,0.254,0.18,0.51,0.275,0.763l1.154-0.876l0.32,0.37l-1.288,0.978c0.099,0.252,0.195,0.507,0.298,0.756l1.124-0.917
				l0.334,0.359l-1.257,1.025c0.106,0.249,0.221,0.494,0.334,0.738l1.085-0.951l0.347,0.347l-1.222,1.07
				c0.115,0.243,0.239,0.484,0.359,0.725l1.053-0.988l0.357,0.335l-1.178,1.106c0.125,0.24,0.244,0.484,0.374,0.721l1.022-1.029
				l0.369,0.322l-1.139,1.147c0.133,0.236,0.267,0.47,0.404,0.703l0.98-1.059l0.382,0.309l-1.104,1.192
				c0.141,0.229,0.291,0.452,0.438,0.68l0.939-1.091l0.391,0.296l-1.056,1.224c0.149,0.225,0.3,0.45,0.453,0.672l0.904-1.125
				l0.4,0.282l-1.011,1.257c0.158,0.221,0.311,0.446,0.472,0.663l0.866-1.159l0.411,0.268l-0.968,1.293
				c0.164,0.215,0.332,0.427,0.501,0.637l0.821-1.181l0.42,0.253l-0.926,1.331c0.172,0.208,0.351,0.409,0.525,0.614l0.78-1.21
				l0.428,0.238l-0.874,1.357c0.179,0.203,0.357,0.407,0.539,0.607l0.741-1.241l0.436,0.223l-0.827,1.385
				c0.188,0.198,0.371,0.396,0.562,0.588l0.696-1.265l0.442,0.208l-0.78,1.419c0.193,0.19,0.392,0.373,0.587,0.559l0.649-1.286
				l0.45,0.192L382.56,70c0.199,0.183,0.401,0.362,0.604,0.54l0.604-1.31l0.457,0.177l-0.678,1.467
				c0.206,0.176,0.408,0.358,0.617,0.531l0.563-1.34l0.463,0.161l-0.629,1.492c0.213,0.169,0.425,0.337,0.639,0.502l0.515-1.354
				l0.468,0.144l-0.577,1.524c0.216,0.161,0.438,0.312,0.657,0.469l0.469-1.371l0.472,0.128l-0.524,1.538
				c0.223,0.154,0.447,0.307,0.672,0.457l0.422-1.393l0.477,0.112l-0.47,1.555c0.229,0.147,0.454,0.297,0.685,0.439l0.373-1.412
				l0.481,0.095l-0.417,1.576c0.231,0.138,0.468,0.271,0.703,0.405l0.322-1.42l0.484,0.078l-0.363,1.597
				c0.237,0.13,0.479,0.25,0.717,0.375l0.274-1.432l0.486,0.06l-0.307,1.605c0.242,0.121,0.482,0.246,0.729,0.363l0.224-1.451
				l0.489,0.045l-0.251,1.616c0.246,0.112,0.492,0.227,0.741,0.335l0.174-1.456l0.489,0.026l-0.195,1.633
				c0.249,0.104,0.502,0.198,0.753,0.297l0.123-1.459l0.489,0.009l-0.137,1.637c0.253,0.096,0.506,0.188,0.763,0.278l0.071-1.467
				l0.49-0.008l-0.081,1.638c0.258,0.088,0.513,0.179,0.773,0.261l0.02-1.477l0.489-0.024l-0.022,1.645
				c0.259,0.078,0.52,0.15,0.78,0.222l-0.031-1.469l0.488-0.042l0.034,1.65c0.261,0.069,0.526,0.126,0.789,0.189l-0.083-1.468
				l0.487-0.058l0.092,1.64c0.264,0.06,0.526,0.125,0.794,0.179l-0.134-1.474l0.483-0.075l0.149,1.638
				c0.266,0.049,0.532,0.098,0.8,0.142l-0.185-1.461l0.48-0.092l0.208,1.641c0.265,0.04,0.535,0.068,0.802,0.102l-0.234-1.451
				l0.478-0.109l0.264,1.624c0.269,0.031,0.537,0.064,0.808,0.089l-0.286-1.447l0.473-0.126l0.32,1.612
				c0.27,0.021,0.539,0.046,0.811,0.062l-0.337-1.437l0.469-0.142l0.378,1.608c0.268,0.013,0.539,0.014,0.809,0.021l-0.385-1.419
				l0.462-0.159l0.433,1.591c0.153,0.001,0.305,0.011,0.458,0.011c0.119,0,0.236-0.008,0.355-0.009l-0.438-1.411l0.458-0.174
				l0.487,1.573c0.271-0.007,0.543-0.009,0.814-0.021l-0.488-1.399l0.452-0.19l0.545,1.564c0.27-0.015,0.539-0.041,0.809-0.061
				l-0.536-1.379l0.445-0.206l0.599,1.546c0.271-0.025,0.54-0.054,0.81-0.084l-0.586-1.366l0.438-0.221l0.652,1.522
				c0.27-0.034,0.541-0.062,0.809-0.102l-0.636-1.353l0.429-0.236l0.709,1.507c0.269-0.044,0.533-0.094,0.801-0.143l-0.683-1.326
				l0.421-0.251l0.765,1.487c0.266-0.053,0.528-0.114,0.793-0.173l-0.729-1.304l0.411-0.266l0.814,1.456
				c0.265-0.062,0.531-0.118,0.795-0.186l-0.781-1.289l0.402-0.28l0.865,1.43c0.264-0.071,0.523-0.145,0.783-0.222l-0.822-1.257
				l0.393-0.293l0.922,1.409c0.259-0.081,0.512-0.173,0.768-0.26l-0.865-1.227l0.382-0.307l0.967,1.371
				c0.256-0.09,0.513-0.18,0.766-0.275l-0.91-1.202l0.369-0.32l1.015,1.336c0.253-0.099,0.507-0.195,0.758-0.299l-0.955-1.171
				l0.359-0.333l1.064,1.305c0.248-0.108,0.493-0.222,0.739-0.335l-0.991-1.133l0.346-0.346l1.111,1.268
				c0.245-0.116,0.486-0.238,0.729-0.36l-1.033-1.098l0.335-0.359l1.149,1.226c0.242-0.126,0.487-0.245,0.727-0.375l-1.077-1.069
				l0.322-0.369l1.193,1.185c0.236-0.133,0.473-0.267,0.705-0.405l-1.107-1.027l0.309-0.38l1.241,1.149
				c0.23-0.141,0.454-0.292,0.682-0.438l-1.141-0.985l0.295-0.391l1.275,1.101c0.227-0.15,0.451-0.3,0.675-0.454l-1.179-0.947
				l0.281-0.402l1.312,1.055c0.222-0.158,0.446-0.311,0.665-0.473l-1.217-0.909l0.27-0.411l1.35,1.011
				c0.217-0.165,0.428-0.334,0.64-0.502l-1.241-0.863l0.253-0.42l1.39,0.966c0.209-0.171,0.411-0.351,0.616-0.527l-1.27-0.819
				l0.238-0.427l1.417,0.912c0.204-0.179,0.409-0.357,0.609-0.54l-1.304-0.778l0.223-0.437l1.448,0.864
				c0.198-0.186,0.396-0.371,0.591-0.562l-1.332-0.732l0.208-0.444l1.484,0.817c0.19-0.193,0.375-0.392,0.561-0.588l-1.353-0.683
				l0.192-0.451l1.513,0.764c0.184-0.2,0.362-0.403,0.542-0.605l-1.379-0.638l0.177-0.457l1.536,0.709
				c0.177-0.206,0.359-0.408,0.532-0.619l-1.409-0.592l0.159-0.463l1.563,0.657c0.169-0.212,0.338-0.425,0.503-0.64l-1.425-0.541
				l0.144-0.469l1.595,0.605c0.161-0.216,0.313-0.441,0.471-0.661l-1.443-0.491l0.128-0.473l1.61,0.548
				c0.155-0.223,0.308-0.447,0.458-0.674l-1.466-0.442l0.11-0.477l1.629,0.492c0.147-0.23,0.299-0.456,0.441-0.688l-1.487-0.393
				l0.095-0.481l1.65,0.437c0.138-0.234,0.273-0.469,0.406-0.706l-1.495-0.339l0.077-0.485l1.673,0.38
				c0.129-0.237,0.251-0.479,0.375-0.72l-1.508-0.288l0.061-0.486l1.68,0.321c0.122-0.243,0.247-0.485,0.363-0.731l-1.525-0.236
				l0.044-0.488l1.69,0.262c0.115-0.247,0.229-0.494,0.338-0.743l-1.533-0.183l0.025-0.49l1.709,0.204
				c0.104-0.249,0.199-0.503,0.299-0.756l-1.535-0.129l0.009-0.489l1.713,0.144c0.096-0.254,0.188-0.51,0.278-0.766l-1.544-0.076
				l-0.008-0.49l1.715,0.084c0.087-0.258,0.18-0.513,0.261-0.774l-1.553-0.021l-0.024-0.49l1.72,0.024
				c0.077-0.26,0.15-0.521,0.223-0.783l-1.545,0.033l-0.043-0.489l1.727-0.036c0.068-0.261,0.126-0.527,0.188-0.79l-1.542,0.086
				l-0.059-0.486l1.716-0.096c0.059-0.266,0.122-0.529,0.175-0.798l-1.545,0.141l-0.075-0.483l1.709-0.156
				c0.052-0.267,0.101-0.534,0.145-0.803l-1.534,0.194l-0.092-0.481l1.711-0.216c0.041-0.266,0.068-0.537,0.103-0.806l-1.521,0.247
				l-0.109-0.478l1.695-0.274c0.031-0.27,0.063-0.539,0.087-0.81l-1.517,0.3l-0.126-0.474l1.682-0.332
				c0.021-0.271,0.045-0.542,0.062-0.814l-1.506,0.353l-0.142-0.469l1.675-0.393c0.011-0.269,0.014-0.541,0.021-0.812l-1.486,0.404
				l-0.158-0.463l1.657-0.45c0.002-0.137,0.011-0.27,0.011-0.407c0-0.137-0.009-0.272-0.011-0.408l-1.475,0.456l-0.176-0.458
				l1.638-0.506c-0.007-0.272-0.01-0.546-0.021-0.817l-1.464,0.51l-0.19-0.451l1.627-0.567c-0.017-0.271-0.04-0.54-0.062-0.81
				l-1.438,0.558l-0.207-0.445l1.606-0.623c-0.024-0.27-0.057-0.54-0.087-0.81l-1.423,0.611l-0.224-0.437l1.582-0.678
				c-0.034-0.27-0.063-0.542-0.104-0.811l-1.41,0.663l-0.237-0.428l1.563-0.736c-0.044-0.268-0.093-0.534-0.144-0.801l-1.38,0.709
				l-0.251-0.421l1.542-0.792c-0.055-0.266-0.116-0.529-0.177-0.794l-1.354,0.758l-0.268-0.411l1.508-0.842
				c-0.063-0.266-0.12-0.532-0.189-0.795l-1.337,0.809l-0.28-0.402l1.479-0.895c-0.073-0.263-0.146-0.525-0.224-0.785l-1.303,0.853
				l-0.295-0.392l1.454-0.951c-0.081-0.259-0.174-0.513-0.26-0.77l-1.271,0.897l-0.307-0.382l1.415-0.997
				c-0.092-0.258-0.184-0.513-0.278-0.767l-1.243,0.943l-0.32-0.371l1.377-1.044c-0.1-0.254-0.195-0.51-0.3-0.76l-1.212,0.987
				l-0.333-0.359l1.342-1.094c-0.107-0.25-0.222-0.495-0.334-0.742l-1.17,1.024l-0.346-0.347l1.305-1.142
				c-0.117-0.245-0.24-0.485-0.363-0.727l-1.133,1.063l-0.356-0.334l1.258-1.182c-0.126-0.242-0.247-0.486-0.379-0.725l-1.099,1.107
				l-0.369-0.322l1.216-1.224c-0.134-0.236-0.269-0.473-0.407-0.706l-1.055,1.14l-0.38-0.31l1.175-1.269
				c-0.142-0.231-0.291-0.456-0.438-0.684l-1.012,1.172l-0.39-0.296l1.127-1.305c-0.15-0.227-0.304-0.451-0.458-0.674l-0.971,1.208
				l-0.4-0.282l1.077-1.34c-0.157-0.221-0.311-0.447-0.474-0.665l-0.932,1.245l-0.41-0.268l1.03-1.378
				c-0.164-0.215-0.333-0.428-0.503-0.639l-0.881,1.268l-0.419-0.253l0.983-1.418c-0.172-0.209-0.353-0.408-0.53-0.614l-0.835,1.296
				l-0.428-0.238l0.931-1.443c-0.181-0.203-0.36-0.407-0.545-0.607l-0.791,1.328l-0.436-0.224l0.877-1.471
				c-0.188-0.198-0.372-0.397-0.563-0.591l-0.745,1.355l-0.444-0.208l0.827-1.505c-0.192-0.19-0.391-0.375-0.587-0.561l-0.694,1.374
				l-0.451-0.192l0.775-1.535c-0.2-0.182-0.405-0.36-0.609-0.539l-0.645,1.398l-0.457-0.176l0.718-1.555
				c-0.207-0.177-0.41-0.357-0.621-0.53l-0.599,1.426l-0.463-0.16l0.663-1.579c-0.213-0.169-0.426-0.338-0.642-0.503l-0.547,1.441
				l-0.468-0.144l0.609-1.608c-0.217-0.161-0.44-0.314-0.661-0.47l-0.495,1.455l-0.474-0.128l0.553-1.623
				c-0.224-0.153-0.449-0.304-0.676-0.453l-0.444,1.474l-0.478-0.111l0.494-1.638c-0.229-0.146-0.456-0.298-0.688-0.441
				l-0.396,1.496l-0.48-0.094l0.438-1.656c-0.234-0.138-0.469-0.273-0.706-0.406l-0.341,1.501l-0.484-0.078l0.383-1.678
				c-0.238-0.13-0.482-0.247-0.723-0.372l-0.287,1.51l-0.486-0.061l0.32-1.681c-0.243-0.121-0.485-0.244-0.731-0.361l-0.235,1.525
				l-0.488-0.044l0.262-1.69c-0.247-0.113-0.493-0.227-0.743-0.335l-0.183,1.531l-0.489-0.027l0.204-1.703
				c-0.251-0.104-0.504-0.2-0.758-0.298l-0.128,1.53l-0.489-0.01l0.143-1.707c-0.253-0.095-0.509-0.184-0.765-0.274l-0.074,1.534
				l-0.491,0.007l0.084-1.704c-0.259-0.086-0.514-0.18-0.773-0.261l-0.022,1.543l-0.489,0.024l0.024-1.705
				c-0.26-0.077-0.521-0.151-0.783-0.223l0.032,1.531l-0.488,0.042l-0.035-1.712c-0.262-0.068-0.526-0.122-0.791-0.184l0.086,1.524
				l-0.485,0.059l-0.097-1.697c-0.264-0.059-0.528-0.12-0.796-0.173l0.139,1.524l-0.483,0.076l-0.154-1.689
				c-0.266-0.049-0.533-0.099-0.802-0.143l0.192,1.512l-0.481,0.093l-0.214-1.687c-0.266-0.04-0.535-0.068-0.803-0.102l0.242,1.496
				l-0.479,0.109l-0.27-1.669c-0.27-0.03-0.538-0.059-0.81-0.083l0.295,1.488l-0.474,0.125l-0.327-1.652
				c-0.271-0.021-0.54-0.046-0.813-0.062l0.348,1.476l-0.469,0.142l-0.386-1.641c-0.27-0.012-0.54-0.015-0.811-0.021l0.395,1.453
				l-0.464,0.158l-0.44-1.624c-0.115-0.001-0.228-0.009-0.344-0.009C408.067,4.285,407.912,4.295,407.755,4.297"
            />
          </defs>
          <clipPath id="SVGIDB_407_">
            <use xlink:href="#SVGIDB_406_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDB_408_"
            cx="-155.9995"
            cy="571"
            r="1"
            gradientTransform="matrix(37.8716 0 0 37.8716 6316.1748 -21582.5137)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#272726" />
            <stop offset="0.6946" style="stop-color:#272726" />
            <stop offset="0.9079" style="stop-color:#575756" />
            <stop offset="1" style="stop-color:#2E2D2C" />
          </radialGradient>
          <rect
            x="370.35"
            y="4.285"
            :style="frontWheelClass"
            v-on:click="changeSeverity('frontWheel')"
            clip-path="url(#SVGIDB_407_)"
            fill="url(#SVGIDB_408_)"
            width="75.743"
            height="75.743"
          />
        </g>
        <g>
          <path
            fill="#D9D9D9"
            id="rearBumper"
            :style="rearBumperClass"
            v-on:click="changeSeverity('rearBumper')"
            d="M108.509,173.057c-17.826-2.796-35.409-6.116-55.034-9.563c-0.506-0.083-0.942-0.424-1.142-0.895
			c-0.282-0.611-0.141-1.329,0.33-1.8l2.447-2.447c-0.012-0.012-0.012-0.012-0.024-0.012l17.648-0.941l-34.119-26.695
			c-6.894-1.824-11.154-2.071-17.731-2.412c-1.211-1.177-2.423-2.365-3.658-3.589c-3.848-3.812-6.036-9.012-6.036-14.436V88.149
			c-7.659-8.73-8.318-19.543-7.424-35.461c0.2-3.612,2.106-7.118,4.894-9.565l6.424-5.977c2.059-1.8,4.624-2.953,7.342-3.283
			l15.189-1.847l4.059-0.494c-0.165,2.659-0.282,5.377-0.282,8.389c0,24.966,19.883,45.202,44.414,45.202
			c24.53,0,44.414-20.236,44.414-45.202c0-4.989-0.118-9.695-0.612-14.26l0.706-0.047l3.423-0.012l31.224-0.215l3.176-0.012
			l0.624,0.012c-0.245,3.076-0.501,5.027-0.685,7.986l-0.002-0.196l-8.303,2.313c-7.734,0.088-14.746,4.073-18.756,10.659
			c-12.895,21.177-21.546,37.951-33.938,63.357c-2.587,5.305-3.309,11.404-2.033,17.17l0.767,3.468l0.213-0.047
			c-1.756,1.293-3.065,2.889-4.112,4.911c-0.588,1.141-0.906,2.4-1.023,3.683c-0.318,3.67-1.047,11.965-1.341,15.224
			c-0.083,1.012-0.071,2.035,0.129,3.035c0.647,3.271,1.286,5.985,4.251,7.338c1.47,0.683,3.973,1.985,5.573,2.185"
          />
          <path
            fill="#D9D9D9"
            d="M106.156,130.058l-0.132,0.029c0.04-0.029,0.08-0.057,0.12-0.086L106.156,130.058z"
          />
          <path
            fill="#D9D9D9"
            d="M168.078,33.52h-0.011c0.003-0.052,0.006-0.105,0.009-0.157L168.078,33.52z"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_409_"
              d="M55.087,158.341l17.647-0.941l-34.119-26.696c-6.895-1.824-11.154-2.071-17.731-2.412
				C31.379,138.469,41.639,147.493,55.087,158.341"
            />
          </defs>
          <clipPath id="SVGIDB_410_">
            <use xlink:href="#SVGIDB_409_" overflow="visible" />
          </clipPath>

          <linearGradient
            id="SVGIDB_411_"
            gradientUnits="userSpaceOnUse"
            x1="-155.9995"
            y1="571"
            x2="-154.9995"
            y2="571"
            gradientTransform="matrix(0 30.0486 30.0486 0 -17110.957 4815.8711)"
          >
            <stop offset="0" style="stop-color:#41494A" />
            <stop offset="1" style="stop-color:#172225" />
          </linearGradient>
          <rect
            x="20.884"
            y="128.292"
            clip-path="url(#SVGIDB_410_)"
            fill="url(#SVGIDB_411_)"
            width="51.85"
            height="30.049"
          />
        </g>
        <g>
          <path
            fill="#A71916"
            d="M11.19,110.268v-6.294l39.014-1.883l-5.659,13.554c-1.894,4.529-6.236,7.6-11.13,7.8
			c-7.907,0.341-13.977-0.223-20.084-4.141C11.931,116.526,11.19,113.433,11.19,110.268"
          />
          <path
            fill="#E31715"
            d="M11.19,110.268v-6.294l5.859-0.283c3.942,6.412,5.553,11.73,6.024,19.342
			c-3.412-0.564-6.577-1.694-9.742-3.729C11.931,116.526,11.19,113.433,11.19,110.268"
          />
          <path
            fill="#2A0D0E"
            d="M48.941,102.976l-5.157,12.351c-1.775,4.245-5.859,7.109-10.405,7.295
			c-1.302,0.056-2.456,0.083-3.53,0.083c-6.787,0-11.409-1.153-15.883-3.974c-0.125-0.077-1.098-0.411-1.098-0.411
			c0.132,0.296,0.317,0.694,0.463,0.983c5.156,3.309,10.286,4.226,16.519,4.226c1.148,0,2.334-0.031,3.564-0.084
			c4.895-0.2,9.236-3.271,11.13-7.801l5.659-13.553l-39.014,1.882v0.809L48.941,102.976z"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_412_"
              d="M37.597,108.15l-19.426,0.81c-0.919,0.04-1.644,0.797-1.644,1.717v2.133
				c0,1.847,1.518,3.334,3.364,3.296l11.336,0.516c4.009-0.135,7.264-3.288,7.523-7.291c0.042-0.643-0.469-1.182-1.106-1.182
				C37.628,108.149,37.613,108.149,37.597,108.15"
            />
          </defs>
          <clipPath id="SVGIDB_413_">
            <use xlink:href="#SVGIDB_412_" overflow="visible" />
          </clipPath>

          <linearGradient
            id="SVGIDB_414_"
            gradientUnits="userSpaceOnUse"
            x1="-156"
            y1="571"
            x2="-155"
            y2="571"
            gradientTransform="matrix(-22.2256 0 0 22.2256 -3428.4294 -12578.4111)"
          >
            <stop offset="0" style="stop-color:#9F9F9F" />
            <stop offset="0.05" style="stop-color:#E4E4E3" />
            <stop offset="0.1" style="stop-color:#9F9F9F" />
            <stop offset="0.15" style="stop-color:#E4E4E3" />
            <stop offset="0.2" style="stop-color:#9F9F9F" />
            <stop offset="0.25" style="stop-color:#E4E4E3" />
            <stop offset="0.3" style="stop-color:#9F9F9F" />
            <stop offset="0.35" style="stop-color:#E4E4E3" />
            <stop offset="0.4" style="stop-color:#9F9F9F" />
            <stop offset="0.45" style="stop-color:#E4E4E3" />
            <stop offset="0.5" style="stop-color:#9F9F9F" />
            <stop offset="0.55" style="stop-color:#E4E4E3" />
            <stop offset="0.6" style="stop-color:#9F9F9F" />
            <stop offset="0.65" style="stop-color:#E4E4E3" />
            <stop offset="0.7" style="stop-color:#9F9F9F" />
            <stop offset="0.75" style="stop-color:#E4E4E3" />
            <stop offset="0.8" style="stop-color:#ADADAD" />
            <stop offset="0.85" style="stop-color:#E4E4E3" />
            <stop offset="0.9" style="stop-color:#ADADAD" />
            <stop offset="0.95" style="stop-color:#E4E4E3" />
            <stop offset="1" style="stop-color:#ADADAD" />
          </linearGradient>
          <rect
            x="16.527"
            y="108.149"
            clip-path="url(#SVGIDB_413_)"
            fill="url(#SVGIDB_414_)"
            width="22.265"
            height="8.473"
          />
        </g>
        <g>
          <path
            fill="#2A0D0E"
            d="M31.227,116.623l-11.336-0.517c-0.023,0-0.046,0-0.069,0c-1.815,0-3.295-1.472-3.295-3.296v-2.133
			c0-0.92,0.725-1.677,1.644-1.717l19.426-0.81c0.016-0.001,0.031-0.001,0.047-0.001c0.637,0,1.148,0.539,1.106,1.182
			C38.491,113.334,35.237,116.488,31.227,116.623 M31.22,117.8l0.047-0.002c4.635-0.155,8.357-3.763,8.658-8.391
			c0.04-0.629-0.183-1.252-0.614-1.711c-0.43-0.46-1.038-0.723-1.667-0.723H37.62l-0.072,0.002l-19.426,0.81
			c-1.555,0.068-2.772,1.338-2.772,2.892v2.133c0,2.466,2.006,4.473,4.472,4.473l0.047-0.001l11.305,0.516L31.22,117.8z"
          />
          <g>
            <g>
              <defs>
                <rect
                  id="SVGIDB_415_"
                  x="11.19"
                  y="102.091"
                  width="39.014"
                  height="21.438"
                />
              </defs>
              <clipPath id="SVGIDB_416_">
                <use xlink:href="#SVGIDB_415_" overflow="visible" />
              </clipPath>
              <g clip-path="url(#SVGIDB_416_)">
                <defs>
                  <path
                    id="SVGIDB_417_"
                    d="M11.19,110.268v-6.295l39.014-1.882l-5.659,13.553c-1.894,4.53-6.236,7.601-11.13,7.801
							c-7.907,0.341-13.977-0.224-20.084-4.142C11.931,116.527,11.19,113.432,11.19,110.268"
                  />
                </defs>
                <clipPath id="SVGIDB_418_">
                  <use xlink:href="#SVGIDB_417_" overflow="visible" />
                </clipPath>

                <linearGradient
                  id="SVGIDB_419_"
                  gradientUnits="userSpaceOnUse"
                  x1="-156"
                  y1="571.0703"
                  x2="-155"
                  y2="571.0703"
                  gradientTransform="matrix(-23.1893 -23.1893 -23.1893 23.1893 9664.8672 -16738.3887)"
                >
                  <stop offset="0" style="stop-color:#000000" />
                  <stop offset="0.4854" style="stop-color:#9F9F9F" />
                  <stop offset="0.8117" style="stop-color:#000000" />
                  <stop offset="1" style="stop-color:#000000" />
                </linearGradient>
                <polygon
                  clip-path="url(#SVGIDB_418_)"
                  fill="url(#SVGIDB_419_)"
                  points="30.697,143.293 0.342,112.938 30.697,82.584
						61.051,112.938 					"
                />
              </g>
            </g>
          </g>
          <path
            d="M20.672,128.086c6.23,0.323,10.953,0.587,17.987,2.448l0.064,0.031l34.49,26.986l-18.127,0.79l-0.339-0.274l17.508-0.819
			l-33.721-26.382c-6.978-1.843-11.027-2.053-17.456-2.387L20.672,128.086z"
          />
          <g opacity="0.5">
            <g>
              <defs>
                <rect
                  id="SVGIDB_420_"
                  x="49.81"
                  y="76.943"
                  width="10.815"
                  height="25.167"
                />
              </defs>
              <clipPath id="SVGIDB_421_">
                <use xlink:href="#SVGIDB_420_" overflow="visible" />
              </clipPath>
              <polygon
                clip-path="url(#SVGIDB_421_)"
                points="60.33,76.943 60.625,77.152 50.201,102.091 49.811,102.11 				"
              />
            </g>
          </g>
          <path
            fill="none"
            stroke="#000000"
            stroke-width="0.257"
            stroke-miterlimit="10"
            d="M100.275,102.721v-6.002
			c0-2.555-2.091-4.646-4.647-4.646H81.558c-2.555,0-4.646,2.091-4.646,4.646v6.002c0,2.556,2.091,4.647,4.646,4.647h14.071
			C98.185,107.368,100.275,105.277,100.275,102.721z"
          />
          <g>
            <g>
              <defs>
                <rect
                  id="SVGIDB_422_"
                  x="77.089"
                  y="98.136"
                  width="3.028"
                  height="3.168"
                />
              </defs>
              <clipPath id="SVGIDB_423_">
                <use xlink:href="#SVGIDB_422_" overflow="visible" />
              </clipPath>
              <g clip-path="url(#SVGIDB_423_)">
                <defs>
                  <path
                    id="SVGIDB_424_"
                    d="M80.117,99.724c0-0.875-1.294-1.588-2.889-1.588h-0.139v3.168h0.139
							C78.823,101.304,80.117,100.591,80.117,99.724"
                  />
                </defs>
                <clipPath id="SVGIDB_425_">
                  <use xlink:href="#SVGIDB_424_" overflow="visible" />
                </clipPath>

                <linearGradient
                  id="SVGIDB_426_"
                  gradientUnits="userSpaceOnUse"
                  x1="-155.9995"
                  y1="571"
                  x2="-154.9995"
                  y2="571"
                  gradientTransform="matrix(0 3.1675 -3.1675 0 1887.2334 592.2632)"
                >
                  <stop offset="0" style="stop-color:#B3B3B2" />
                  <stop offset="0.4812" style="stop-color:#FFFFFF" />
                  <stop offset="1" style="stop-color:#B3B3B2" />
                </linearGradient>
                <rect
                  x="77.089"
                  y="98.136"
                  clip-path="url(#SVGIDB_425_)"
                  fill="url(#SVGIDB_426_)"
                  width="3.028"
                  height="3.168"
                />
              </g>
            </g>
          </g>
          <path
            fill="#D9D9D9"
            id="frontBumper"
            :style="frontBumperClass"
            v-on:click="changeSeverity('frontBumper')"
            d="M346.157,30.305c1.589-1.373,2.165,2.351,2.646,3.92c8.779,28.601,14.112,63.724,4.114,78.456
			c-1.282,3.777-2.482,6.648-4.118,9.589c-2.306,4.118-5.553,7.659-9.436,10.353l13.537-6.489c2.894-1.729,16.971-2.37,20.336-2.699
			l3.965-0.389l0.494-0.047c2.259-0.188,4.481-0.388,6.693-0.6c74.063-7.118,121.419-25.813,118.019-64.297
			c-0.047-0.53-0.506-0.941-1.035-0.941h-3.765l-0.188-10.989l3.941-7.883c1.576-3.165-0.541-6.93-4.071-7.2l-41.308-3.248
			l-3.67-0.294l-0.695-0.022c1.235,4.553,2.188,9.259,2.188,14.236c0,24.966-20.39,45.202-45.556,45.202
			c-25.154,0-45.543-20.236-45.543-45.202c0-6.095,0.494-11.001,0.941-16.625l-0.623-0.011l-3.178,0.011l-12.168,0.061"
          />
          <g>
            <g>
              <defs>
                <rect
                  id="SVGIDB_427_"
                  x="464.559"
                  y="57.161"
                  width="37.955"
                  height="11.33"
                />
              </defs>
              <clipPath id="SVGIDB_428_">
                <use xlink:href="#SVGIDB_427_" overflow="visible" />
              </clipPath>
              <g clip-path="url(#SVGIDB_428_)">
                <defs>
                  <path
                    id="SVGIDB_429_"
                    d="M464.559,68.491v-5.353c9.813-0.636,16.59-1.012,22.272-4.542l10.777-1.435h3.765
							c0.529,0,0.988,0.412,1.035,0.941c0.047,0.541,0.094,1.082,0.105,1.623C492.655,64.867,480.595,67.561,464.559,68.491"
                  />
                </defs>
                <clipPath id="SVGIDB_430_">
                  <use xlink:href="#SVGIDB_429_" overflow="visible" />
                </clipPath>

                <linearGradient
                  id="SVGIDB_431_"
                  gradientUnits="userSpaceOnUse"
                  x1="-156.0005"
                  y1="571"
                  x2="-155.0005"
                  y2="571"
                  gradientTransform="matrix(-37.955 0 0 37.955 -5418.4731 -21609.5)"
                >
                  <stop offset="0" style="stop-color:#E3E3E3" />
                  <stop offset="1" style="stop-color:#FFFFFF" />
                </linearGradient>
                <rect
                  x="464.559"
                  y="57.161"
                  clip-path="url(#SVGIDB_430_)"
                  fill="url(#SVGIDB_431_)"
                  width="37.955"
                  height="11.33"
                />
              </g>
            </g>
          </g>
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_432_"
              d="M491.725,78.927l5.912-2.259L491.725,78.927z"
            />
          </defs>
          <clipPath id="SVGIDB_433_">
            <use xlink:href="#SVGIDB_432_" overflow="visible" />
          </clipPath>

          <linearGradient
            id="SVGIDB_434_"
            gradientUnits="userSpaceOnUse"
            x1="-156"
            y1="571"
            x2="-155"
            y2="571"
            gradientTransform="matrix(-5.911 0 0 5.911 -424.4778 -3297.3848)"
          >
            <stop offset="0" style="stop-color:#D2D2D2" />
            <stop offset="1" style="stop-color:#FFFFFF" />
          </linearGradient>
          <rect
            x="491.725"
            y="76.668"
            clip-path="url(#SVGIDB_433_)"
            fill="url(#SVGIDB_434_)"
            width="5.912"
            height="2.259"
          />
        </g>
        <g>
          <g>
            <g>
              <defs>
                <rect
                  id="SVGIDB_435_"
                  x="440.017"
                  y="76.668"
                  width="57.615"
                  height="26.777"
                />
              </defs>
              <clipPath id="SVGIDB_436_">
                <use xlink:href="#SVGIDB_435_" overflow="visible" />
              </clipPath>
              <path
                clip-path="url(#SVGIDB_436_)"
                fill="#666666"
                d="M440.017,103.445c0.118-0.377,0.388-0.812,0.813-1.271
					c6-6.529,11.918-11.812,20.754-17.342c3.165-1.976,6.624-3.435,10.259-4.341c7.424-1.871,16.331-2.894,25.79-3.824l-5.906,2.259
					c-8.06,0.8-15.225,1.53-21.554,3.106c-3.083,0.777-6.036,2.024-8.73,3.706c-7.518,4.706-12.565,9.201-17.66,14.766
					c-1.388,1.506-0.835,2.588,1.2,2.388C443.322,103.081,441.664,103.269,440.017,103.445"
              />
            </g>
          </g>
          <g>
            <g>
              <defs>
                <rect
                  id="SVGIDB_437_"
                  x="489.808"
                  y="76.668"
                  width="7.83"
                  height="10.683"
                />
              </defs>
              <clipPath id="SVGIDB_438_">
                <use xlink:href="#SVGIDB_437_" overflow="visible" />
              </clipPath>
              <g clip-path="url(#SVGIDB_438_)">
                <defs>
                  <path
                    id="SVGIDB_439_"
                    d="M491.455,83.48c0.341-1.471,0.329-2.659,0.27-4.553l5.907-2.259c0.059,2.011-0.271,3.529-0.718,5.059
							c-1.224,1.953-2.647,3.823-4.259,5.624h-2.848C490.561,86.162,491.137,84.868,491.455,83.48"
                  />
                </defs>
                <clipPath id="SVGIDB_440_">
                  <use xlink:href="#SVGIDB_439_" overflow="visible" />
                </clipPath>

                <linearGradient
                  id="SVGIDB_441_"
                  gradientUnits="userSpaceOnUse"
                  x1="-156"
                  y1="571"
                  x2="-155"
                  y2="571"
                  gradientTransform="matrix(-7.8308 0 0 7.8308 -723.9636 -4389.3657)"
                >
                  <stop offset="0" style="stop-color:#D2D2D2" />
                  <stop offset="1" style="stop-color:#FFFFFF" />
                </linearGradient>
                <rect
                  x="489.808"
                  y="76.668"
                  clip-path="url(#SVGIDB_440_)"
                  fill="url(#SVGIDB_441_)"
                  width="7.882"
                  height="10.683"
                />
              </g>
            </g>
          </g>
          <g>
            <g>
              <defs>
                <rect
                  id="SVGIDB_442_"
                  x="469.006"
                  y="36.96"
                  width="28.684"
                  height="21.378"
                />
              </defs>
              <clipPath id="SVGIDB_443_">
                <use xlink:href="#SVGIDB_442_" overflow="visible" />
              </clipPath>
              <path
                clip-path="url(#SVGIDB_443_)"
                fill="#7F8080"
                d="M492.949,39.171c0.224-1.141-0.694-2.212-1.871-2.212h4.707
					c1.176,0,2.094,1.071,1.87,2.212c-1.848,9.283-10.53,14.542-25.248,18.93c-1.436,0.436-2.624,0.247-3.4-0.388
					C482.937,53.396,491.161,48.172,492.949,39.171"
              />
            </g>
          </g>
          <g>
            <g>
              <defs>
                <rect
                  id="SVGIDB_444_"
                  x="358.93"
                  y="25.124"
                  width="98.994"
                  height="65.815"
                />
              </defs>
              <clipPath id="SVGIDB_445_">
                <use xlink:href="#SVGIDB_444_" overflow="visible" />
              </clipPath>
              <g clip-path="url(#SVGIDB_445_)">
                <defs>
                  <path
                    id="SVGIDB_446_"
                    d="M358.93,41.807c0-6.106,0.472-11.13,0.918-16.672l3.177-0.011l0.624,0.011
							c-0.447,5.624-0.941,10.53-0.941,16.625c0,24.966,20.389,45.202,45.543,45.202c25.166,0,45.556-20.236,45.556-45.202
							c0-4.977-0.952-9.683-2.188-14.236l0.695,0.023l3.67,0.294c1.13,4.436,1.941,9.001,1.941,13.813
							c0,27.213-22.236,49.285-49.674,49.285C380.825,90.939,358.93,69.032,358.93,41.807"
                  />
                </defs>
                <clipPath id="SVGIDB_447_">
                  <use xlink:href="#SVGIDB_446_" overflow="visible" />
                </clipPath>

                <linearGradient
                  id="SVGIDB_448_"
                  gradientUnits="userSpaceOnUse"
                  x1="-156"
                  y1="570.999"
                  x2="-155"
                  y2="570.999"
                  gradientTransform="matrix(0 65.8152 65.8152 0 -37172.0391 10292.2842)"
                >
                  <stop offset="0" style="stop-color:#000000" />
                  <stop offset="0.1255" style="stop-color:#000000" />
                  <stop offset="1" style="stop-color:#9D9D9C" />
                </linearGradient>
                <rect
                  x="358.93"
                  y="25.124"
                  clip-path="url(#SVGIDB_447_)"
                  fill="url(#SVGIDB_448_)"
                  width="98.994"
                  height="65.815"
                />
              </g>
            </g>
          </g>
          <path
            d="M444.962,102.717l0.039,0.35c-37.988,4.262-66.383,7.281-92.065,9.789l-0.034-0.351
			C378.582,109.998,406.975,106.979,444.962,102.717"
          />
          <polygon
            points="381.557,109.695 381.875,109.847 375.527,123.136 375.127,123.157 		"
          />
          <g opacity="0.5">
            <g>
              <defs>
                <rect
                  id="SVGIDB_449_"
                  x="436.471"
                  y="77.007"
                  width="19.485"
                  height="12.658"
                />
              </defs>
              <clipPath id="SVGIDB_450_">
                <use xlink:href="#SVGIDB_449_" overflow="visible" />
              </clipPath>
              <polygon
                clip-path="url(#SVGIDB_450_)"
                points="436.777,77.007 455.956,89.369 455.766,89.665 436.471,77.249 				"
              />
            </g>
          </g>
          <path
            d="M491.9,78.736l0.006,0.189c0.052,1.881,0.067,3.109-0.281,4.598c-0.625,2.676-2.235,5.214-4.535,7.146
			c-7.813,6.563-20.008,10.154-42.092,12.396c-1.063,0.109-1.798-0.123-2.062-0.648c-0.263-0.524-0.011-1.245,0.71-2.031
			c5.687-6.202,10.814-10.488,17.699-14.792c2.7-1.689,5.656-2.944,8.784-3.728c6.402-1.605,13.776-2.337,21.582-3.11L491.9,78.736z
			 M444.962,102.712c22.009-2.233,34.148-5.8,41.9-12.313c2.242-1.884,3.812-4.354,4.42-6.956c0.327-1.401,0.325-2.523,0.276-4.319
			c-7.724,0.766-15.017,1.497-21.342,3.084c-3.093,0.775-6.015,2.014-8.685,3.683c-6.856,4.287-11.962,8.555-17.626,14.733
			c-0.605,0.66-0.844,1.256-0.654,1.634C443.442,102.637,444.064,102.802,444.962,102.712"
          />
          <polygon
            points="490.023,87.139 492.844,87.139 492.527,87.492 489.891,87.492 		"
          />
          <path
            fill="#D9D9D9"
            id="frontDoor"
            :style="frontDoorClass"
            v-on:click="changeSeverity('frontDoor')"
            d="M347.961,35.372l-0.138,0.04v-0.01l-125.479,1.51l0.004,0.353h0.012
			c2.994,35.86,2.864,50.545-3.529,83.162l0.21,0.067l69.49-4.844l66.118-6.333l-0.001-0.131l0.108,0.01
			C359.878,95.359,357.398,67.524,347.961,35.372"
          />
          <path
            fill="#333333"
            d="M208.934,171.74c15.883,0,22.816,0.161,42.062-1.439c5.733-0.48,11.431-1.49,16.985-3.093
			c28.511-8.194,47.593-18.219,72.751-36.855c3.909-2.892,7.178-6.692,9.499-11.111c1.647-3.156,3.454-6.002,4.745-10.055
			c-45.959,4.786-87.389,8.106-135.779,10.848 M344.843,116.375c-1.869,3.557-4.538,6.681-7.725,9.038
			c-25.316,18.753-43.848,28.147-70.817,35.898c-5.03,1.452-10.35,2.42-15.808,2.877c-10.027,0.834-19.221,1.435-27.918,1.823
			l11.577-40.726c36.465-2.3,72.279-5.294,110.843-9.203C344.943,116.18,344.894,116.277,344.843,116.375"
          />
          <path
            fill="#1A1A1A"
            d="M219.872,145.305c0.816,6.374,4.415,10.885,7.196,10.81c0.903-0.024,4.634-1.863,4.634-1.863l-0.001-0.001
			c2.741-1.37,4.426-6.164,3.662-12.137c-0.669-5.231-2.948-9.318-5.498-10.481l4.546-9.293v-0.699l-12.106-0.349l-1.941,14.116
			l1.041-0.375C219.985,137.257,219.332,141.083,219.872,145.305"
          />
          <path
            fill="#262626"
            d="M309.067,110.684l9.478,22.277c0.444,1.044,1.662,1.535,2.706,1.09c1.044-0.444,1.535-1.662,1.091-2.706
			l-2.911-6.843l1.041-0.413l2.894,6.953c0.162,0.393,0.563,0.642,0.987,0.619c2.725-0.149,11.963,1.975,20.642-4.277
			c4.591-3.307,10.226-20.187,10.226-20.187l-40.307,3.535l0.419,1.005l-1.364-0.075l-1.103-2.593
			c-0.444-1.045-1.662-1.535-2.706-1.091C309.115,108.422,308.624,109.64,309.067,110.684"
          />
          <g opacity="0.4">
            <g>
              <defs>
                <rect
                  id="SVGIDB_451_"
                  x="208.421"
                  y="114.231"
                  width="143.604"
                  height="59.248"
                />
              </defs>
              <clipPath id="SVGIDB_452_">
                <use xlink:href="#SVGIDB_451_" overflow="visible" />
              </clipPath>
              <g clip-path="url(#SVGIDB_452_)">
                <defs>
                  <path
                    id="SVGIDB_453_"
                    d="M217.979,124.506c48.907-2.565,87.729-5.75,134.045-10.275c-1.283,3.776-2.483,6.647-4.118,9.589
							c-2.307,4.117-5.554,7.659-9.437,10.353c-24.989,17.366-43.943,26.707-72.263,34.343c-5.518,1.494-11.177,2.435-16.871,2.882
							c-15.555,1.214-27.816,1.859-40.915,2.081"
                  />
                </defs>
                <clipPath id="SVGIDB_454_">
                  <use xlink:href="#SVGIDB_453_" overflow="visible" />
                </clipPath>

                <linearGradient
                  id="SVGIDB_455_"
                  gradientUnits="userSpaceOnUse"
                  x1="-156"
                  y1="571"
                  x2="-155"
                  y2="571"
                  gradientTransform="matrix(-65.435 -65.435 -65.435 65.435 27460.3945 -47402.7461)"
                >
                  <stop offset="0" style="stop-color:#AFCACA" />
                  <stop offset="0.2552" style="stop-color:#4A7480" />
                  <stop offset="0.5356" style="stop-color:#AFCACA" />
                  <stop offset="0.7615" style="stop-color:#4A7480" />
                  <stop offset="1" style="stop-color:#AFCACA" />
                </linearGradient>
                <polygon
                  clip-path="url(#SVGIDB_454_)"
                  fill="url(#SVGIDB_455_)"
                  points="280.223,245.28 178.797,143.855 280.223,42.43
						381.648,143.855 					"
                />
              </g>
            </g>
          </g>
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_456_"
              d="M217.805,126.325c0,0,52.035-2.35,131.624-10.069c-0.965,2.572-1.911,4.628-3.063,6.702
				c-2.151,3.839-5.229,7.216-8.903,9.765c-25.61,17.797-44.377,26.718-71.717,34.09c-5.271,1.427-10.838,2.377-16.547,2.826
				c-19.333,1.508-24.737,2.073-40.26,2.075L217.805,126.325z M217.98,124.505l-9.559,48.974c15.776,0,21.799-0.59,40.915-2.081
				c5.694-0.446,11.354-1.388,16.871-2.882c28.319-7.636,47.273-16.977,72.263-34.343c3.883-2.694,7.13-6.236,9.436-10.353
				c1.636-2.941,2.836-5.812,4.119-9.589C278.078,121.454,217.98,124.505,217.98,124.505"
            />
          </defs>
          <clipPath id="SVGIDB_457_">
            <use xlink:href="#SVGIDB_456_" overflow="visible" />
          </clipPath>

          <linearGradient
            id="SVGIDB_458_"
            gradientUnits="userSpaceOnUse"
            x1="-156"
            y1="571"
            x2="-155"
            y2="571"
            gradientTransform="matrix(-65.435 -65.435 -65.435 65.435 27460.3945 -47402.7461)"
          >
            <stop offset="0" style="stop-color:#FFFFFF" />
            <stop offset="0.1088" style="stop-color:#B1B1B1" />
            <stop offset="0.2176" style="stop-color:#FFFFFF" />
            <stop offset="0.3598" style="stop-color:#B1B1B1" />
            <stop offset="0.4435" style="stop-color:#FFFFFF" />
            <stop offset="0.523" style="stop-color:#B1B1B1" />
            <stop offset="0.5983" style="stop-color:#FFFFFF" />
            <stop offset="0.6946" style="stop-color:#B1B1B1" />
            <stop offset="0.7615" style="stop-color:#FFFFFF" />
            <stop offset="0.8536" style="stop-color:#B1B1B1" />
            <stop offset="0.9247" style="stop-color:#FFFFFF" />
            <stop offset="1" style="stop-color:#B1B1B1" />
          </linearGradient>
          <polygon
            clip-path="url(#SVGIDB_457_)"
            fill="url(#SVGIDB_458_)"
            points="280.223,245.28 178.797,143.855 280.223,42.43
			381.648,143.855 		"
          />
        </g>
        <g>
          <path
            fill="none"
            stroke="#000000"
            stroke-width="0.367"
            stroke-miterlimit="10"
            d="M217.805,126.326
			c0,0,52.035-2.351,131.624-10.07c-0.965,2.572-1.91,4.628-3.063,6.701c-2.15,3.84-5.229,7.217-8.903,9.767
			c-25.61,17.797-44.376,26.717-71.717,34.089c-5.271,1.427-10.838,2.378-16.547,2.826c-19.364,1.511-24.754,2.075-40.334,2.075
			l0.069,0.026 M208.421,173.479L208.421,173.479c15.776,0,21.799-0.589,40.915-2.08c5.693-0.447,11.354-1.389,16.871-2.883
			c28.319-7.636,47.273-16.977,72.263-34.343c3.883-2.694,7.13-6.236,9.437-10.353c1.635-2.942,2.835-5.812,4.117-9.589
			c-73.944,7.224-134.043,10.275-134.043,10.275"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_459_"
              d="M217.805,126.325l-8.871,45.414c2.435-0.046,4.894-0.117,7.389-0.199l13.035-45.862
				C225.511,125.902,221.664,126.114,217.805,126.325"
            />
          </defs>
          <clipPath id="SVGIDB_460_">
            <use xlink:href="#SVGIDB_459_" overflow="visible" />
          </clipPath>

          <linearGradient
            id="SVGIDB_461_"
            gradientUnits="userSpaceOnUse"
            x1="-156"
            y1="571"
            x2="-155"
            y2="571"
            gradientTransform="matrix(0 46.0612 46.0612 0 -26081.7969 7311.23)"
          >
            <stop offset="0" style="stop-color:#1A1A1A" />
            <stop offset="0.2845" style="stop-color:#4E4D4D" />
            <stop offset="0.7866" style="stop-color:#1A1A1A" />
            <stop offset="1" style="stop-color:#1A1A1A" />
          </linearGradient>
          <rect
            x="208.934"
            y="125.678"
            clip-path="url(#SVGIDB_460_)"
            fill="url(#SVGIDB_461_)"
            width="20.424"
            height="46.061"
          />
        </g>
        <g>
          <path
            fill="#1A1A1A"
            d="M325.928,140.432l2.2-22.178c7.012-0.635,14.107-1.306,21.295-2c-0.964,2.577-1.905,4.624-3.059,6.707
			c-2.153,3.835-5.224,7.212-8.906,9.765C333.47,135.502,329.646,138.055,325.928,140.432"
          />
          <path
            fill="#F1F1F1"
            d="M340.487,123.94c0-2.7-2.188-4.888-4.889-4.888c-2.699,0-4.888,2.188-4.888,4.888
			c0,2.7,2.188,4.888,4.888,4.888C338.299,128.828,340.487,126.64,340.487,123.94"
          />
          <path
            fill="#F1F1F1"
            d="M320.071,119.548c-0.014-0.745,0.58-1.362,1.325-1.378c2.297-0.048,4.771-0.011,7.397,0.153
			c1.375,0.086,2.702,0.201,3.981,0.338c2.664,0.287,4.751,2.428,4.964,5.099c0.01,0.122,0.019,0.246,0.026,0.371
			c0.133,2.254-0.166,4.159-0.505,5.544c-0.081,0.332-0.186,0.654-0.317,0.968c-0.285,0.674-0.685,1.462-1.249,2.287
			c-0.007,0.01-0.014,0.021-0.021,0.031c-1.373,1.995-3.574,3.318-5.981,3.591c-0.906,0.103-1.927,0.097-3.026-0.114
			c-1.085-0.208-2.019-0.572-2.801-0.983c-1.694-0.893-2.806-2.589-3.024-4.493c-0.2-1.727-0.37-3.526-0.5-5.393
			C320.194,123.482,320.109,121.472,320.071,119.548"
          />
          <g>
            <g>
              <defs>
                <rect
                  id="SVGIDB_462_"
                  x="228.779"
                  y="102.131"
                  width="28.806"
                  height="4.954"
                />
              </defs>
              <clipPath id="SVGIDB_463_">
                <use xlink:href="#SVGIDB_462_" overflow="visible" />
              </clipPath>
              <g clip-path="url(#SVGIDB_463_)">
                <defs>
                  <path
                    id="SVGIDB_464_"
                    d="M231.596,102.131l24.292,0.19c1.202,0.01,1.935,1.089,1.626,2.4c-0.308,1.31-1.544,2.374-2.746,2.364
							l-24.293-0.19c-1.202-0.01-1.934-1.089-1.626-2.399C229.158,103.185,230.393,102.121,231.596,102.131"
                  />
                </defs>
                <clipPath id="SVGIDB_465_">
                  <use xlink:href="#SVGIDB_464_" overflow="visible" />
                </clipPath>

                <linearGradient
                  id="SVGIDB_466_"
                  gradientUnits="userSpaceOnUse"
                  x1="-156"
                  y1="571"
                  x2="-155"
                  y2="571"
                  gradientTransform="matrix(0 4.9548 4.9548 0 -2586.0002 875.0797)"
                >
                  <stop offset="0" style="stop-color:#7F8080" />
                  <stop offset="0.3891" style="stop-color:#FFFFFF" />
                  <stop offset="0.6527" style="stop-color:#FFFFFF" />
                  <stop offset="1" style="stop-color:#7F8080" />
                </linearGradient>
                <rect
                  x="228.541"
                  y="102.121"
                  clip-path="url(#SVGIDB_465_)"
                  fill="url(#SVGIDB_466_)"
                  width="29.282"
                  height="4.974"
                />
              </g>
              <g clip-path="url(#SVGIDB_463_)">
                <g>
                  <defs>
                    <rect
                      id="SVGIDB_467_"
                      x="228.779"
                      y="102.131"
                      width="28.806"
                      height="4.954"
                    />
                  </defs>
                  <clipPath id="SVGIDB_468_">
                    <use xlink:href="#SVGIDB_467_" overflow="visible" />
                  </clipPath>
                  <g clip-path="url(#SVGIDB_468_)">
                    <defs>
                      <path
                        id="SVGIDB_469_"
                        d="M231.596,102.131l24.292,0.19c1.202,0.01,1.935,1.089,1.626,2.4
									c-0.308,1.31-1.544,2.374-2.746,2.364l-24.293-0.19c-1.202-0.01-1.934-1.089-1.626-2.399
									C229.158,103.185,230.393,102.121,231.596,102.131"
                      />
                    </defs>
                    <clipPath id="SVGIDB_470_">
                      <use xlink:href="#SVGIDB_469_" overflow="visible" />
                    </clipPath>

                    <linearGradient
                      id="SVGIDB_471_"
                      gradientUnits="userSpaceOnUse"
                      x1="-156"
                      y1="571"
                      x2="-155"
                      y2="571"
                      gradientTransform="matrix(28.8062 0 0 -28.8062 4722.5508 16552.9512)"
                    >
                      <stop offset="0" style="stop-color:#C6C6C6" />
                      <stop offset="0.2" style="stop-color:#FFFFFF" />
                      <stop offset="0.8" style="stop-color:#FFFFFF" />
                      <stop offset="1" style="stop-color:#C6C6C6" />
                    </linearGradient>
                    <rect
                      x="228.541"
                      y="102.121"
                      clip-path="url(#SVGIDB_470_)"
                      fill="url(#SVGIDB_471_)"
                      width="29.282"
                      height="4.974"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
          <g>
            <g>
              <defs>
                <rect
                  id="SVGIDB_472_"
                  x="236.747"
                  y="98.571"
                  width="14.88"
                  height="3.718"
                />
              </defs>
              <clipPath id="SVGIDB_473_">
                <use xlink:href="#SVGIDB_472_" overflow="visible" />
              </clipPath>
              <path
                clip-path="url(#SVGIDB_473_)"
                fill="#CCCCCC"
                d="M251.618,102.289l-14.871-0.118c0.835-2.059,2.882-3.612,4.87-3.6
					l6.835,0.059C250.453,98.642,251.747,100.23,251.618,102.289"
              />
            </g>
          </g>
          <g>
            <g>
              <defs>
                <rect
                  id="SVGIDB_474_"
                  x="235.547"
                  y="106.936"
                  width="14.989"
                  height="4.001"
                />
              </defs>
              <clipPath id="SVGIDB_475_">
                <use xlink:href="#SVGIDB_474_" overflow="visible" />
              </clipPath>
              <path
                clip-path="url(#SVGIDB_475_)"
                fill="#CCCCCC"
                d="M235.583,106.936l14.954,0.118c-0.765,2.2-2.895,3.906-4.977,3.882
					l-6.836-0.047C236.641,110.866,235.312,109.136,235.583,106.936"
              />
            </g>
          </g>
          <g>
            <g>
              <defs>
                <rect
                  id="SVGIDB_476_"
                  x="320.071"
                  y="118.151"
                  width="17.727"
                  height="18.466"
                />
              </defs>
              <clipPath id="SVGIDB_477_">
                <use xlink:href="#SVGIDB_476_" overflow="visible" />
              </clipPath>
              <g clip-path="url(#SVGIDB_477_)">
                <defs>
                  <path
                    id="SVGIDB_478_"
                    d="M320.071,119.548c-0.015-0.745,0.58-1.362,1.326-1.378c2.297-0.048,4.77-0.01,7.396,0.153
							c1.375,0.086,2.703,0.201,3.981,0.339c2.664,0.286,4.752,2.427,4.964,5.098c0.01,0.122,0.019,0.246,0.025,0.372
							c0.135,2.253-0.165,4.158-0.504,5.543c-0.081,0.332-0.185,0.654-0.317,0.968c-0.284,0.674-0.685,1.462-1.248,2.287
							c-0.008,0.01-0.015,0.021-0.022,0.031c-1.373,1.995-3.574,3.318-5.98,3.591c-0.906,0.103-1.928,0.097-3.026-0.114
							c-1.084-0.208-2.019-0.572-2.8-0.983c-1.696-0.893-2.807-2.589-3.026-4.493c-0.199-1.727-0.369-3.526-0.5-5.393
							C320.195,123.482,320.109,121.473,320.071,119.548"
                  />
                </defs>
                <clipPath id="SVGIDB_479_">
                  <use xlink:href="#SVGIDB_478_" overflow="visible" />
                </clipPath>

                <linearGradient
                  id="SVGIDB_480_"
                  gradientUnits="userSpaceOnUse"
                  x1="-156.0005"
                  y1="571"
                  x2="-155.0005"
                  y2="571"
                  gradientTransform="matrix(17.7264 0 0 17.7264 3085.3933 -9994.4072)"
                >
                  <stop offset="0" style="stop-color:#C6C6C6" />
                  <stop offset="0.2427" style="stop-color:#FFFFFF" />
                  <stop offset="0.4017" style="stop-color:#FFFFFF" />
                  <stop offset="1" style="stop-color:#C6C6C6" />
                </linearGradient>
                <rect
                  x="320.057"
                  y="118.122"
                  clip-path="url(#SVGIDB_479_)"
                  fill="url(#SVGIDB_480_)"
                  width="17.843"
                  height="18.533"
                />
              </g>
              <g clip-path="url(#SVGIDB_477_)">
                <g>
                  <defs>
                    <rect
                      id="SVGIDB_481_"
                      x="320.071"
                      y="118.151"
                      width="17.727"
                      height="18.466"
                    />
                  </defs>
                  <clipPath id="SVGIDB_482_">
                    <use xlink:href="#SVGIDB_481_" overflow="visible" />
                  </clipPath>
                  <g clip-path="url(#SVGIDB_482_)">
                    <defs>
                      <path
                        id="SVGIDB_483_"
                        d="M320.071,119.548c-0.015-0.745,0.58-1.362,1.326-1.378c2.297-0.048,4.77-0.01,7.396,0.153
									c1.375,0.086,2.703,0.201,3.981,0.339c2.664,0.286,4.752,2.427,4.964,5.098c0.01,0.122,0.019,0.246,0.025,0.372
									c0.135,2.253-0.165,4.158-0.504,5.543c-0.081,0.332-0.185,0.654-0.317,0.968c-0.284,0.674-0.685,1.462-1.248,2.287
									c-0.008,0.01-0.015,0.021-0.022,0.031c-1.373,1.995-3.574,3.318-5.98,3.591c-0.906,0.103-1.928,0.097-3.026-0.114
									c-1.084-0.208-2.019-0.572-2.8-0.983c-1.696-0.893-2.807-2.589-3.026-4.493c-0.199-1.727-0.369-3.526-0.5-5.393
									C320.195,123.482,320.109,121.473,320.071,119.548"
                      />
                    </defs>
                    <clipPath id="SVGIDB_484_">
                      <use xlink:href="#SVGIDB_483_" overflow="visible" />
                    </clipPath>

                    <linearGradient
                      id="SVGIDB_485_"
                      gradientUnits="userSpaceOnUse"
                      x1="-156"
                      y1="570.998"
                      x2="-155"
                      y2="570.998"
                      gradientTransform="matrix(0 18.4665 -18.4665 0 10873.3184 2998.9341)"
                    >
                      <stop offset="0" style="stop-color:#C6C6C6" />
                      <stop offset="0.2845" style="stop-color:#FFFFFF" />
                      <stop offset="1" style="stop-color:#C6C6C6" />
                    </linearGradient>
                    <rect
                      x="320.057"
                      y="118.122"
                      clip-path="url(#SVGIDB_484_)"
                      fill="url(#SVGIDB_485_)"
                      width="17.843"
                      height="18.533"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
          <g>
            <g>
              <defs>
                <rect
                  id="SVGIDB_486_"
                  x="334.552"
                  y="119.055"
                  width="5.931"
                  height="9.376"
                />
              </defs>
              <clipPath id="SVGIDB_487_">
                <use xlink:href="#SVGIDB_486_" overflow="visible" />
              </clipPath>
              <g clip-path="url(#SVGIDB_487_)">
                <defs>
                  <path
                    id="SVGIDB_488_"
                    d="M334.552,119.16c0.341-0.07,0.684-0.105,1.047-0.105c2.695,0,4.884,2.188,4.884,4.882
							c0,2.024-1.225,3.753-2.966,4.494c0.212-1.199,0.342-2.658,0.247-4.294c-0.012-0.129-0.012-0.259-0.022-0.376
							C337.576,121.725,336.317,119.996,334.552,119.16"
                  />
                </defs>
                <clipPath id="SVGIDB_489_">
                  <use xlink:href="#SVGIDB_488_" overflow="visible" />
                </clipPath>

                <linearGradient
                  id="SVGIDB_490_"
                  gradientUnits="userSpaceOnUse"
                  x1="-155.9995"
                  y1="571"
                  x2="-154.9995"
                  y2="571"
                  gradientTransform="matrix(0 9.3769 9.3769 0 -5016.7129 1581.8628)"
                >
                  <stop offset="0" style="stop-color:#C6C6C6" />
                  <stop offset="0.2427" style="stop-color:#FFFFFF" />
                  <stop offset="0.4017" style="stop-color:#FFFFFF" />
                  <stop offset="1" style="stop-color:#C6C6C6" />
                </linearGradient>
                <rect
                  x="334.552"
                  y="119.055"
                  clip-path="url(#SVGIDB_489_)"
                  fill="url(#SVGIDB_490_)"
                  width="5.931"
                  height="9.376"
                />
              </g>
            </g>
          </g>
          <polyline
            points="222.298,36.9 347.905,35.389 347.909,35.742 222.302,37.253 		"
          />
          <path
            d="M348.248,35.675c10.823,36.868,12.359,67.745,3.914,78.664l-0.279-0.216c8.379-10.832,6.818-41.585-3.974-78.348
			L348.248,35.675z"
          />
          <path
            d="M222.659,37.141c3.004,35.96,2.072,54.753-4.333,87.433l-9.581,49.065h-0.521l9.755-49.133
			c6.398-32.642,7.329-51.415,4.328-87.335L222.659,37.141z"
          />
          <path
            fill="#D9D9D9"
            id="backDoor"
            :style="backDoorClass"
            v-on:click="changeSeverity('backDoor')"
            d="M159.03,37.93l63.314-0.775c2.989,35.848,2.054,54.617-4.337,87.225l0.153,0.03
			c-30.73,1.667-63.323,2.959-99.639,3.896c-2.659,0.071-5.33,0.447-7.871,1.259c-2.132,0.676-3.832,1.511-5.252,2.533l-0.755-3.411
			c-1.259-5.689-0.547-11.705,2.006-16.939c12.387-25.396,21.034-42.163,33.922-63.328C144.518,41.938,151.417,38.017,159.03,37.93"
          />
          <path
            fill="#333333"
            d="M208.803,173.53l-9.471-0.863c-28.351,0-54.519-2.49-89.858-7.256c-1.611-0.215-3.21-0.631-4.691-1.364
			c-2.985-1.452-4.548-3.383-5.2-6.893c-0.201-1.074-0.213-2.172-0.13-3.258c0.296-3.497,1.03-12.399,1.35-16.338
			c0.119-1.376,0.438-2.727,1.031-3.952c1.919-3.952,4.655-6.426,9.547-8.08c2.558-0.872,5.247-1.275,7.924-1.351
			c37.308-1.027,68.073-2.294,99.564-4.136 M199.33,166.533h-0.002c-22.305,0-43.372-1.638-66.124-4.295l4.065-32.461
			c29.981-0.955,53.145-2.194,80.572-3.808l-7.638,40.321C204.918,166.452,204.383,166.532,199.33,166.533 M105.526,154.417
			c0.297-3.502,1.032-12.415,1.35-16.329c0.061-0.709,0.212-1.33,0.434-1.789c1.077-2.217,2.406-3.739,6.024-4.963
			c1.82-0.619,3.886-0.966,6.137-1.03c4.798-0.131,9.535-0.271,14.227-0.416l-3.998,31.93c-6.319-0.761-12.768-1.592-19.426-2.49
			c-1.099-0.146-2.041-0.411-2.838-0.805c-1.245-0.606-1.566-0.909-1.864-2.51C105.493,155.592,105.479,155.037,105.526,154.417"
          />
          <g opacity="0.4">
            <g>
              <defs>
                <rect
                  id="SVGIDB_491_"
                  x="98.763"
                  y="124.489"
                  width="119.252"
                  height="49.304"
                />
              </defs>
              <clipPath id="SVGIDB_492_">
                <use xlink:href="#SVGIDB_491_" overflow="visible" />
              </clipPath>
              <g clip-path="url(#SVGIDB_492_)">
                <defs>
                  <path
                    id="SVGIDB_493_"
                    d="M208.456,173.602c-34.196,0.931-58.616-1.564-99.692-6.761c-1.6-0.2-3.188-0.589-4.659-1.271
							c-2.965-1.353-4.518-3.153-5.165-6.424c-0.2-1-0.212-2.024-0.129-3.035c0.294-3.259,1.023-11.554,1.341-15.225
							c0.118-1.282,0.435-2.541,1.024-3.682c1.906-3.683,4.623-5.989,9.482-7.53c2.542-0.812,5.212-1.188,7.871-1.259
							c46.399-1.198,61.371-1.528,99.486-3.926"
                  />
                </defs>
                <clipPath id="SVGIDB_494_">
                  <use xlink:href="#SVGIDB_493_" overflow="visible" />
                </clipPath>

                <linearGradient
                  id="SVGIDB_495_"
                  gradientUnits="userSpaceOnUse"
                  x1="-156"
                  y1="571.0459"
                  x2="-155"
                  y2="571.0459"
                  gradientTransform="matrix(-72.3584 -72.3584 -72.3584 72.3584 30227.5918 -52421.3086)"
                >
                  <stop offset="0" style="stop-color:#AFCACA" />
                  <stop offset="0.2552" style="stop-color:#4A7480" />
                  <stop offset="0.5356" style="stop-color:#AFCACA" />
                  <stop offset="0.7615" style="stop-color:#4A7480" />
                  <stop offset="1" style="stop-color:#AFCACA" />
                </linearGradient>
                <polygon
                  clip-path="url(#SVGIDB_494_)"
                  fill="url(#SVGIDB_495_)"
                  points="158.372,234.177 73.706,149.511 158.372,64.846
						243.037,149.511 					"
                />
              </g>
            </g>
          </g>
        </g>
        <g>
          <defs>
            <rect
              id="SVGIDB_496_"
              x="122.313"
              y="128.042"
              transform="matrix(-0.9922 -0.1244 0.1244 -0.9922 228.7408 310.8941)"
              width="3.528"
              height="40.525"
            />
          </defs>
          <clipPath id="SVGIDB_497_">
            <use xlink:href="#SVGIDB_496_" overflow="visible" />
          </clipPath>

          <linearGradient
            id="SVGIDB_498_"
            gradientUnits="userSpaceOnUse"
            x1="-156"
            y1="571"
            x2="-155"
            y2="571"
            gradientTransform="matrix(0 40.6501 40.6501 0 -23087.1152 6469.4067)"
          >
            <stop offset="0" style="stop-color:#1A1A1A" />
            <stop offset="0.2845" style="stop-color:#4E4D4D" />
            <stop offset="0.7866" style="stop-color:#1A1A1A" />
            <stop offset="1" style="stop-color:#1A1A1A" />
          </linearGradient>
          <rect
            x="119.809"
            y="127.979"
            clip-path="url(#SVGIDB_497_)"
            fill="url(#SVGIDB_498_)"
            width="8.537"
            height="40.651"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_499_"
              d="M118.53,128.415c-2.66,0.07-5.33,0.447-7.872,1.259c-4.859,1.541-7.577,3.847-9.482,7.53
				c-0.589,1.141-0.906,2.4-1.024,3.682c-0.318,3.671-1.047,11.966-1.341,15.225c-0.082,1.011-0.071,2.035,0.129,3.035
				c0.647,3.271,2.2,5.071,5.165,6.424c1.471,0.682,3.059,1.071,4.659,1.271c35.102,4.441,61.095,6.761,89.256,6.76h10.437
				l0.513-1.878c0,0-8.215,0.165-10.953,0.114c-22.318-0.412-57.024-2.697-89.034-6.748c-1.563-0.195-2.953-0.572-4.145-1.125
				c-2.521-1.15-3.65-2.549-4.167-5.164c-0.148-0.737-0.181-1.57-0.103-2.531c0.295-3.26,1.025-11.558,1.341-15.221
				c0.105-1.143,0.386-2.164,0.834-3.033c1.749-3.381,4.197-5.311,8.453-6.66c2.219-0.709,4.703-1.105,7.379-1.176l99.265-3.87
				l0.175-1.82C218.015,124.489,210.146,126.05,118.53,128.415"
            />
          </defs>
          <clipPath id="SVGIDB_500_">
            <use xlink:href="#SVGIDB_499_" overflow="visible" />
          </clipPath>

          <linearGradient
            id="SVGIDB_501_"
            gradientUnits="userSpaceOnUse"
            x1="-156"
            y1="571.043"
            x2="-155"
            y2="571.043"
            gradientTransform="matrix(-72.3584 -72.3584 -72.3584 72.3584 30227.5918 -52421.3086)"
          >
            <stop offset="0" style="stop-color:#FFFFFF" />
            <stop offset="0.1088" style="stop-color:#B1B1B1" />
            <stop offset="0.2176" style="stop-color:#FFFFFF" />
            <stop offset="0.3598" style="stop-color:#B1B1B1" />
            <stop offset="0.4435" style="stop-color:#FFFFFF" />
            <stop offset="0.523" style="stop-color:#B1B1B1" />
            <stop offset="0.5983" style="stop-color:#FFFFFF" />
            <stop offset="0.6946" style="stop-color:#B1B1B1" />
            <stop offset="0.7615" style="stop-color:#FFFFFF" />
            <stop offset="0.8536" style="stop-color:#B1B1B1" />
            <stop offset="0.9247" style="stop-color:#FFFFFF" />
            <stop offset="1" style="stop-color:#B1B1B1" />
          </linearGradient>
          <polygon
            clip-path="url(#SVGIDB_500_)"
            fill="url(#SVGIDB_501_)"
            points="158.372,233.245 74.172,149.045 158.372,64.846
			242.571,149.045 		"
          />
        </g>
        <g>
          <path
            fill="none"
            stroke="#000000"
            stroke-width="0.367"
            stroke-miterlimit="10"
            d="M218.015,124.489
			c0,0-7.869,1.561-99.486,3.926c-2.659,0.07-5.329,0.447-7.871,1.259c-4.859,1.541-7.577,3.847-9.483,7.53
			c-0.588,1.141-0.905,2.4-1.023,3.682c-0.318,3.671-1.047,11.965-1.341,15.224c-0.083,1.012-0.071,2.036,0.129,3.036
			c0.647,3.271,2.2,5.071,5.165,6.424c1.471,0.682,3.059,1.07,4.659,1.27c35.102,4.442,61.095,6.762,89.255,6.761h10.437
			l0.513-1.878c0,0-8.214,0.164-10.952,0.114c-22.319-0.412-57.024-2.698-89.034-6.748c-1.563-0.195-2.954-0.572-4.145-1.125
			c-2.521-1.15-3.65-2.549-4.168-5.164c-0.147-0.737-0.18-1.57-0.102-2.531c0.294-3.26,1.024-11.558,1.341-15.222
			c0.105-1.143,0.386-2.164,0.834-3.032c1.75-3.381,4.198-5.311,8.452-6.66c2.22-0.709,4.703-1.105,7.38-1.176l99.265-3.87"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDB_502_"
              d="M206.64,126.898l-4.848,44.92c2.366-0.012,4.754-0.035,7.178-0.095l8.87-45.414
				C214.122,126.509,210.381,126.71,206.64,126.898"
            />
          </defs>
          <clipPath id="SVGIDB_503_">
            <use xlink:href="#SVGIDB_502_" overflow="visible" />
          </clipPath>

          <linearGradient
            id="SVGIDB_504_"
            gradientUnits="userSpaceOnUse"
            x1="-155.9995"
            y1="571"
            x2="-154.9995"
            y2="571"
            gradientTransform="matrix(0 45.5082 45.5082 0 -25775.3867 7225.5859)"
          >
            <stop offset="0" style="stop-color:#1A1A1A" />
            <stop offset="0.2845" style="stop-color:#4E4D4D" />
            <stop offset="0.7866" style="stop-color:#1A1A1A" />
            <stop offset="1" style="stop-color:#1A1A1A" />
          </linearGradient>
          <rect
            x="201.792"
            y="126.309"
            clip-path="url(#SVGIDB_503_)"
            fill="url(#SVGIDB_504_)"
            width="16.048"
            height="45.509"
          />
        </g>
        <g>
          <g>
            <g>
              <defs>
                <rect
                  id="SVGIDB_505_"
                  x="128.542"
                  y="104.437"
                  width="14.88"
                  height="3.718"
                />
              </defs>
              <clipPath id="SVGIDB_506_">
                <use xlink:href="#SVGIDB_505_" overflow="visible" />
              </clipPath>
              <path
                clip-path="url(#SVGIDB_506_)"
                fill="#CCCCCC"
                d="M143.413,108.155l-14.871-0.118c0.835-2.059,2.882-3.612,4.87-3.6
					l6.836,0.059C142.248,104.508,143.542,106.096,143.413,108.155"
              />
            </g>
          </g>
          <g>
            <g>
              <defs>
                <rect
                  id="SVGIDB_507_"
                  x="127.342"
                  y="112.802"
                  width="14.989"
                  height="4.001"
                />
              </defs>
              <clipPath id="SVGIDB_508_">
                <use xlink:href="#SVGIDB_507_" overflow="visible" />
              </clipPath>
              <path
                clip-path="url(#SVGIDB_508_)"
                fill="#CCCCCC"
                d="M127.377,112.803l14.954,0.118c-0.765,2.2-2.895,3.906-4.977,3.882
					l-6.836-0.047C128.436,116.732,127.106,115.002,127.377,112.803"
              />
            </g>
          </g>
          <g>
            <g>
              <defs>
                <rect
                  id="SVGIDB_509_"
                  x="120.574"
                  y="107.997"
                  width="28.806"
                  height="4.955"
                />
              </defs>
              <clipPath id="SVGIDB_510_">
                <use xlink:href="#SVGIDB_509_" overflow="visible" />
              </clipPath>
              <g clip-path="url(#SVGIDB_510_)">
                <defs>
                  <path
                    id="SVGIDB_511_"
                    d="M123.39,107.997l24.294,0.191c1.202,0.009,1.934,1.089,1.626,2.399
							c-0.309,1.31-1.544,2.374-2.747,2.365l-24.293-0.191c-1.202-0.009-1.934-1.089-1.626-2.399S122.188,107.987,123.39,107.997"
                  />
                </defs>
                <clipPath id="SVGIDB_512_">
                  <use xlink:href="#SVGIDB_511_" overflow="visible" />
                </clipPath>

                <linearGradient
                  id="SVGIDB_513_"
                  gradientUnits="userSpaceOnUse"
                  x1="-156"
                  y1="571"
                  x2="-155"
                  y2="571"
                  gradientTransform="matrix(0 4.9549 4.9549 0 -2694.2551 880.9601)"
                >
                  <stop offset="0" style="stop-color:#7F8080" />
                  <stop offset="0.3891" style="stop-color:#FFFFFF" />
                  <stop offset="0.6527" style="stop-color:#FFFFFF" />
                  <stop offset="1" style="stop-color:#7F8080" />
                </linearGradient>
                <rect
                  x="120.336"
                  y="107.987"
                  clip-path="url(#SVGIDB_512_)"
                  fill="url(#SVGIDB_513_)"
                  width="29.282"
                  height="4.974"
                />
              </g>
            </g>
          </g>
          <g>
            <g>
              <defs>
                <rect
                  id="SVGIDB_514_"
                  x="120.574"
                  y="107.997"
                  width="28.806"
                  height="4.955"
                />
              </defs>
              <clipPath id="SVGIDB_515_">
                <use xlink:href="#SVGIDB_514_" overflow="visible" />
              </clipPath>
              <g clip-path="url(#SVGIDB_515_)">
                <defs>
                  <path
                    id="SVGIDB_516_"
                    d="M123.39,107.997l24.294,0.191c1.202,0.009,1.934,1.089,1.626,2.399
							c-0.309,1.31-1.544,2.374-2.747,2.365l-24.293-0.191c-1.202-0.009-1.934-1.089-1.626-2.399S122.188,107.987,123.39,107.997"
                  />
                </defs>
                <clipPath id="SVGIDB_517_">
                  <use xlink:href="#SVGIDB_516_" overflow="visible" />
                </clipPath>

                <linearGradient
                  id="SVGIDB_518_"
                  gradientUnits="userSpaceOnUse"
                  x1="-156"
                  y1="571"
                  x2="-155"
                  y2="571"
                  gradientTransform="matrix(28.8062 0 0 -28.8062 4614.3403 16558.834)"
                >
                  <stop offset="0" style="stop-color:#C6C6C6" />
                  <stop offset="0.2" style="stop-color:#FFFFFF" />
                  <stop offset="0.8" style="stop-color:#FFFFFF" />
                  <stop offset="1" style="stop-color:#C6C6C6" />
                </linearGradient>
                <rect
                  x="120.336"
                  y="107.987"
                  clip-path="url(#SVGIDB_517_)"
                  fill="url(#SVGIDB_518_)"
                  width="29.282"
                  height="4.974"
                />
              </g>
            </g>
          </g>
          <path
            d="M222.691,36.801l0.004,0.353l-63.656,0.885c-7.612,0.086-14.513,4.008-18.459,10.49
			c-12.888,21.165-21.535,37.932-33.922,63.328c-2.553,5.233-3.266,11.249-2.006,16.938l0.767,3.468l-0.345,0.076l-0.767-3.468
			c-1.275-5.766-0.554-11.864,2.034-17.169c12.391-25.406,21.043-42.18,33.937-63.357c4.01-6.586,11.022-10.571,18.757-10.659
			L222.691,36.801z"
          />
          <path
            d="M222.695,37.124c3.004,35.96,2.072,54.753-4.333,87.433l-9.558,48.973l-0.347-0.068l9.558-48.973
			c6.398-32.642,7.329-51.415,4.328-87.335L222.695,37.124z"
          />
          <path
            d="M363.29,125.872c0.034-0.024,0.07-0.047,0.105-0.071c2.895-1.729,6.153-2.788,9.519-3.118l3.965-0.388
			c-1.694,1.036-3.365,2.047-5.024,3.036C369.572,125.26,366.925,125.472,363.29,125.872"
          />
          <g opacity="0.4">
            <g>
              <defs>
                <rect
                  id="SVGIDB_519_"
                  x="284.822"
                  y="122.295"
                  width="92.057"
                  height="43.768"
                />
              </defs>
              <clipPath id="SVGIDB_520_">
                <use xlink:href="#SVGIDB_519_" overflow="visible" />
              </clipPath>
              <g clip-path="url(#SVGIDB_520_)">
                <defs>
                  <path
                    id="SVGIDB_521_"
                    d="M285.909,165.062c29.59-12.483,52.226-24.107,77.487-39.261c2.894-1.73,6.152-2.788,9.518-3.118
							l3.965-0.388c-35.614,21.754-63.333,35.437-89.593,43.685l-1.153,0.07C284.474,166.144,284.379,165.697,285.909,165.062"
                  />
                </defs>
                <clipPath id="SVGIDB_522_">
                  <use xlink:href="#SVGIDB_521_" overflow="visible" />
                </clipPath>

                <linearGradient
                  id="SVGIDB_523_"
                  gradientUnits="userSpaceOnUse"
                  x1="-156.001"
                  y1="571"
                  x2="-155.001"
                  y2="571"
                  gradientTransform="matrix(-92.0564 0 0 92.0564 -13983.9287 -52420.0313)"
                >
                  <stop offset="0" style="stop-color:#AFCACA" />
                  <stop offset="0.2552" style="stop-color:#4A7480" />
                  <stop offset="0.5356" style="stop-color:#AFCACA" />
                  <stop offset="0.7615" style="stop-color:#4A7480" />
                  <stop offset="1" style="stop-color:#AFCACA" />
                </linearGradient>
                <rect
                  x="284.379"
                  y="122.295"
                  clip-path="url(#SVGIDB_522_)"
                  fill="url(#SVGIDB_523_)"
                  width="92.5"
                  height="43.849"
                />
              </g>
            </g>
          </g>
          <path
            d="M376.879,122.295l-0.487,0.297l-3.461,0.267c-3.338,0.327-6.604,1.397-9.444,3.094
			c-26.224,15.732-48.68,27.11-77.509,39.272c-0.842,0.349-0.963,0.548-0.978,0.579c0.004,0.008,0.151,0.082,0.717,0.082
			c0.116,0,1.888-0.008,1.888-0.008l-1.032,0.325l-0.429,0.023c-1.24,0.065-1.444-0.154-1.49-0.356
			c-0.046-0.203,0.046-0.497,1.188-0.971c28.811-12.154,51.254-23.526,77.463-39.249c2.885-1.724,6.201-2.81,9.592-3.143
			L376.879,122.295z"
          />
        </g>
      </g>
    </svg>
  </div>
</template>
<script>
export default {
  props: {
    front: Number,
    frontDoor: Number,
    rearDoor: Number,
    rear: Number,
    frontWheel: Number,
    rearWheel: Number
  },

  data() {
    return {
      left: {
        frontDoor: 0,
        frontBumper: 0,
        backDoor: 0,
        rearBumper: 0,
        rearWheel: 0,
        frontWheel: 0
      }
    };
  },

  computed: {
    frontWheelClass() {
      return this.getSeverityColour(this.left.frontWheel, {});
    },

    rearWheelClass() {
      return this.getSeverityColour(this.left.rearWheel, {});
    },

    frontDoorClass() {
      return this.getSeverityColour(this.left.frontDoor);
    },

    frontBumperClass() {
      return this.getSeverityColour(this.left.frontBumper);
    },

    rearBumperClass() {
      return this.getSeverityColour(this.left.rearBumper);
    },

    backDoorClass() {
      return this.getSeverityColour(this.left.backDoor);
    }
  },

  methods: {
    changeSeverity(section) {
      if (this.left[section] == 3) {
        this.left[section] = 0;
      } else {
        this.left[section] = this.left[section] + 1;
      }

      this.$emit('updated', this.left);
    },

    getSeverityColour(severity, defaultColour = '#D9D9D9', opacity = null) {
      const colour = this.getColour(severity, defaultColour);

      if (opacity) {
        return {
          opacity,
          ...colour
        };
      }

      return colour;
    },

    getColour(severity, defaultColour = '#D9D9D9') {
      switch (severity) {
        case 1:
          return {
            fill: '#FFCA28'
          };

        case 2:
          return {
            fill: '#f0ad4e'
          };

        case 3:
          return {
            fill: '#d9534f'
          };

        default:
          return typeof defaultColour === 'string'
            ? {
                fill: defaultColour
              }
            : defaultColour;
      }
    }
  },

  watch: {
    front: {
      handler(value) {
        if (value) {
          this.left.frontBumper = value;
        }
      },
      immediate: true,
      deep: true
    },
    frontDoor: {
      handler(value) {
        if (value) {
          this.left.frontDoor = value;
        }
      },
      immediate: true,
      deep: true
    },
    rearDoor: {
      handler(value) {
        if (value) {
          this.left.backDoor = value;
        }
      },
      immediate: true,
      deep: true
    },
    rear: {
      handler(value) {
        if (value) {
          this.left.rearBumper = value;
        }
      },
      immediate: true,
      deep: true
    },
    frontWheel: {
      handler(value) {
        if (value) {
          this.left.frontWheel = value;
        }
      },
      immediate: true,
      deep: true
    },
    rearWheel: {
      handler(value) {
        if (value) {
          this.left.rearWheel = value;
        }
      },
      immediate: true,
      deep: true
    }
  }
};
</script>
